import React, { useRef,useState,useContext } from "react";
import Select from "react-select";
import {Decimal} from 'decimal.js';
import moment from "moment";
import "./www/pos-restaurante.css"
// import { MDBIcon, MDBTabs, MDBTabsLink, MDBTabsContent, MDBTabsPane, MDBInput, MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import CloseIcon from '@mui/icons-material/Close';
import {STATES_FAC_FACTURA} from "../Componentes/States"
import DeleteIcon from "@mui/icons-material/Delete";
import ReactToPrint from "react-to-print-advanced";
import { DateRange,Calendar  } from 'react-date-range';
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import {Button} from '@mui/material';
import AddBoxIcon from "@mui/icons-material/AddBox";
import SearchIcon from "@mui/icons-material/Search";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { COLUMNS_BODEGAS,COLUMNS_LISTA_FACTURA,COLUMNS_DC_COMPRA_DETALLE,COLUMNS_LISTA_CLIENTE,COLUMNS_LISTA_ITEMS, COLUMNS_FAC_FACTURA_DETALLE_COPIA} from "../Componentes/DatatableColumns";
import { MaterialReactTable} from "material-react-table";
import ImageUploading from "react-images-uploading";
import {Label,Row,Col, Container} from "reactstrap";
import StoreContext from "./../Componentes/Store/Context";
// import Select from "react-dropdown-select";

import {dataDropdownTipo,dataDropdownPrint, get_articulo_detail, TEXT_INVOICE_ENABLED, get_list_itemsFactura_detail, imgURLServerGastos, imgURLServerGastosPreview, post_pdf_cxc, post_pdf_informex, IP, IP_IMAGENES} from "./Services";
import DetalleArticuloCotizacion, {roundNumber,FOOTER_FACTURA, ITEM_DETAIL_PANEL, PANEL_VIEW_INVOICE, MONEY_ROUND, FOOTER_FACTURA_COTIZACION, FORM_CLIENTE} from "./Util";
import {DATATABLE_COLUMNS_LISTA_ORDENES,DATATABLE_COLUMNS_LISTA_CREDITOS_PAGO,DATATABLE_COLUMNS_LISTA_CREDITOS_DETALLE,DATATABLE_COLUMNS_LISTA_CREDITOS,DATATABLE_COLUMNS_RENCUENTO,DATATABLE_COLUMNS_LISTA_COTIZACION,DATATABLE_COLUMNS_LISTA_FPAGO,DATATABLE_COLUMNS_LISTA_ANULACION,DATATABLE_DC_COMPRA_DETALLE,DATATABLE_COLUMNS_LISTA_ITEMS,DATATABLE_LISTA_CLIENTE,DATATABLE_LISTA_ITEMS,DATATABLE_COTIZACION_DETALLE, DATATABLE_COLUMNS_LISTA_ORDENES_NORMAL, DATATABLE_COLUMNS_MOVIMIENTO, DATATABLE_COLUMNS_LISTA_ITEMS_BODEGA, DATATABLE_SERIES} from "./Datatables"
import {STATES_COT_COTIZACION} from "./States";
import {
  Box,
  IconButton,
} from '@mui/material';
import {
  MDBBtn,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabs,
  MDBTabsPane,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBInput,
  MDBTypography,
  MDBTextArea,MDBIcon
} from "mdb-react-ui-kit";
import { imgURLocalImage } from "./Services";
import {ADD_IMAGE,SUCCES_IMAGE,SEARCH_IMAGE,EXIT_IMAGE,PRECIO_IMAGE,YAPPY_IMAGE, AWARD, REFRESH, EDIT_IMAGE, ARTICULOS_IMAGE} from "./Image";
import { Componentprint_report_x, ComponentToPrintsPDFCredito } from "../Inventario/ComponentToPrintss";
import { AmpliarDiv, AwardIcon, BackIcon, EditIcon, PlusIcon, PriceIcon, SaveIcon, XIcon } from "./www/Icons";

const BodegaModal = ({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading,
  dataCompania,
  onChangeDropdown
}) => {
  var companiaSelected="";
  var objCompania = []
    dataCompania.map((comp) => {
    objCompania.push({
      value: comp.com_id,
      label: comp.com_alias,
    });
    return comp;
  });
    dataCompania.find((data)=>{
      if(props.bod_suc === data.com_id){
        companiaSelected= data.com_alias
      }
    })
if(companiaSelected=== null){
  companiaSelected="";
}
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>BODEGAS</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <MDBInput
                  id="bod_nombre"
                  wrapperClass="mb-4"
                  label="* Nombre"
                  name="bod_nombre"
                  onChange={onChange}
                  defaultValue={props.bod_nombre}
                />
                <MDBInput
                  type="text"
                  id="bod_ubicacion"
                  wrapperClass="mb-4"
                  label="Ubicación"
                  name="bod_ubicacion"
                  onChange={onChange}
                  defaultValue={props.bod_ubicacion}
                />
                <Select
                    options={objCompania}
                    onChange={onChangeDropdown}
                    placeholder={companiaSelected.length>0 ?companiaSelected:"Sucursal"}
                    maxMenuHeight={180}
                  />
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
              <MDBIcon fas icon="ban" className="me-1" /> Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
              <MDBIcon fas icon="save" className="me-1" />  Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ClienteModal = ({ props,isOpen,basicModalEdit, toggle, toggleSave, toggleSaveEdit, onChange, error, setFormClientesBlank, handleOnChangeCheckBox, loading,
  setFormClientes, dataRetencion,  onClickBuscarRuc}) => {

  const { dataCompania } = useContext(StoreContext);
  const [anchorElRe, setAnchorElRe] = React.useState(null);
  const openRe = Boolean(anchorElRe);
  const isEdit = basicModalEdit === true;

  const handleClickRetencion = (event) => {
    event.preventDefault();
    setAnchorElRe(event.currentTarget);
  };

  const handleCloseRetencion = () => {
    setAnchorElRe(null);
  };

  const handleClose = () => {
    toggle(false);
    setFormClientesBlank();
  };

  return (
    <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
      <MDBModalDialog centered className="gm-dialog cliente-dialog">
        <MDBModalContent className="gm-modal">
          <FORM_CLIENTE  props={props}
            onChange={onChange}
            onClickBuscarRuc={onClickBuscarRuc}
            openRe={openRe}
            anchorElRe={anchorElRe}
            handleClickRetencion={handleClickRetencion}
            handleCloseRetencion={handleCloseRetencion}
            dataRetencion={dataRetencion}
            setFormClientes={setFormClientes}
            dataCompania={dataCompania}
            handleOnChangeCheckBox={handleOnChangeCheckBox}
            />
            <MDBModalFooter className="gm-footer">
            <button
              type="button"
              className="gm-btn gm-btn-cancel"
              onClick={handleClose}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="gm-btn gm-btn-save"
              disabled={loading}
              onClick={() =>
                isEdit
                  ? toggleSaveEdit()
                  : toggleSave()
              }
            >
              <MDBIcon
                fas
                icon="save"
                className="gm-btn-icon"
              />
              {loading ? "Guardando…" : "Guardar"}
            </button>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
};

const ProveedorModal = ({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>PROVEEDORES</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <MDBInput
                  id="prov_nombre"
                  wrapperClass="mb-4"
                  label="* Nombre"
                  name="prov_nombre"
                  onChange={onChange}
                  defaultValue={props.prov_nombre}
                />
                <MDBInput
                  id="prov_direccion"
                  wrapperClass="mb-4"
                  label="Dirección"
                  name="prov_direccion"
                  onChange={onChange}
                  defaultValue={props.prov_direccion}
                />
                <MDBInput
                  type="text"
                  id="prov_telefono"
                  wrapperClass="mb-4"
                  label="Teléfono"
                  name="prov_telefono"
                  onChange={onChange}
                  defaultValue={props.prov_telefono}
                />
                <MDBInput
                  id="prov_ruc"
                  wrapperClass="mb-4"
                  label="RUC"
                  name="prov_ruc"
                  onChange={onChange}
                  defaultValue={props.prov_ruc}
                />
                <MDBInput
                  type="text"
                  id="prov_dv"
                  wrapperClass="mb-4"
                  label="DV"
                  name="prov_dv"
                  onChange={onChange}
                  defaultValue={props.prov_dv}
                />
                <MDBInput
                  type="email"
                  id="prov_email"
                  wrapperClass="mb-4"
                  label="E-MAIL"
                  name="prov_email"
                  onChange={onChange}
                  defaultValue={props.prov_email}
                />
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
              <MDBIcon fas icon="ban" className="me-1" />   Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
              <MDBIcon fas icon="save" className="me-1" />      Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const WarningModal = ({
  props,
  isOpen,
  toggle,
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog className="modal-delete">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>AVISO</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <Label>{props.text}</Label>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
              <MDBIcon fas icon="ban" className="me-1" />     Salir
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const DeleteModal = ({ props, isOpen, toggle, toggleDelete, text, error }) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog centered className="modal-delete del-modal">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>
                <span className="del-title">
                  <MDBIcon fas icon="exclamation-triangle" className="del-title-icon" />
                  Confirmar acción
                </span>
              </MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>

            <MDBModalBody>
              {/* Ícono grande de advertencia */}
              <div className="del-icon-wrap">
                <MDBIcon fas icon="trash-alt" />
              </div>

              <p className="del-question">{text}</p>
              <p className="del-record">{props}</p>
              <p className="del-hint">Esta acción no se puede deshacer.</p>

              {error && error.length > 0 ? <p className="del-error">{error}</p> : null}
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn className="del-btn del-btn-cancel" color="none" onClick={() => toggle(false)}>
                <MDBIcon fas icon="times" className="me-1" />
                Cancelar
              </MDBBtn>
              <MDBBtn className="del-btn del-btn-confirm" color="none" onClick={() => toggleDelete({})}>
                <MDBIcon fas icon="trash" className="me-1" />
                Sí, proceder
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  )
}
const  MesasModal =({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading,
  setLoading
}) =>{
  const isEdit = basicModalEdit === true;

  return (
    <MDBModal show={isOpen} setShow={toggle} tabIndex="-1">
            <MDBModalDialog
        centered
        size={window.innerWidth <= 611 ? "fullscreen" : "xl"}
        className={window.innerWidth <= 611 ? "modal-fiscal" : "gm-dialog usuarios-dialog"}
        // centered className="gm-dialog"
      >
        <MDBModalContent className="gm-modal">

          <MDBModalHeader className="gm-header">
            <div className="gm-header-title">
              <span className="gm-header-icon">
                <MDBIcon fas icon={isEdit ? "pen" : "plus"} />
              </span>

              <div>
                <h5 className="gm-title">
                  {isEdit ? "Editar mesa" : "Nueva mesa"}
                </h5>

                <p className="gm-subtitle">
                  Datos del registro
                </p>
              </div>
            </div>

            <button
              type="button"
              className="gm-close"
              aria-label="Cerrar"
              onClick={() => toggle(false)}
            >
              <MDBIcon fas icon="times" />
            </button>
          </MDBModalHeader>


          <MDBModalBody className="gm-body">

            <label className="gm-field">
              <span className="gm-label">
                Nombre de la mesa <span className="gm-req">*</span>
              </span>

              <input
                type="text"
                name="res_nombre"
                className="gm-input"
                placeholder="Ej. Mesa 1"
                value={props.res_nombre || ""}
                onChange={onChange}
                autoFocus
              />
            </label>


            {error ? (
              <div className="gm-error">
                <MDBIcon
                  fas
                  icon="exclamation-circle"
                  className="gm-error-icon"
                />
                <span>{error}</span>
              </div>
            ) : null}

          </MDBModalBody>


          <MDBModalFooter className="gm-footer">

            <button
              type="button"
              className="gm-btn gm-btn-cancel"
              onClick={() => {
                toggle(false);
                setLoading(false);
              }}
            >
              Cancelar
            </button>

            <button
              type="button"
              className="gm-btn gm-btn-save"
              disabled={loading}
              onClick={() =>
                isEdit
                  ? toggleSaveEdit()
                  : toggleSave()
              }
            >
              <MDBIcon
                fas
                icon="save"
                className="gm-btn-icon"
              />

              {loading ? "Guardando…" : "Guardar"}
            </button>

          </MDBModalFooter>

        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
}

export default function GarantiaModal({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading,
  setLoading
}) {
  const isEdit = basicModalEdit === true
  return (
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1">
      <MDBModalDialog centered className="gm-dialog">
        <MDBModalContent className="gm-modal">
          <MDBModalHeader className="gm-header">
            <div className="gm-header-title">
              <span className="gm-header-icon">
                <MDBIcon fas icon={isEdit ? "pen" : "plus"} />
              </span>
              <div>
                <h5 className="gm-title">{isEdit ? "Editar garantía" : "Nueva garantía"}</h5>
                <p className="gm-subtitle">Datos del registro</p>
              </div>
            </div>
            <button type="button" className="gm-close" aria-label="Cerrar" onClick={() => toggle(false)}>
              <MDBIcon fas icon="times" />
            </button>
          </MDBModalHeader>

          <MDBModalBody className="gm-body">
            <label className="gm-field">
              <span className="gm-label">
                Nombre <span className="gm-req">*</span>
              </span>
              <input
                type="text"
                name="gr_name"
                className="gm-input"
                placeholder="Ej. Garantía de 12 meses"
                value={props.gr_name || ""}
                onChange={onChange}
                autoFocus
              />
            </label>

            <label className="gm-field">
              <span className="gm-label">
                Descripción <span className="gm-req">*</span>
              </span>
              <textarea
                name="gr_descripcion"
                className="gm-input gm-textarea"
                rows={5}
                placeholder="Describe la garantía o condición…"
                value={props.gr_descripcion || ""}
                onChange={onChange}
              />
            </label>

            {error ? (
              <div className="gm-error">
                <MDBIcon fas icon="exclamation-circle" className="gm-error-icon" />
                <span>{error}</span>
              </div>
            ) : null}
          </MDBModalBody>

          <MDBModalFooter className="gm-footer">
            <button type="button" className="gm-btn gm-btn-cancel" onClick={() => {toggle(false);setLoading(false)}}>
              Cancelar
            </button>
            <button
              type="button"
              className="gm-btn gm-btn-save"
              disabled={loading}
              onClick={() => (isEdit ? toggleSaveEdit() : toggleSave())}
            >
              <MDBIcon fas icon="save" className="gm-btn-icon" />
              {loading ? "Guardando…" : "Guardar"}
            </button>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  )
}
const DescuentoModal = ({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>DESCUENTOS</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <MDBInput
                  id="des_number"
                  wrapperClass="mb-4"
                  label="% Descuento"
                  name="des_number"
                  onChange={onChange}
                  defaultValue={props.des_number}
                  type="number"
                />
                 <MDBInput
                  id="des_code"
                  wrapperClass="mb-4"
                  label="Nombre descuento"
                  name="des_code"
                  onChange={onChange}
                  defaultValue={props.des_code}
                    type="text"
                />
               
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
              <MDBIcon fas icon="trash" className="me-1 " />  Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
              <MDBIcon fas icon="save" className="me-1 " />     Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const GastosModal = ({
  props,
  isOpen,
  images,
  basicModalEdit,
  toggle,
  onChangeImage,
  removeImage,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading,
  objTipo,
  onChangeDropdown,
  dataTipo,
  valueSelected,
}) => {
  var objTipo = [];
  objTipo = dataTipo.map((data) => {
    return {
      value: data.tgs_id,
      label: data.tgs_desc,
    };
  });
  const maxNumber = 69;
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog
          size={window.innerWidth <= 611 ? "fullscreen" : "xl"}
          className="modal-fiscal"
        >
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>REGISTRAR GASTO</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <Row>
                  <Col xs={12}>
                    <MDBInput
                      id="gs_desc"
                      wrapperClass="mb-4"
                      label="Descripción"
                      name="gs_desc"
                      onChange={onChange}
                      defaultValue={props.gs_desc}
                    />
                  </Col>
                  <Col xs={3}>
                    <MDBInput
                      id="gs_monto"
                      wrapperClass="mb-4"
                      label="* Monto"
                      name="gs_monto"
                      type="number"
                      onChange={onChange}
                      defaultValue={props.gs_monto}
                    />
                  </Col>
                  <Col xs={6}>
                    {/* <MDBTypography variant="h6 mt-2">* Tipo</MDBTypography> */}
                    <Select
                      options={objTipo}
                      onChange={onChangeDropdown}
                      placeholder={valueSelected.length > 0 ? valueSelected : "Seleccione el gasto"}
                    />
                  </Col>
                  <Col xs={3}>
                    <MDBInput
                      id="gs_fecha"
                      type="date"
                      wrapperClass="mb-2"
                      name="gs_fecha"
                      onChange={onChange}
                      defaultValue={props.gs_fecha}
                    />
                  </Col>
                  <Col xs={12}>
                    <div className="App">
                      <ImageUploading
                        multiple={false}
                        value={images}
                        onChange={onChangeImage}
                        maxNumber={maxNumber}
                        dataURLKey="data_url"
                        allowNonImageType={true}
                        acceptType={["png", "jpeg", "jpg", "avif", "jfif", "webp", "avif","pdf","PDF"]}
                      >
                        {({
                          imageList,
                          onImageUpload,
                          onImageRemoveAll,
                          onImageUpdate,
                          onImageRemove,
                          isDragging,
                          dragProps,
                        }) => 
                          (
                          // write your building UI
                          <div className="upload__image-wrapper">
                            <Row className="mb-2">
                              <Col xs={12} className="text-center">
                                <MDBBtn
                                  type="button"
                                  style={isDragging ? { color: "red" } : undefined}
                                  onClick={onImageUpload}
                                  {...dragProps}
                                >
                                  Click or Drop here
                                </MDBBtn>
                              </Col>
                            </Row>
                            {images[0] === undefined && props.gs_imgType !=="none" && props.gs_imgType !=="" ? (
                              <Row>
                                <Col xs={12} className="text-center">
                                  {props.gs_imgType.includes("pdf")?<>
                                   <iframe src={imgURLServerGastosPreview + props.gs_imgName + props.gs_imgType} className="iframe-pdf" ></iframe>
                                  </>
                                 
                                  : <img
                                    className="img-articulos"
                                    src={imgURLServerGastosPreview + props.gs_imgName + props.gs_imgType}
                                    alt=""
                                    width="130"/>
                                    }
                                </Col>
                                <Col xs={12} className="text-center">
                                  <MDBBtn type="button" onClick={() => removeImage(props.gs_id)}>
                                    Remover
                                  </MDBBtn>
                                </Col>
                              </Row>
                            ) : null}
                            {imageList.map((image, index) => (
                              <div key={index} className="image-item">
                                <Row>
                                  <Col xs={12} className="text-center">
                                  {image["data_url"].includes("pdf")? <embed  src={image["data_url"]} type="application/pdf"className="iframe-pdf"/>:                                    <img
                                      src={image["data_url"]}
                                      alt=""
                                      width="130"
                                      className="img-articulos"
                                    />}
                                  </Col>
                                </Row>

                                <Row className="image-item__btn-wrapper mt-2">
                                  <Col xs={6} className="text-center">
                                    <MDBBtn type="button" onClick={() => onImageUpdate(index)}>
                                      Actualizar
                                    </MDBBtn>
                                  </Col>
                                  <Col xs={6} className="text-center">
                                    <MDBBtn type="button" onClick={() => onImageRemove(index)}>
                                      Remover
                                    </MDBBtn>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                          </div>
                        )}
                      </ImageUploading>
                    </div>
                  </Col>
                </Row>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
                <MDBIcon fas icon="trash" className="me-1 " /> Cerrar
              </MDBBtn>
              <MDBBtn
                onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())}
                disabled={loading}
              >
                <MDBIcon fas icon="save" className="me-1 " /> Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const MarcaModal = ({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>MARCAS</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <MDBInput
                  id="mar_descripcion"
                  wrapperClass="mb-4"
                  label="* Nombre"
                  name="mar_descripcion"
                  onChange={onChange}
                  defaultValue={props.mar_descripcion}
                />
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
              <MDBIcon fas icon="trash" className="me-1 " />  Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
              <MDBIcon fas icon="save" className="me-1 " />     Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const CategoriaModal = ({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>CATEGORIAS</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <MDBInput
                  id="cat_descripcion"
                  wrapperClass="mb-4"
                  label="* Nombre"
                  name="cat_descripcion"
                  onChange={onChange}
                  defaultValue={props.cat_descripcion}
                />
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
              <MDBIcon fas icon="ban" className="me-1 " />    Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
              <MDBIcon fas icon="save" className="me-1 " />   Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const UsuariosModal = ({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  onChangeDropdown,
  handleOnChangeCheckBox,
  loading
}) => {
  const { dataCompania } = useContext(StoreContext);

  var valueSelected = "";
  var valueSelectedPrint = "";
  var objTipo = [];

  if (dataCompania.com_restaurante === "1") {
    objTipo = dataDropdownTipo;
  } else {
    objTipo = dataDropdownTipo.filter((data) => {
      if (data.objName !== "restaurante") {
        return data;
      }
      return null;
    });
  }

  dataDropdownTipo.find((data) => {
    if (data.value === props.usr_perfil) {
      valueSelected = data.label;
      return null;
    }
    return null;
  });

  dataDropdownPrint.find((data) => {
    if (data.value === props.usr_print) {
      valueSelectedPrint = data.label;
      return null;
    }
    return null;
  });

  const isEdit = basicModalEdit === true;

  return (
    <MDBModal show={isOpen} setShow={toggle} tabIndex="-1"   className="usuarios-modal-backdrop">
      <MDBModalDialog
        centered
        size={window.innerWidth <= 611 ? "fullscreen" : "xl"}
        className={window.innerWidth <= 611 ? "modal-fiscal" : "gm-dialog usuarios-dialog"}
        // centered className="gm-dialog"
      >

        <MDBModalContent className="gm-modal">

          {/* HEADER */}
          <MDBModalHeader className="gm-header">
            <div className="gm-header-title">
              <span className="gm-header-icon">
                <MDBIcon fas icon={isEdit ? "user-edit" : "user-plus"} />
              </span>

              <div>
                <h5 className="gm-title">
                  {isEdit ? "Editar usuario" : "Nuevo usuario"}
                </h5>

                <p className="gm-subtitle">
                  Datos de acceso, perfil y permisos
                </p>
              </div>
            </div>

            <button
              type="button"
              className="gm-close"
              aria-label="Cerrar"
              onClick={() => toggle(false)}
            >
              <MDBIcon fas icon="times" />
            </button>
          </MDBModalHeader>


          {/* BODY */}
<MDBModalBody className="gm-body usuarios-body">

  <form>

    {/* =====================================
        DATOS DEL USUARIO
    ===================================== */}
    <div className="usuarios-section">

      <div className="usuarios-section-header">
        <MDBIcon fas icon="user" />

        <div>
          <strong>Datos del usuario</strong>
          <span>Información principal de acceso</span>
        </div>
      </div>

      <Row className="g-3">
        {/* SUCURSAL */}
        <Col xs={12} md={4}>
          <label className="gm-field">
            <span className="gm-label">
              Sucursal
            </span>

            <input
              type="text"
              name="com_nombre"
              className="gm-input usuarios-disabled"
              disabled
              onChange={onChange}
              value={
                (props.com_nombre || "") +
                " / Sucursal # " +
                (props.usr_sucursal || "")
              }
            />
          </label>
        </Col>


        {/* USUARIO */}
        <Col xs={6} md={4}>
          <label className="gm-field">
            <span className="gm-label">
              Usuario <span className="gm-req">*</span>
            </span>

            <input
              type="text"
              name="usr_usuario"
              className="gm-input"
              placeholder="Nombre de usuario"
              onChange={onChange}
              value={props.usr_usuario || ""}
            />
          </label>
        </Col>


        {/* CLAVE */}
        <Col xs={6} md={4}>
          <label className="gm-field">
            <span className="gm-label">
              Clave <span className="gm-req">*</span>
            </span>

            <input
              type="text"
              name="usr_clave"
              className="gm-input"
              placeholder="Clave de acceso"
              onChange={onChange}
              value={props.usr_clave || ""}
            />
          </label>
        </Col>


        {/* NOMBRE */}
        <Col xs={6} md={4}>
          <label className="gm-field">
            <span className="gm-label">
              Nombre <span className="gm-req">*</span>
            </span>

            <input
              type="text"
              name="usr_nombre"
              className="gm-input"
              placeholder="Nombre completo"
              onChange={onChange}
              value={props.usr_nombre || ""}
            />
          </label>
        </Col>
          {dataCompania.com_version === "2" && (<>
            <Col xs={6} md={3} >
              <div className="gm-field">
                <span className="gm-label">
                  Tipo de usuario <span className="gm-req">*</span>
                </span>
                <Select
                  options={objTipo}
                  onChange={onChangeDropdown}
                  placeholder={valueSelected}
                  classNamePrefix="usuarios-select"
                />
              </div>
            </Col>
            <Col xs={12} md={5}>
              <div className="gm-field">
                <span className="gm-label">
                  Imprimir <span className="gm-req">*</span>
                </span>
                <Select
                  options={dataDropdownPrint}
                  onChange={onChangeDropdown}
                  placeholder={valueSelectedPrint}
                  classNamePrefix="usuarios-select"
                />
              </div>
            </Col>
          </>)}
      </Row>

    </div>


    {dataCompania.com_version === "2" && (
      <>
        <div className="usuarios-section">

          <div className="usuarios-section-header">
            <MDBIcon fas icon="shield-alt" />

            <div>
              <strong>Permisos</strong>
              <span>
                Accesos y acciones permitidas para este usuario
              </span>
            </div>
          </div>


          <Row className="g-2">

            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_ajustes"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_ajustes}
                  checked={props.usr_ajustes === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Ajustes</span>
              </label>
            </Col>


            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_factura"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_factura}
                  checked={props.usr_factura === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Factura</span>
              </label>
            </Col>


            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_inventario"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_inventario}
                  checked={props.usr_inventario === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Inventario</span>
              </label>
            </Col>


            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_cotizacion"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_cotizacion}
                  checked={props.usr_cotizacion === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Cotización</span>
              </label>
            </Col>


            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_articulo"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_articulo}
                  checked={props.usr_articulo === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Artículos</span>
              </label>
            </Col>


            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_reporte"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_reporte}
                  checked={props.usr_reporte === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Reportes</span>
              </label>
            </Col>


            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_apartado"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_apartado}
                  checked={props.usr_apartado === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Apartado</span>
              </label>
            </Col>


            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_gastos"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_gastos}
                  checked={props.usr_gastos === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Gastos</span>
              </label>
            </Col>


            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_clientes"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_clientes}
                  checked={props.usr_clientes === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Contactos</span>
              </label>
            </Col>


            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_precio"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_precio}
                  checked={props.usr_precio === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Puede editar precios</span>
              </label>
            </Col>


            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_fac_compra"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_fac_compra}
                  checked={props.usr_fac_compra === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Factura de compra</span>
              </label>
            </Col>


            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_movimiento"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_movimiento}
                  checked={props.usr_movimiento === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Movimiento de inventario</span>
              </label>
            </Col>


            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_hacer_inventario"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_hacer_inventario}
                  checked={props.usr_hacer_inventario === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Puede hacer inventario</span>
              </label>
            </Col>


            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_trazabilidad"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_trazabilidad}
                  checked={props.usr_trazabilidad === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Puede ver trazabilidad</span>
              </label>
            </Col>


            <Col xs={6} sm={6} md={4}>
              <label className="usuarios-permission">
                <input
                  type="checkbox"
                  name="usr_a_costo"
                  onChange={handleOnChangeCheckBox}
                  value={props.usr_a_costo}
                  checked={props.usr_a_costo === "1"}
                />

                <span className="usuarios-check">
                  <MDBIcon fas icon="check" />
                </span>

                <span>Puede ver costos de artículos</span>
              </label>
            </Col>

          </Row>

        </div>

      </>
    )}


    {/* ERROR */}
    {error ? (
      <div className="gm-error mt-3">
        <MDBIcon
          fas
          icon="exclamation-circle"
          className="gm-error-icon"
        />

        <span>{error}</span>
      </div>
    ) : null}

  </form>

</MDBModalBody>


          {/* FOOTER */}
          <MDBModalFooter className="gm-footer">

            <button
              type="button"
              className="gm-btn gm-btn-cancel"
              onClick={() => toggle(false)}
            >
              Cancelar
            </button>

            <button
              type="button"
              className="gm-btn gm-btn-save"
              disabled={loading}
              onClick={() =>
                isEdit
                  ? toggleSaveEdit()
                  : toggleSave()
              }
            >
              <MDBIcon fas icon="save" className="gm-btn-icon" />
              {loading ? "Guardando…" : "Guardar"}
            </button>

          </MDBModalFooter>

        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
};
const ArticuloModal = ({
  props,
  propsArtBodega,
  propsDropdown,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  onChangeDropdown,
  onChangeImage,
  images,
  error,
  onRemoveBodega,
  removeImage,
  handleOnChangeCheckBox,
  loading,
  onClickGenerateCodigo,
  usr_a_costo
}) => {
    const { dataCompania} = useContext(StoreContext);
  var disabled_costo = true;
  if(basicModalEdit && usr_a_costo==="1"){
    disabled_costo = false;
  }
  if(basicModalEdit ===false){
   disabled_costo = false;
  }
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  // const [open, SetOpen] = useState(false);
    const handleClickPrices = (event) => {
    setAnchorEl(event.currentTarget);
    // SetOpen(true)
  };
    const handleClosePrices = () => {
    setAnchorEl(null);
    // SetOpen(false)
  };

 const [isOpenDetailItem, SetOpenDetailItem] = useState(true);
   const [dataQty, setDataQty] = useState([]);
  const maxNumber = 69;
  var compraLabel = propsDropdown.itbms_compra.find((data)=>{
    if(data.value === props.art_itbm_cod_c)
      return data
    return null
  }
  )
  var ventaLabel = propsDropdown.itbms_venta.find((data)=>{
    if(data.value === props.art_itbm_cod_v)
      return data
    return null
  }
  )
    async function select_detail_articulo({art_id}) {
     var response = await get_articulo_detail(art_id);
      setDataQty(response);
  }
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":"modal-full-large"}>
          <MDBModalContent>
            <MDBModalHeader>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
              <MDBModalTitle>Articulos</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody className="padd-1p">
              <form>
                <Row>
                  <Col xs={12} md={8} className="input-tablet">
                    <MDBTextArea 
                      id="art_descripcion"
                      label="* Descripción"
                      name="art_descripcion"
                        wrapperClass="mb-2"
                        rows={2}
                      onChange={onChange}
                      defaultValue={props.art_descripcion}
                    />
                  </Col>
                  <Col xs={4} md={4}  className="input-tablet display-none-mobile">
                  {dataCompania.com_restaurante==="1"?<div className="form-check form-check-inline mt-1">
                    <input className="form-check-input" type="checkbox" name="art_restaurante" id="inlineRadioAjustes"
                    onChange={handleOnChangeCheckBox}  value={props.art_restaurante} checked={props.art_restaurante==="1"?true:false}/>
                    <label className="form-check-label" htmlFor="inlineRadioAjustes">* Articulo restaurante</label>
                  </div>:null}
                    <input className="form-check-input" type="checkbox" name="art_servicio" id="inlineRadioAjustes"
                    onChange={handleOnChangeCheckBox}  value={props.art_servicio} checked={props.art_servicio==="1"?true:false}/>
                    <label className="form-check-label" htmlFor="inlineRadioAjustes">{dataCompania.com_lavanderia==="1"?"* Marcar como canasta":"* Marcar como servicio"}</label>
                    <input className="form-check-input" type="checkbox" name="art_catalogo" id="inlineRadioAjustes"
                    onChange={handleOnChangeCheckBox}  value={props.art_catalogo} checked={props.art_catalogo==="1"?true:false}/>
                    <label className="form-check-label" htmlFor="inlineRadioAjustes">* Catalogo</label>
                  </Col>
                  <Col xs={12} md={4} className="input-tablet d-flex mb-3">
                    <MDBInput
                      id="art_upc"
                      label="* CODIGO"
                      name="art_upc"
                      maxLength={19} 
                      onChange={onChange}
                      value={props.art_upc}
                      // disabled={basicModalEdit?true:false}
                    />
 <img src={REFRESH}  onClick={()=>onClickGenerateCodigo()} className="btn-random" alt="..."/>
                  </Col>
                  <Col xs={6} md={4} className="mb-3 input-tablet">
                    <MDBInput
                      id="art_referencia"
                      label="Referencia"
                      name="art_referencia"
                      onChange={onChange}
                      defaultValue={props.art_referencia}
                    />
                  </Col>
                  <Col xs={6} md={4} className="input-tablet">
                    <MDBInput
                      id="art_serie"
                      label="Serie"
                      name="art_serie"
                      onChange={onChange}
                      defaultValue={props.art_serie}
                    />
                  </Col>
                </Row>
                <Row className="mt-2 mb-2 text-center  display-none-mobile">
                  <Col xs={6} md={4} className="input-tablet" >
                    <MDBTypography variant="h6">* Proveedor</MDBTypography>
                    <Select
                      options={propsDropdown.proveedor}
                      onChange={onChangeDropdown}
                      placeholder={props.prov_nombre}
                    />
                  </Col>
                  <Col xs={6} md={4}  className="input-tablet">
                    <MDBTypography variant="h6">* Categorias</MDBTypography>
                    <Select
                      options={propsDropdown.categorias}
                      onChange={onChangeDropdown}
                      placeholder={props.cat_descripcion}
                    />
                  </Col>
                  <Col xs={6} md={4} className="input-tablet">
                    <MDBTypography variant="h6">* Marca</MDBTypography>
                    <Select
                      options={propsDropdown.marcas}
                      onChange={onChangeDropdown}
                      placeholder={props.mar_descripcion}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={4} md={2} className="input-tablet mb-2"> 
                    <MDBInput
                      id="art_costo"
                      label="Costo"
                      name="art_costo"
                      wrapperClass="mb-2"
                      onChange={onChange}
                      type="number"
                      disabled={disabled_costo}
                      defaultValue={basicModalEdit && usr_a_costo==="1"?props.art_costo:""}
                    />
                  </Col>
                  {window.innerWidth<=611?<><Col xs={3} md={2} className="input-tablet mb-2 display-none-mobile">
                    <MDBInput
                      id="art_linea_roja"
                      label="Linea roja"
                      name="art_linea_roja"
                      type="number"
                      onChange={onChange}
                      defaultValue={props.art_linea_roja}
                    />
                  </Col>
                  <Col xs={5} md={2}  className="d-flex input-tablet mb-2 display-none-mobile">
                    <MDBInput
                      id="inv_qty"
                      label="Cantidad"
                      name="inv_qty"
                      type="number"
                      className="h-40p"
                      onChange={onChange}
                      defaultValue={props.inv_qty}
                      disabled={true}/>
                    <Button
                      id="basic-button"
                      aria-controls={open ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                      disabled={basicModalEdit === true?false:true}
                      onClick={(e)=>{select_detail_articulo({art_id:props.art_id});handleClickPrices(e)}}>
                      <img alt ="" className="img-art-datatable-3" src ={SEARCH_IMAGE} />
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClosePrices}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}>
                         <Col xs={12} className="modal-add-inventario datatable-factura">
                    <MaterialReactTable 
                      muiTableBodyRowProps={({row}) => ({

                        sx: {
                          backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                        },
                      })} 
                      globalFilterFn="contains"
                      layoutMode="grid" 
                      renderEmptyRowsFallback={() => <Col xs={12} className="col-no-record"><Label className="label-no-record">No hay registros que mostrar</Label></Col>}
                      
                      enableEditing={false}
                      enableColumnActions={false}
                      editDisplayMode="cell"
                      enableBottomToolbar={false} 
                      enableTopToolbar={false}
                      enableRowActions={false}
                      positionActionsColumn="last"
                      enablePagination={true}
                      enableSorting={false}
                      enableFilters={true} 
                      enableStickyHeader={true}
                      columns={COLUMNS_BODEGAS()}
                      data={ dataQty}
                    />
                    
                  </Col>
                    </Menu>
                  </Col></>:null}
                  
                  <Col xs={4} md={2} className="input-tablet">
                    <MDBInput
                      id="art_precio"
                      label="* Precio 1"
                      wrapperClass="mb-2"
                      name="art_precio"
                      type="number"
                      onChange={onChange}
                      defaultValue={props.art_precio}
                    />
                  </Col>
                  <Col xs={4} md={2} className="input-tablet">
                    <MDBInput
                      id="art_precio2"
                      label="Precio 2"
                      name="art_precio2"
                      type="number"
                      onChange={onChange}
                      defaultValue={props.art_precio2}
                    />
                  </Col>
                  <Col xs={4} md={2} className="input-tablet">
                    <MDBInput
                      id="art_precio3"
                      label="Precio 3"
                      name="art_precio3"
                      type="number"
                      onChange={onChange}
                      defaultValue={props.art_precio3}
                    />
                  </Col>
                  {window.innerWidth>=612?<> <Col xs={4} md={2} className="input-tablet">
                    <MDBInput
                      id="art_linea_roja"
                      label="Linea roja"
                      name="art_linea_roja"
                      type="number"
                      onChange={onChange}
                      defaultValue={props.art_linea_roja}
                    />
                  </Col>
                  <Col xs={4} md={2}  className="d-flex input-tablet">
                    <MDBInput
                      id="inv_qty"
                      label="Cantidad"
                      name="inv_qty"
                      type="number"
                      className="h-40p"
                      onChange={onChange}
                      defaultValue={props.inv_qty}
                      disabled={true}/>
                    <Button
                      id="basic-button"
                      aria-controls={open ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                        disabled={basicModalEdit === true?false:true}
                      onClick={(e)=>{select_detail_articulo({art_id:props.art_id});handleClickPrices(e)}}>
                      <img alt ="" className="img-art-datatable-3" src ={SEARCH_IMAGE} />
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClosePrices}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}>
                         <Col xs={12} className="modal-add-inventario datatable-factura">
                    <MaterialReactTable 
                      muiTableBodyRowProps={({row}) => ({

                        sx: {
                          backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                        },
                      })} 
                      globalFilterFn="contains"
                      layoutMode="grid" 
                      renderEmptyRowsFallback={() => <Col xs={12} className="col-no-record"><Label className="label-no-record">No hay registros que mostrar</Label></Col>}
                      
                      enableEditing={false}
                      enableColumnActions={false}
                      editDisplayMode="cell"
                      enableBottomToolbar={false} 
                      enableTopToolbar={false}
                      enableRowActions={false}
                      positionActionsColumn="last"
                      enablePagination={true}
                      enableSorting={false}
                      enableFilters={true} 
                      enableStickyHeader={true}
                      columns={COLUMNS_BODEGAS()}
                      data={ dataQty}
                    />
                    
                  </Col>
                    </Menu>
                  </Col></>:null}
                 
                </Row>
                <Row>
                  {window.innerWidth>=612?<Col xs={2}>
                  </Col>:null}

                  <Col xs={4} md={2} className="input-tablet mt-3">
                    <MDBInput
                      id="art_utilidad"
                      label={props.art_precio==="0.00"?"Utilidad 1":"Utilidad 1 -> "+(((Number(props.art_precio) - Number(props.art_costo))/Number(props.art_costo))*100).toFixed(2)+"%"}
                      wrapperClass="mb-2"
                      name="art_utilidad"
                      type="number"
                      disabled={true}
                      value={props.art_precio1==="0.00"||""?"-":(Number(props.art_precio) - Number(props.art_costo)).toFixed(2)}
                    />
                  </Col>
                  <Col xs={4} md={2} className="input-tablet  mt-3">
                    <MDBInput
                      id="art_utilidad2"
                      label={props.art_precio2==="0.00"?"Utilidad 2":"Utilidad 2 ->  "+(((Number(props.art_precio2) - Number(props.art_costo))/Number(props.art_costo))*100).toFixed(2)+"%"}
                      name="art_utilidad2"
                      type="number"
                      disabled={true}
                      value={props.art_precio2==="0.00"||""?"-":(Number(props.art_precio2) - Number(props.art_costo)).toFixed(2)}
                    />
                  </Col>
                  <Col xs={4} md={2} className="input-tablet  mt-3">
                    <MDBInput
                      id="art_utilidad3"
                      label={props.art_precio3==="0.00"?"Utilidad 3":"Utilidad 3 ->"+(((Number(props.art_precio3) - Number(props.art_costo))/Number(props.art_costo))*100).toFixed(2)+"%"}
                      name="art_utilidad3"
                      type="number"
                      disabled={true}
                      value={props.art_precio3==="0.00"||""?"-":(Number(props.art_precio3) - Number(props.art_costo)).toFixed(2)}
                    />
                  </Col>
                  {window.innerWidth>=612?<><Col xs={2}>
                  </Col>
                  <Col xs={2} className="d-flex">
                  </Col></>:null}
                  
                </Row>

                <Row>
                  <Col xs={6} md={4}>
                    <div className="App">
                      <ImageUploading
                        multiple={false}
                        value={images}
                        onChange={onChangeImage}
                        maxNumber={maxNumber}
                        dataURLKey="data_url"
                        acceptType={['png','jpeg','jpg','avif','jfif','webp','avif']}
                      >
                        {({
                          imageList,
                          onImageUpload,
                          onImageRemoveAll,
                          onImageUpdate,
                          onImageRemove,
                          isDragging,
                          dragProps,
                        }) => (
                          // write your building UI
                          <div className="upload__image-wrapper">
                            <Row className="mb-2">
                              <Col xs={12} className="text-center">
                                <MDBBtn
                                  type="button"
                                  style={isDragging ? { color: "red" } : undefined}
                                  onClick={onImageUpload}
                                  {...dragProps}
                                >
                                  Click or Drop here
                                </MDBBtn>
                              </Col>
                            </Row>
                            {images[0] === undefined && props.art_imgName.length > 0 ? (
                              <Row>
                                <Col xs={12} className="text-center">
                                  <img
                                  className="img-articulos"
                                    src={imgURLocalImage + props.art_imgName}
                                    alt=""
                                    width="130"
                                  />
                                </Col>
                                <Col xs={12} className="text-center">
                                    <MDBBtn type="button" onClick={() => removeImage(props.art_id)}>
                                      Remover
                                    </MDBBtn>
                                  </Col>
                              </Row>
                            ) : null}

                            {imageList.map((image, index) => (
                              <div key={index} className="image-item">
                                <Row>
                                  <Col xs={12} className="text-center">
                                    <img src={image["data_url"]} alt="" width="130"  className="img-articulos"/>
                                  </Col>
                                </Row>

                                <Row className="image-item__btn-wrapper mt-2">
                                  <Col xs={6} className="text-center">
                                    <MDBBtn type="button" onClick={() => onImageUpdate(index)}>
                                      Actualizar
                                    </MDBBtn>
                                  </Col>
                                  <Col xs={6} className="text-center">
                                    <MDBBtn type="button" onClick={() => onImageRemove(index)}>
                                      Remover
                                    </MDBBtn>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                          </div>
                        )}
                      </ImageUploading>
                    </div>
                  </Col>
                  <Col xs={4} className="display-none-mobile">
                  <MDBTypography variant="h6">* Compra</MDBTypography>
                  <Select
                      options={propsDropdown.itbms_compra}
                      onChange={onChangeDropdown}
                      placeholder={compraLabel=== undefined?"":compraLabel.label}
                      maxMenuHeight={150}
                    />
                    {/* <MDBInput
                      id="art_itbm_venta"
                      wrapperClass="mb-4"
                      label="ITBM Venta"
                      name="art_itbm_venta"
                      type="number"
                      onChange={onChange}
                      value={props.art_itbm_venta}
                    /> */}
                  </Col>
                  <Col xs={6} md={4}>
                  <MDBTypography variant="h6">* Venta</MDBTypography>
                  <Select
                      options={propsDropdown.itbms_venta}
                      onChange={onChangeDropdown}
                      placeholder={ventaLabel=== undefined?"":ventaLabel.label}
                      maxMenuHeight={150}
                    />
                
                    {/* <MDBInput
                      id="art_itbm_compra"
                      wrapperClass="mb-4"
                      type="number"
                      label="ITBM Compra"
                      name="art_itbm_compra"
                      onChange={onChange}
                      value={props.art_itbm_compra}
                    /> */}
                  </Col>
                </Row>
              </form>
            </MDBModalBody>
            <MDBModalFooter className="margin-padding-u">
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
                Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
                Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const PublicidadModal = ({toggle, props, isOpen, onChangeImage, images, onImageUpload, removeImage, onImageUpdate, onImageRemove, toggleSave, error, loading}) => {
  const maxNumber = 69;

  return (
    <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
      <MDBModalDialog centered className="gm-dialog">
        <MDBModalContent className="gm-modal">
          <MDBModalHeader className="gm-header">
            <div className="gm-header-title">
              <span className="gm-header-icon">
                <MDBIcon fas icon={ "plus"} />
              </span>
              <div>
                <h5 className="gm-title">Publicidad</h5>
                <p className="gm-subtitle">Imagen publicitaria</p>
              </div>
            </div>
            <button
              type="button"
              className="gm-close"
              aria-label="Cerrar"
              onClick={() => toggle(false)}>
              <MDBIcon fas icon="times" />
            </button>
          </MDBModalHeader>
          <MDBModalBody className="gm-body">
            <ImageUploading
              multiple={false}
              value={images}
              onChange={onChangeImage}
              maxNumber={maxNumber}
              dataURLKey="data_url"
              acceptType={[
                "png",
                "jpeg",
                "jpg",
                "avif",
                "jfif",
                "webp"
              ]}
            >
              {({
                imageList,
                onImageUpload,
                onImageUpdate,
                onImageRemove,
                isDragging,
                dragProps
              }) => (
                <div className="gm-upload-wrapper">
                  <button
                    type="button"
                    className={`gm-upload-zone ${isDragging ? "gm-upload-dragging" : ""}`}
                    onClick={onImageUpload}
                    {...dragProps}
                  >
                    <span className="gm-upload-icon">
                      <MDBIcon fas icon="cloud-upload-alt" />
                    </span>

                    <span className="gm-upload-title">
                      Seleccionar imagen
                    </span>

                    <span className="gm-upload-subtitle">
                      Haz clic o arrastra una imagen aquí
                    </span>
                  </button>
                  {images[0] === undefined && props.img_name?.length > 0 ? (
                    <div className="gm-image-card">
                      <div className="gm-image-preview">
                        <img
                          src={imgURLocalImage + props.img_name}
                          alt="Publicidad"
                          className="gm-image"
                        />
                      </div>
                      <div className="gm-image-actions">
                        <button
                          type="button"
                          className="gm-btn gm-btn-danger"
                          onClick={() => removeImage(props.img_id)}
                        >
                          <MDBIcon fas icon="trash" className="gm-btn-icon" />
                          Remover
                        </button>
                      </div>
                    </div>
                  ) : null}

                  {imageList.map((image, index) => (
                    <div key={index} className="gm-image-card">
                      <div className="gm-image-preview">
                        <img
                          src={image["data_url"]}
                          alt="Vista previa"
                          className="gm-image"
                        />
                      </div>
                      <div className="gm-image-actions">
                        <button
                          type="button"
                          className="gm-btn gm-btn-secondary"
                          onClick={() => onImageUpdate(index)}
                        >
                          <MDBIcon fas icon="sync-alt" className="gm-btn-icon" />
                          Cambiar
                        </button>
                        <button
                          type="button"
                          className="gm-btn gm-btn-danger"
                          onClick={() => onImageRemove(index)}
                        >
                          <MDBIcon fas icon="trash" className="gm-btn-icon" />
                          Remover
                        </button>
                      </div>
                    </div>
                  ))}

                </div>
              )}
            </ImageUploading>
            {error ? (
              <div className="gm-error">
                <MDBIcon
                  fas
                  icon="exclamation-circle"
                  className="gm-error-icon"
                />
                <span>{error}</span>
              </div>
            ) : null}

          </MDBModalBody>
          <MDBModalFooter className="gm-footer">
            <button
              type="button"
              className="gm-btn gm-btn-cancel"
              onClick={() => toggle(false)}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="gm-btn gm-btn-save"
              disabled={loading}
              onClick={() => toggleSave()}
            >
              <MDBIcon
                fas
                icon="save"
                className="gm-btn-icon"
              />
              {loading ? "Guardando…" : "Guardar"}
            </button>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
};

const FacturaCompraModal = ({
  dataBodegas,
  props,
  dataCompraDetalle,
  propsDCDetail,
  formDropdown,
  propsDropdown,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  onChange,
  onChangeDC_detail,
  handleKeyPress,
  onChangeDropdown,
  onBlurs,
  error,
  error_upc,
  isSaveI,
  deleteRow,
  setOBJCompraDetalle,
  fetchDCCompra,
  update_dcd_compra_detalle_row,
  toggleSaveEncabezado,
  dataItems,
  selectItem,
  setFormCompraDetalle,
  loading,
  usr_sucursal,
  usr_a_costo
}) => {
  const [isTabItems, setTabItems] = useState(false);
  const [isOpenDetailItem, SetOpenDetailItem] = useState(false);
  var bodegas =dataBodegas.filter((data,i)=>{
    if(usr_sucursal ===data.bod_suc)
    return data
  });
  var enableTab = true
  if(props.dc_docn.length>0 && props.dc_fecha.length>0 && formDropdown.prov_id.length>0 && formDropdown.bod_id.length>0){
    enableTab = false
  }
  const ref = useRef(null);
  var subtotal=0;
  var itbms =0;
  var total = 0;
  var existencia =0;
  const [formDetailItem, setFormDetailItem] = useState({
    art_categoria : "",
    art_descripcion : "",
    art_id : "",
    art_img : null,
    art_imgName : "",
    art_itbm_cod_v: "",
    art_itbm_venta: "",
    art_precio: "",
    art_precio2: "",
    art_precio3: "",
    art_referencia: "",
    art_restaurante: "",
    art_upc: "",
    cat_descripcion: "",
    itbm_descripcion: "",
    mar_descripcion: "",
  });
async function select_detail_articulo({row}) {   
    var response = await get_articulo_detail(row.art_id);
    setFormDetailItem({
    art_categoria : row.art_categoria,
    art_descripcion : row.art_descripcion,
    art_id : row.art_id,
    art_img : row.art_img,
    art_imgName :row.art_imgName,
    art_itbm_cod_v:row.art_itbm_cod_v,
    art_itbm_venta: row.art_itbm_venta,
    art_precio: row.art_precio,
    art_precio2: row.art_precio2,
    art_precio3: row.art_precio3,
    art_referencia: row.art_referencia,
    art_restaurante: row.art_restaurante,
    art_upc: row.art_upc,
    cat_descripcion: row.cat_descripcion,
    itbm_descripcion: row.itbm_descripcion,
    mar_descripcion: row.mar_descripcion,
    bodegas:response});
    SetOpenDetailItem(true)
}
  if(isOpenDetailItem && formDetailItem.bodegas !== undefined){
    formDetailItem.bodegas.map((data)=>{
    existencia = existencia+Number(data.inv_qty)
  })}
dataCompraDetalle.map((row,i)=>{
  subtotal = Number(subtotal) + Number((Number(row.dcd_cantidad)*Number(row.dcd_precio)));
  itbms = Number(itbms) + Number(row.dcd_itbms);
  total = Number(subtotal)+Number(itbms);
 return null
})

const handleSaveRow = ({
  exitEditingMode,
  row,
  values
}) => {

if(basicModalEdit){
  update_dcd_compra_detalle_row({
    dcd_cantidad:values.dcd_cantidad,
    dcd_id:row.original.dcd_id, 
    dcd_itbms:((new Decimal(values.dcd_cantidad).times(new Decimal(row.original.dcd_precio)))).times(new Decimal(row.original.art_itbm_compra)),
    dcd_total: ((new Decimal(values.dcd_cantidad).times(row.original.dcd_precio)).times(new Decimal(1).plus(row.original.art_itbm_compra))),
    dcd_serie:values.art_serie, 
  },row.original.dcd_identificador)
  exitEditingMode();
}
else{
  dataCompraDetalle[row.index] = {
      art_upc:row.original.art_upc,
      art_descripcion: row.original.art_descripcion,
      art_itbm_cod_c:row.original.art_itbm_cod_c,
      art_itbm_compra:row.original.art_itbm_compra,
      dcd_articulo:row.original.dcd_articulo,
      dcd_cantidad: values.dcd_cantidad,
      dcd_descuento:row.original.dcd_descuento,
      dcd_descuento_number:row.original.dcd_descuento_number,
      dcd_id:row.original.dcd_id,
      dcd_itbms: ((new Decimal(values.dcd_cantidad).times(new Decimal(row.original.dcd_precio)))).times(new Decimal(row.original.art_itbm_compra)),
      dcd_precio: values.dcd_precio,
      dcd_total: ((new Decimal(values.dcd_cantidad).times(row.original.dcd_precio)).times(new Decimal(1).plus(row.original.art_itbm_compra))),
      art_serie:values.art_serie, 
    };

    setOBJCompraDetalle([...dataCompraDetalle]);
    exitEditingMode();
}
};

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size="fullscreen" className="modal-full-large">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>FACTURA DE COMPRA</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => {toggle(false);fetchDCCompra()}}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
                <>
                {isTabItems?<>
                 {isOpenDetailItem?<> {ITEM_DETAIL_PANEL({SetOpenDetailItem,formDetailItem,existencia})}</>:
<Row>
<Col xs={12} className="modal-add-inventario datatable-factura css_datatable1">
              {dataItems !==undefined?<DATATABLE_LISTA_ITEMS select_detail_articulo={select_detail_articulo} dataItems={dataItems} selectItem={selectItem} setTabItems={setTabItems} usr_a_costo={usr_a_costo}/>:<Label>Cargando...</Label>}
                  </Col>
</Row>}
                </>:<>
                <form>
                <Row>
                  <Col xs={2}>
                    <MDBInput
                      id="dc_docn"
                      wrapperClass="mb-3"
                      label="* N° Documento"
                      name="dc_docn"
                      onChange={onChange}
                      defaultValue={props.dc_docn}
                    />
                  </Col>
                  <Col xs={2}>
                    <MDBInput
                      id="dc_fecha"
                      type="date"
                      wrapperClass="mb-3"
                      label="* Fecha documento"
                      name="dc_fecha"
                      onChange={onChange}
                      value={props.dc_fecha ? moment(props.dc_fecha).format("YYYY-MM-DD") : ""}
                    />
                  </Col>
                  <Col xs={4}>
                    <Select
                      options={propsDropdown}
                      onChange={onChangeDropdown}
                      placeholder={formDropdown.prov_nombre.length===0?"Proveedores":"Proveedor: "+formDropdown.prov_nombre}
                      maxMenuHeight={150}
                    />
                  </Col>
                  <Col xs={4}>
                    <Select
                      options={bodegas}
                      onChange={onChangeDropdown}
                      placeholder={formDropdown.bod_nombre.length===0?"Bodega":"Bodega: "+formDropdown.bod_nombre}
                      maxMenuHeight={150}
                    />
                  </Col>
                  <Col xs={12}>
                    <MDBInput
                      id="dc_descripcion"
                      wrapperClass="mb-1"
                      label="Descripción"
                      name="dc_descripcion"
                      onChange={onChange}
                      defaultValue={props.dc_descripcion}
                      
                    />
                  </Col>
                </Row>
              </form>
              <Row >
              <Col xs={12}>
                    <Label className="error-label-inventario">
                      - {error_upc}
                    </Label>
                  </Col>
                  <Col xs ={12} className="mt-2">
                    <Row>
                    <Col xs={3} className="d-flex">
                  <MDBInput
                      id="art_upc"
                      wrapperClass="mb-2"
                      label="Código o referencia"
                      name="art_upc"
                      onChange={onChangeDC_detail}
                      value={propsDCDetail.art_upc}
                      disabled={enableTab}
                      onKeyDown={(e) =>{
                        handleKeyPress(e, props.dcd_articulo);
                      }
                      }
                    />
                      {enableTab===true?null:<img src={SEARCH_IMAGE} className="src-image" alt="..." onClick={()=>{setTabItems(true)}}/>}
                      {enableTab===false && propsDCDetail.art_upc.length>0?<img src={EXIT_IMAGE} className="src-image" alt="..." onClick={()=>{     
                         setFormCompraDetalle({
                          dcd_id: "",
                          dcd_articulo: "",
                          dcd_precio: "",
                          dcd_cantidad: "1",
                          dcd_itbms: "",
                          dcd_descuento: "",
                          dcd_total: "",
                          dcd_descuento_number: "",
                          art_descripcion: "",
                          art_upc:"",
                          art_serie:""
                        });
                      
                      }}/>:null}
                  </Col>
                  <Col xs={4}>
                  <MDBInput
                      id="art_descripcion"
                      wrapperClass="mb-2"
                      label="Descripción del artículo"
                      name="art_descripcion"
                      onChange={onChangeDC_detail}
                      value={propsDCDetail.art_descripcion}
                      disabled ={propsDCDetail.art_upc.length>0?false:true}
                    />
                  </Col>
                   <Col xs={2}>
                  <MDBInput
                      id="art_serie"
                      wrapperClass="mb-2"
                      label="Serie"
                      name="art_serie"
                      onChange={onChangeDC_detail}
                      value={propsDCDetail.art_serie}
                      disabled ={propsDCDetail.art_upc.length>0?false:true}
                      // disabled={true}
                    />
                  </Col>
                  <Col xs={1}>
                  <MDBInput
                      id="dcd_precio"
                      wrapperClass="mb-2"
                      label="Costo"
                      name="dcd_precio"
                      // autoFocus ={true}
                      type={"number"}
                      onChange={onChangeDC_detail}
                      value={propsDCDetail.dcd_precio}
                      disabled= {propsDCDetail.art_upc.length>0?false:true}
                    />
                  </Col>
                  <Col xs={2} className="d-flex">
                  <MDBInput
                      id="dcd_cantidad"
                      wrapperClass="mb-2"
                      label="Cantidad"
                      name="dcd_cantidad"
                      autoFocus ={true}
                      type={"number"}
                      min={"1"}
                      ref={ref}
                      disabled ={propsDCDetail.art_upc.length>0?false:true}
                      onChange={onChangeDC_detail}
                      value={propsDCDetail.art_descripcion.length>0?propsDCDetail.dcd_cantidad:""}
                      onKeyDown={(e) =>
                        handleKeyPress(e, propsDCDetail.dcd_cantidad,"")
                      }
                    />
                    {propsDCDetail.art_upc.length>0 ?<img src={ADD_IMAGE}  namebtn="dcd_cantidad" className="src-image-2" alt="..." onClick={(e)=>{handleKeyPress(e, propsDCDetail.dcd_cantidad,"btn");}}/>:<img src={ADD_IMAGE} className="src-image-2" alt="..." />}
                  </Col>
                <Col className="modal-add-inventario datatable-factura css_datatable1">
                <DATATABLE_DC_COMPRA_DETALLE deleteRow ={deleteRow} onBlurs={onBlurs} enableTab={enableTab} handleSaveRow={handleSaveRow} dataCompraDetalle={dataCompraDetalle} />
                </Col>
              </Row>
              <Row className="mt-3">
                  <Col xs={6}>
                  </Col>
                <Col xs={2}>
                <MDBInput
                 className="input-iventario-totales"
                      id="dcd_i_subtotal"
                      wrapperClass="mb-2"
                      label="SUBTOTAL"
                      name="dcd_i_subtotal"
                      autoFocus ={true}
                      value={
                        enableTab?[]:subtotal.toFixed(2)
                      }
                      disabled={true}
                    />
                </Col>
                <Col xs={2}>
                <MDBInput
                 className="input-iventario-totales"
                      id="dcd_i_itbms"
                      wrapperClass="mb-2"
                      label="ITBMS"
                      name="dcd_i_itbms"
                      autoFocus ={true}
                      value={
                        enableTab?[]:itbms.toFixed(2)
                      }
                      disabled={true}
                    />
                  </Col>
                  <Col xs={2}>
                  <MDBInput
                  className="input-iventario-totales"
                      id="dcd_i_total"
                      wrapperClass="mb-2"
                      label="TOTAL"
                      name="dcd_i_total"
                      autoFocus ={true}
                      value={                 enableTab?[]:total.toFixed(2)
                      }
                      disabled={true}
                    />
                  </Col>
                    </Row>
                  </Col>
                </Row>       
                </>}   
                </>
            </MDBModalBody>
            <MDBModalFooter>
            {isTabItems?<>
              <Row>
                <Col xs={12} className="text-center">
                <MDBBtn color="danger" onClick={() => {setTabItems(false)}}>
                <MDBIcon fas icon="ban" className="me-1"  />   Cerrar
              </MDBBtn>
                </Col>
              </Row>
            </>:<>
            <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
                <Col xs={12} className="text-center">
                 {isSaveI ? <Label className="success-label" >Guardado</Label> : ""}
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => {toggle(false);fetchDCCompra();}}>
              <MDBIcon fas icon="ban" className="me-1"  />    Cerrar
              </MDBBtn>
              {basicModalEdit?<MDBBtn  onClick={() => ( toggleSaveEncabezado())}>
                  Guardar
                </MDBBtn>:              <MDBBtn onClick={() => ( toggleSave())} disabled={loading}>
              <MDBIcon fas icon="save" className="me-1"  />  Guardar
              </MDBBtn>}

            </>}

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const MovimientoModal = ({
  props,
  setFormMovimiento,
  dataMovimientoDetalle,
  formMovimientoDetalle,
  isOpen,
  basicModalEditMov,
  toggle,
  toggleSave,
  onChange,
  onChangeRed_detail,
  handleKeyPress,
  error,
  error_upc,
  isSaveI,
  deleteRow,
  setOBJMovimientoDetalle,
  fetchMovimiento,
  dataItems,
  update_mov_movimiento_detalle_row,
  toggleSaveEncabezado,
  dataRecuento,
  selectItem,
  setFormMovimientoDetalle,
  loading,
  dataBodegas,
  onChangeDropdown,usr_a_costo,
  dataSeries,
  setFormSerie
}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElSerie, setAnchorElSerie] = React.useState(null);
      const handleClickSeries = (event) => {
    setAnchorElSerie(event.currentTarget);
    //  setError_upc("")
  };
  const open = Boolean(anchorEl);
  const openSerie = Boolean(anchorElSerie);
  var ObjBodegaDesde = [];
  var ObjBodegaHacia = [];
  var dataItemsFilter;
  dataItemsFilter = dataItems.filter((data,i)=>{
    if(data.bod_id==props.mov_bodega_desde){
      return data;
    }
  })
  const [isTabItems, setTabItems] = useState(false);
  var enableTab = true
  if(props.mov_fecha.length>0 && props.mov_bodega_desde.length>0 && props.mov_bodega_hacia.length>0){
    enableTab = false
  }
  dataBodegas.map((bodega) => {
    ObjBodegaDesde.push({
      value: bodega.bod_id,
      label: bodega.bod_nombre,
      objName: "bodegaDesde",
    });
    return bodega;
  });
    dataBodegas.map((bodega) => {
      if(props.mov_bodega_desde!==bodega.bod_id){
        ObjBodegaHacia.push({
          value: bodega.bod_id,
          label: bodega.bod_nombre,
          objName: "bodegaHacia",
        });
      }
    return bodega;
  });
const handleSaveRow = ({exitEditingMode,row,values}) => {
    var qty =0;
    dataItems.map((data,i)=>{
      if(Number(row.original.movd_articulo)===Number(data.art_id) && Number(props.mov_bodega_desde)===Number(data.bod_id)){
        qty = data.inv_qty;
      }
    })

    if(Number(values.movd_cantidad)<=Number(qty)){
        if(basicModalEditMov){
          update_mov_movimiento_detalle_row({
            movd_cantidad:values.movd_cantidad,
            movd_id:row.original.movd_id, 
            movd_identificador:row.original.movd_identificador,
            movd_serie:values.art_serie 
          },row.original.movd_identificador)
          exitEditingMode();
        }
        else{
          dataMovimientoDetalle[row.index] = {
          art_upc:row.original.art_upc,
          movd_articulo:row.original.movd_articulo,
          movd_cantidad: values.movd_cantidad,
          movd_id:row.original.movd_id,
          art_descripcion:values.art_descripcion,
          inv_qty:row.original.inv_qty,
          art_serie:values.art_serie
        };

        setOBJMovimientoDetalle([...dataMovimientoDetalle]);
        exitEditingMode();
        }
    }
};
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size="fullscreen" className="modal-full-large">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Movimiento # {props.mov_id}</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => {toggle(false);fetchMovimiento()}}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
                <>
                {isTabItems?<>
                  <Row>
                    <Col xs={12} className="modal-add-inventario datatable-factura css_datatable1">
                      {dataItems !==undefined?
                      <DATATABLE_COLUMNS_LISTA_ITEMS_BODEGA dataItems={dataItemsFilter} selectItem={selectItem} setTabItems={setTabItems} setFormMovimientoDetalle={setFormMovimientoDetalle} props= {formMovimientoDetalle} usr_a_costo={usr_a_costo}/> :<Label>Cargando...</Label>}
                  </Col>
                </Row>
                </>:<>
                    <form>
                      <Row>
                        <Col xs={2}>
                          <MDBInput
                            id="mov_fecha"
                            type="date"
                            wrapperClass="mb-1"
                            label="* Fecha movimiento"
                            name="mov_fecha"
                            onChange={onChange}
                            defaultValue={props.mov_fecha}
                          />
                        </Col>
                        <Col xs={10}>
                          <MDBInput
                            id="mov_descripcion"
                            wrapperClass="mb-1"
                            label="Descripcion"
                            name="mov_descripcion"
                            onChange={onChange}
                            value={props.mov_descripcion}
                            
                          />
                        </Col>
                      </Row>
                  </form>
                  <Row>
                    <Col xs={6}>
                    <Label>
                      Bodega desde
                    </Label>
                      <Select
                       wrapperClass="mb-1"
                        options={ObjBodegaDesde}
                        onChange={onChangeDropdown}
                        placeholder={props.mov_bodega_desde.length>0?props.mov_bodega_desde_nombre:"Bodega inicio"}
                        maxMenuHeight={180}/>
                    </Col>
                    <Col xs={6}>
                    <Label>
                      Bodega hacia
                    </Label>
                        <Select
                         wrapperClass="mb-1"
                        options={ObjBodegaHacia}
                        onChange={onChangeDropdown}
                        placeholder={props.mov_bodega_hacia.length>0?props.mov_bodega_hacia_nombre:"Bodega final"}
                        maxMenuHeight={180}/>
                    </Col>
                    <Col xs={12} className="mt-2">
                      <Label className="error-label-inventario">
                        - {error_upc}
                      </Label>
                    </Col>
                    <Col xs ={12} className="mt-2">
                      <Row>
                        <Col xs={3} className="d-flex">
                          <MDBInput
                              id="art_upc"
                              wrapperClass="mb-4"
                              label="Codigo"
                              name="art_upc"
                              onChange={onChangeRed_detail}
                              value={formMovimientoDetalle.art_upc}
                              disabled={enableTab}
                              onKeyDown={(e) =>{
                                handleKeyPress(e, props.dcd_articulo);
                              }
                              }
                            />
                          {enableTab===true?null:<img src={SEARCH_IMAGE} className="src-image" alt="..." onClick={()=>{setTabItems(true)}}/>}
                          {enableTab===false && formMovimientoDetalle.art_upc.length>0?<img src={EXIT_IMAGE} className="src-image" alt="..." onClick={()=>{     
                            setFormMovimientoDetalle({
                              movd_id: "",
                              movd_articulo: "",
                              movd_cantidad: "1",
                              movd_identificador: "",
                              art_upc: "",
                              art_descripcion: "",
                            });
                          
                          }}/>:null}
                        </Col>
                        <Col xs={5}>
                        <MDBInput
                            id="art_descripcion"
                            wrapperClass="mb-4"
                            label="Descripcion articulo"
                            name="art_descripcion"
                            disabled={true}
                            onChange={onChangeRed_detail}
                            value={formMovimientoDetalle.art_descripcion}
                          />
                        </Col>
                        <Col xs={2} sm={2} md={2} className="input-tablet d-flex">
                            <MDBInput
                                id="art_serie"
                                wrapperClass="mb-4"
                                label="Serie"
                                name="art_serie"
                                disabled ={true}
                                onChange={onChangeRed_detail}
                                value={formMovimientoDetalle.art_serie}
                                // disabled={true}
                              />
                               {dataSeries.length>0 && <>                  <Button
                                id="basic-button"
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleClickSeries}
                                disabled ={formMovimientoDetalle.art_upc.length>0  ?false:true}>
                                <img src={ARTICULOS_IMAGE} className="src-image style-precio-btn" alt="..."/>
                              </Button>
                              <Menu
                                id="basic-menu"
                                anchorEl={anchorElSerie}
                                open={openSerie}
                                onClose={()=>setAnchorElSerie(null)}
                                MenuListProps={{
                                  'aria-labelledby': 'basic-button',
                                }}>
                                  {dataSeries.map((data,i)=>{
                                    return <MenuItem onClick={()=>{ setFormMovimientoDetalle({
                                  ...formMovimientoDetalle,
                                  ser_id:data.ser_id,
                                  art_serie:data.ser_serie,
                                  art_descripcion: formMovimientoDetalle.art_descripcion + " (SERIE : "+ data.ser_serie +")",
                                });setFormSerie([data]);  setAnchorElSerie(null);}}>{"SERIE : "+data.ser_serie}</MenuItem>
                                  })}
                              </Menu></>}
                          </Col>
                        <Col xs={2} className="d-flex">
                        <MDBInput
                            id="movd_cantidad"
                            wrapperClass="mb-4"
                            label="Cantidad"
                            name="movd_cantidad"
                            autoFocus ={true}
                            type={"number"}
                            min={"1"}
                            max={Number(props.inv_qty).toFixed(0)}
                            disabled ={formMovimientoDetalle.art_upc.length>0?false:true}
                            onChange={onChangeRed_detail}
                            value={formMovimientoDetalle.art_descripcion.length>0?formMovimientoDetalle.movd_cantidad:""}
                            onKeyDown={(e) =>
                              handleKeyPress(e, formMovimientoDetalle.movd_cantidad)
                            }
                          />
                            {formMovimientoDetalle.art_upc.length>0 ?<img src={ADD_IMAGE}  namebtn="movd_cantidad" className="src-image-2" alt="..." onClick={(e)=>{handleKeyPress(e, formMovimientoDetalle.movd_cantidad,"btn");}}/>:<img src={ADD_IMAGE} className="src-image-2" alt="..." />}
                        </Col>
                        <Col className="modal-add-inventario datatable-factura  css_datatable1">
                        <DATATABLE_COLUMNS_MOVIMIENTO  enableTab={enableTab} dataMovimientoDetalle ={dataMovimientoDetalle} handleSaveRow={handleSaveRow} deleteRow={deleteRow}/>
                        </Col>
                    </Row> 
                    </Col>
                  </Row> 
                  
                </>}   
                </>
            </MDBModalBody>
            <MDBModalFooter>
            {isTabItems?<>
              <Row>
                <Col xs={12} className="text-center">
                <MDBBtn color="danger" onClick={() => {setTabItems(false)}}>
                Cerrar
              </MDBBtn>
                </Col>
              </Row>
            </>:<>
            <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
                <Col xs={12} className="text-center">
                 {isSaveI ? <Label className="success-label" >Guardado</Label> : ""}
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => {toggle(false);fetchMovimiento();}}>
                Cerrar
              </MDBBtn>
              {basicModalEditMov?<MDBBtn onClick={() => ( toggleSaveEncabezado())}>
                        Guardar
                      </MDBBtn>:              <MDBBtn onClick={() => ( toggleSave())} disabled={loading}>
                Guardar
              </MDBBtn>}

            </>}

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const RecuentoModal = ({
  dataBodegas,
  onChangeDropdown,
  formDropdown,
  props,
  dataRecuentoDetalle,
  formRecuentoDetalle,
  isOpen,
  basicModalEditRe,
  toggle,
  toggleSave,
  onChange,
  onChangeRed_detail,
  handleKeyPress,
  error,
  error_upc,
  isSaveI,
  deleteRow,
  setOBJRecuentoDetalle,
  fetchRecuento,
  dataItems,
  update_red_recuento_detalle_row_re,
  toggleSaveEncabezado,
  dataRecuento,
  selectItem,
  setFormRecuentoDetalle,
  loading,
  usr_sucursal,
  setPrintI,
  usr_a_costo
}) => {
  const [isTabItems, setTabItems] = useState(false);
  const [isOpenDetailItem, SetOpenDetailItem] = useState(false);
  var enableTab = true
  var existencia =0;
  var bodegas =dataBodegas.filter((data,i)=>{
    if(usr_sucursal ===data.bod_suc)
    return data
  });
  if(props.re_fecha.length && formDropdown.bod_id.length>0){
    enableTab = false
  }
  const ref = useRef(null);
  if (formRecuentoDetalle.art_descripcion.length>0) {
      // ref.current.focus();
   }
  const [formDetailItem, setFormDetailItem] = useState({
    art_categoria : "",
    art_descripcion : "",
    art_id : "",
    art_img : null,
    art_imgName : "",
    art_itbm_cod_v: "",
    art_itbm_venta: "",
    art_precio: "",
    art_precio2: "",
    art_precio3: "",
    art_referencia: "",
    art_restaurante: "",
    art_upc: "",
    cat_descripcion: "",
    itbm_descripcion: "",
    mar_descripcion: "",
  });
  async function select_detail_articulo({row}) {
    var response = await get_articulo_detail(row.art_id);
    setFormDetailItem({
    art_categoria : row.art_categoria,
    art_descripcion : row.art_descripcion,
    art_id : row.art_id,
    art_img : row.art_img,
    art_imgName :row.art_imgName,
    art_itbm_cod_v:row.art_itbm_cod_v,
    art_itbm_venta: row.art_itbm_venta,
    art_precio: row.art_precio,
    art_precio2: row.art_precio2,
    art_precio3: row.art_precio3,
    art_referencia: row.art_referencia,
    art_restaurante: row.art_restaurante,
    art_upc: row.art_upc,
    cat_descripcion: row.cat_descripcion,
    itbm_descripcion: row.itbm_descripcion,
    mar_descripcion: row.mar_descripcion,
    bodegas:response});
    SetOpenDetailItem(true)
}
const handleSaveRow = ({exitEditingMode,row,values}) => {
  if(basicModalEditRe){
    update_red_recuento_detalle_row_re({
      red_cantidad:values.red_cantidad,
      red_id:row.original.red_id,
      red_serie:values.art_serie, 
    },row.original.red_identificador)
    exitEditingMode();
    
  }
  else{
    dataRecuentoDetalle[row.index] = {
        art_upc:row.original.art_upc,
        red_articulo:row.original.red_articulo,
        red_cantidad: values.red_cantidad,
        red_id:row.original.red_id,
         art_serie:values.art_serie, 
        art_descripcion:values.art_descripcion,
      };

      setOBJRecuentoDetalle([...dataRecuentoDetalle]);
      exitEditingMode();
  }
};
  if(isOpenDetailItem && formDetailItem.bodegas !== undefined){
    formDetailItem.bodegas.map((data)=>{
    existencia = existencia+Number(data.inv_qty)
  })}
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":"modal-xl-w2"}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Inventario # {props.re_id}</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => {toggle(false);fetchRecuento()}}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
                <>
                {isTabItems?<>
                 {isOpenDetailItem?<> {ITEM_DETAIL_PANEL({SetOpenDetailItem,formDetailItem,existencia})}</>:<Row>
                    <Col xs={12} className="modal-add-inventario datatable-factura css_datatable1">
                      {dataItems !==undefined?
                      <DATATABLE_COLUMNS_LISTA_ITEMS dataItems={dataItems} usr_a_costo={usr_a_costo} selectItem={selectItem} setTabItems={setTabItems}  select_detail_articulo={select_detail_articulo}/> :<Label>Cargando...</Label>}
                  </Col>
                </Row>
                }
                </>:<>
                    <form>
                      <Row>
                        <Col xs={5} sm={4} md={2} className="input-tablet">
                          <MDBInput
                            id="re_fecha"
                            type="date"
                            wrapperClass="mb-2"
                            label="* Fecha documento"
                            name="re_fecha"
                            onChange={onChange}
                            defaultValue={props.re_fecha}
                          />
                        </Col>
                        <Col xs={7} sm={8} md={6} className="input-tablet">
                          <Select
                            options={bodegas}
                            onChange={onChangeDropdown}
                            placeholder={formDropdown.bod_nombre.length===0?"Bodega":"Bodega: "+formDropdown.bod_nombre}
                            maxMenuHeight={150}
                          />
                        </Col>
                        <Col xs={12} sm={12} md={4} className="input-tablet">
                          <MDBInput
                            id="re_descripcion"
                            wrapperClass="mb-2 mt-2"
                            label="Descripcion"
                            name="re_descripcion"
                            onChange={onChange}
                            defaultValue={props.re_descripcion}   
                          />
                        </Col>
                        
                      </Row>
                  </form>
                  <Row>
                    <Col xs={7}>
                      <Label className="error-label-inventario">
                        - {error_upc}
                      </Label>
                    </Col>
                    <Col xs={5}>
                      <Label className="error-label-inventario">
                        ARTÍCULOS: {dataRecuentoDetalle.length}
                      </Label>
                    </Col>
                    <Col xs ={12}>
                      <Row>
                        <Col xs ={8} sm={8} md={2}  className="d-flex input-tablet inventario">
                          <MDBInput
                              id="art_upc"
                              wrapperClass="mb-2"
                              label="Código o referencia"
                              name="art_upc"
                              onChange={onChangeRed_detail}
                              value={formRecuentoDetalle.art_upc}
                             disabled ={formRecuentoDetalle.art_descripcion.length>0?true:false}
                              onKeyDown={(e) =>{
                                handleKeyPress(e, props.dcd_articulo);
                              }
                              }
                            />
                          {enableTab===true?null:<img src={SEARCH_IMAGE} className="src-image" alt="..." onClick={()=>{setTabItems(true); SetOpenDetailItem(false)}}/>}
                          {enableTab===false && formRecuentoDetalle.art_upc.length>0?<img src={EXIT_IMAGE} className="src-image" alt="..." onClick={()=>{     
                            setFormRecuentoDetalle({
                              red_id: "",
                              red_articulo: "",
                              red_cantidad: "1",
                              red_identificador: "",
                              art_upc: "",
                              art_descripcion: "",
                            });
                          
                          }}/>:null}
                        </Col>
                        {window.innerWidth<=611?null:<><Col xs={5} sm={5} md={6} className="input-tablet">
                          <MDBInput
                              id="art_descripcion"
                              wrapperClass="mb-4"
                              label="Descripción del artículo"
                              name="art_descripcion"
                              disabled={true}
                              onChange={onChangeRed_detail}
                              value={formRecuentoDetalle.art_descripcion}
                            />
                          </Col>
                          <Col xs={5} sm={5} md={2} className="input-tablet">
                            <MDBInput
                                id="art_serie"
                                wrapperClass="mb-4"
                                label="Serie"
                                name="art_serie"
                                disabled ={formRecuentoDetalle.art_upc.length>0?false:true}
                                onChange={onChangeRed_detail}
                                value={formRecuentoDetalle.art_serie}
                              />
                          </Col></>}
                        <Col xs={4} sm={4} md={2}  className="d-flex input-tablet inventario">
                        <MDBInput
                            id="red_cantidad"
                            wrapperClass="mb-2"
                            label="Cantidad"
                            name="red_cantidad"
                            autoFocus ={true}
                            type={"number"}
                            min={"1"}
                            ref={ref}
                            disabled ={formRecuentoDetalle.art_upc.length>0?false:true}
                            onChange={onChangeRed_detail}
                            value={formRecuentoDetalle.art_descripcion.length>0?formRecuentoDetalle.red_cantidad:""}
                            onKeyDown={(e) =>
                              handleKeyPress(e, formRecuentoDetalle.red_cantidad)
                            }
                          />
                           {formRecuentoDetalle.art_upc.length>0 ?<img src={ADD_IMAGE}  namebtn="red_cantidad" className="src-image-2" alt="..." onClick={(e)=>{handleKeyPress(e, formRecuentoDetalle.red_cantidad,"btn");}}/>:<img src={ADD_IMAGE} className="src-image-2" alt="..." />}
                        </Col>
                        {window.innerWidth<=611?<Col xs={12} sm={12} md={5} className="input-tablet">
                        <MDBInput
                            id="art_descripcion"
                            wrapperClass="mb-2"
                            label="Descripción del artículo"
                            name="art_descripcion"
                            disabled={true}
                            onChange={onChangeRed_detail}
                            value={formRecuentoDetalle.art_descripcion}
                          />
                        </Col>:null}
                        <Col className="modal-add-inventario datatable-factura css_datatable1">
                        <DATATABLE_COLUMNS_RENCUENTO  enableTab={enableTab} dataRecuentoDetalle ={dataRecuentoDetalle} handleSaveRow={handleSaveRow} deleteRow={deleteRow}/>
                        </Col>
                    </Row> 
                    </Col>
                  </Row> 
                  
                </>}   
                </>
            </MDBModalBody>
            <MDBModalFooter>
            {isTabItems?<>
              <Row>
                <Col xs={12} className="text-center">
                <MDBBtn color="danger" onClick={() => {setTabItems(false)}}>
                Cerrar
              </MDBBtn>
                </Col>
              </Row>
            </>:<>
            <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
                <Col xs={12} className="text-center">
                 {isSaveI ? <Label className="success-label" >Guardado</Label> : ""}
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => {toggle(false);fetchRecuento();setPrintI(false);}}>
                Cerrar
              </MDBBtn>
              {basicModalEditRe?<MDBBtn onClick={() => ( toggleSaveEncabezado())}>
                        Guardar
                      </MDBBtn>:              <MDBBtn onClick={() => ( toggleSave())} disabled={loading}>
                Guardar
              </MDBBtn>}

            </>}

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ApartadoModal = ({
  props,
  dataapartadoDetalle,
  propsDCDetail,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  onChange,
  onChangeap_detail,
  handleKeyPress,
  onBlurs,
  error,
  error_upc,
  isSaveI,
  deleteRow,
  setOBJapartadoDetalle,
  fetchDCapartado,
  update_apd_apartado_detalle_row,
  toggleSaveEncabezado,
  dataClientes,
  selectCliente,
  formClientes
}) => {
  const [isOpenPanelCliente, setPanelCliente] = useState(false);
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#fff',
      borderColor: '#9e9e9e',
      minHeight: '30px',
      height: '30px',
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: '30px',
      padding: '0 6px'
    }),

    input: (provided, state) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorSeparator: state => ({
      display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: '30px',
    }),
  };
  var enableTab = true
  if(props.ap_docn.length>0 && props.ap_fecha.length>0){
    enableTab = false
  }
  const ref = useRef(null);
  if (propsDCDetail.art_descripcion.length>0) {
      // ref.current.focus();
   }

var subtotal=0;
var itbms =0;
var total = 0;

dataapartadoDetalle.map((row,i)=>{
  subtotal = Number(subtotal) + Number((Number(row.dcd_cantidad)*Number(row.dcd_precio)));
  itbms = Number(itbms) + Number(row.dcd_itbms);
  total = Number(subtotal)+Number(itbms);
  return null
})

const handleSaveRow = ({
  exitEditingMode,
  row,
  values
}) => {

if(basicModalEdit){
  update_apd_apartado_detalle_row({
    dcd_cantidad:values.dcd_cantidad,
    dcd_id:row.original.dcd_id, 
    dcd_itbms:Number((Number(values.dcd_cantidad)*Number(row.original.dcd_precio))*Number(row.original.art_itbm_compra)),
    dcd_total: Number((Number(values.dcd_cantidad)*Number(row.original.dcd_precio))*(1+Number(row.original.art_itbm_compra))),
  },row.original.apd_identificador)
  exitEditingMode();
}
else{
  dataapartadoDetalle[row.index] = {
      art_upc:row.original.art_upc,
      art_descripcion: row.original.art_descripcion,
      art_itbm_compra:row.original.art_itbm_compra,
      dcd_articulo:row.original.dcd_articulo,
      dcd_cantidad: values.dcd_cantidad,
      dcd_itbms: ((Number(values.dcd_cantidad)*Number(row.original.dcd_precio))*Number(row.original.art_itbm_compra)).toFixed(2),
      dcd_precio: values.dcd_precio,
      dcd_total: ((Number(values.dcd_cantidad)*Number(row.original.dcd_precio))*(1+Number(row.original.art_itbm_compra))).toFixed(2),
    };

    setOBJapartadoDetalle([...dataapartadoDetalle]);
    exitEditingMode();
}
};

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size="fullscreen" className="modal-full-large">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Apartado</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => {toggle(false);fetchDCapartado()}}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {isOpenPanelCliente?<> 
              <Col xs={12}>
              <MDBBtn className="btn-close" color="none" onClick={() => {setPanelCliente(false)}}></MDBBtn>
              </Col>
              <Col className="modal-add-inventario">
              <MaterialReactTable 
                muiTableBodyRowProps={({row}) => ({
                  onClick: () => {
                    selectCliente(row.original)
                  }
                  // selected: selectCliente[row],
                  // sx: {
                  //   cursor: 'pointer'
                  // }
                })} 
                state={{
                  selectCliente
                }}
                      // enableEditing={true}
                      // editDisplayMode="cell"
                      // enableRowActions={true}
                      positionActionsColumn="last"
                      // onEditingRowSave={handleSaveRow}
                      enableGlobalFilter={true} 
                      muiTableBodyRowformFactura={({ row }) => {
                        return {
                          sx: {
                            backgroundColor:
                              row.original.fac_fecha_procesado !== "0000-00-00 00:00:00"
                                ? "rgba(219, 237, 220, 0.78)"
                                : "",
                            fontWeight: "bold",
                          },
                        };
                      }}
                      globalFilterFn="contains"
                      enableFullScreenToggle={false}
                      // styles={customStyles}
                      enableDensityToggle={false}
                      positionGlobalFilter="left"
                      columns={COLUMNS_LISTA_CLIENTE()}
                      data={ dataClientes}
                      enableTopToolbar={true}
                      muiTableContainerformFactura={{
                        sx: {
                          maxHeight: "290px",
                        },
                      }}
                    />
                  </Col></>:<>             <form>
                <Row>
                  <Col>
                  <MDBInput
                      id="cli_ruc"
                      wrapperClass="mb-4"
                      label="CLIENTE"
                      name="cli_ruc"
                      value={formClientes.cli_nombre + " " +formClientes.cli_dv}
                      disabled={true}
                    />
                    <img src={SEARCH_IMAGE} className="src-image" alt="..." onClick={()=>{setPanelCliente(true);}}/>
                  </Col>
                  <Col xs={12}>
                    <MDBInput
                      id="dc_descripcion"
                      wrapperClass="mb-4"
                      label="Descripcion"
                      name="dc_descripcion"
                      onChange={onChange}
                      defaultValue={props.dc_descripcion}
                      autoFocus ={true}
                    />
                  </Col>
                </Row>
              </form>
              <Row >
              <Col xs={8}>
                    <Label className="error-label-inventario">
                      - {error_upc}
                    </Label>
                  </Col>
              <Col xs={4} className="text-end">
                {
                  basicModalEdit?<MDBBtn className="btn-update-header" onClick={() => ( toggleSaveEncabezado())}>
                  Actualizar encabezado
                </MDBBtn>:null
                }
                  
                  </Col>
                  <Col xs ={12}>
                    <Row>
                    <Col xs={2}>
                  <MDBInput
                      id="art_upc"
                      wrapperClass="mb-4"
                      label="Codigo"
                      name="art_upc"
                      onChange={onChangeap_detail}
                      value={propsDCDetail.art_upc}
                      disabled={enableTab}
                      onKeyDown={(e) =>{
                        handleKeyPress(e, props.dcd_articulo);
                      }
                      }
                    />
                  </Col>
                  <Col xs={6}>
                  <MDBInput
                      id="art_descripcion"
                      wrapperClass="mb-4"
                      label="Descripcion articulo"
                      name="art_descripcion"
                      onChange={onChangeap_detail}
                      value={propsDCDetail.art_descripcion}
                      disabled ={propsDCDetail.art_upc.length>0?false:true}
                    />
                  </Col>
                  <Col xs={2}>
                  <MDBInput
                      id="dcd_precio"
                      wrapperClass="mb-4"
                      label="Precio"
                      name="dcd_precio"
                      autoFocus ={true}
                      type={"number"}
                      onChange={onChangeap_detail}
                      value={propsDCDetail.dcd_precio}
                      disabled= {propsDCDetail.art_upc.length>0?false:true}
                    />
                  </Col>
                  <Col xs={2}>
                  <MDBInput
                      id="dcd_cantidad"
                      wrapperClass="mb-4"
                      label="Cantidad"
                      name="dcd_cantidad"
                      type={"number"}
                      min={"1"}
                      ref={ref}
                      disabled ={propsDCDetail.art_upc.length>0?false:true}
                      onChange={onChangeap_detail}
                      value={propsDCDetail.dcd_cantidad}
                      onKeyDown={(e) =>
                        handleKeyPress(e, propsDCDetail.dcd_cantidad)
                      }
                    />
                  </Col>
                <Col className="modal-add-inventario">
                <MaterialReactTable
                globalFilterFn="contains"
                enableEditing = {true}
                editDisplayMode="cell" 
                enableRowActions= {true}
                positionActionsColumn = 'last'
                onEditingRowSave={handleSaveRow}
          muiTableBodyRowProps={({row}) => {
            return ({
            sx: {
               backgroundColor: row.original.dc_fecha_procesado !== "0000-00-00 00:00:00" ? 'rgba(219, 237, 220, 0.78)' : '',
               fontWeight: 'bold',
            }
          })
        }}
            enableFullScreenToggle={false}
            styles={customStyles}
            enableDensityToggle={false}
            positionGlobalFilter="left"
            columns={COLUMNS_DC_COMPRA_DETALLE(deleteRow,onBlurs)}
            data={enableTab?[]:dataapartadoDetalle}
            enableTopToolbar={false}
            muiTableContainerProps={{
              sx: {
                maxHeight: '290px'
              }
            }}
          />
                </Col>


              </Row>
              <Row className="mt-3">
                  <Col xs={6}>
                  </Col>
                <Col xs={2}>
                <MDBInput
                 className="input-iventario-totales"
                      id="dcd_i_subtotal"
                      wrapperClass="mb-4"
                      label="SUBTOTAL"
                      name="dcd_i_subtotal"
                      autoFocus ={true}
                      value={
                        enableTab?[]:subtotal.toFixed(2)
                      }
                      disabled={true}
                    />
                </Col>
                <Col xs={2}>
                <MDBInput
                 className="input-iventario-totales"
                      id="dcd_i_itbms"
                      wrapperClass="mb-4"
                      label="ITBMS"
                      name="dcd_i_itbms"
                      autoFocus ={true}
                      value={
                        enableTab?[]:itbms.toFixed(2)
                      }
                      disabled={true}
                    />
                  </Col>
                  <Col xs={2}>
                  <MDBInput
                  className="input-iventario-totales"
                      id="dcd_i_total"
                      wrapperClass="mb-4"
                      label="TOTAL"
                      name="dcd_i_total"
                      autoFocus ={true}
                      value={                 enableTab?[]:total.toFixed(2)
                      }
                      disabled={true}
                    />
                  </Col>
                    </Row>
                  </Col>
   
                </Row></>}
 
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
                <Col xs={12} className="text-center">
                 {isSaveI ? <Label className="success-label" >Guardado</Label> : ""}
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => {toggle(false);fetchDCapartado();}}>
              <MDBIcon fas icon="ban" className="me-1 class-btn-factura d-flex"  />      Cerrar
              </MDBBtn>
              {basicModalEdit?"":              <MDBBtn onClick={() => ( toggleSave())}>
              <MDBIcon fas icon="save" className="me-1 class-btn-factura d-flex"  />    Guardar
              </MDBBtn>}

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ListaCajas= ({
  dataCajas,
  isOpen,
  toggle,
  setCajaData,
  setCajaN
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={"xl"} className={window.innerWidth<=611?"modal-fiscal-login":""}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Seleccione la caja</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody>
              <Row className="caja-selectorr">
                  <Col xs={12}>
                    <Row>
                      <Col className="caja-info" xs={12} sm={12} lg={5}>
                        <Row>
                          <Col xs={3}>
                            <div className="caja-main-icon">
                              <i className="fa-solid fa-cash-register"></i>
                            </div>
                          </Col>
                          <Col xs={9}>
                            <div>
                                <h2>Selección de caja</h2>
                                <p>Elige la caja con la que deseas trabajar</p>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col clclassNameass="caja-options col-btn-reportes" xs={12} sm={12} lg={7}>
                        <Row> 
                          {/* <Col > */}
                            {dataCajas.map((data)=>{
                              return <Col xs={6} className="d-flex"> <button className="caja-option active mt-2" type="button" onClick={()=>{setCajaData(data);setCajaN(data.caj_id);toggle(false)}}>
                            <div className="caja-option-icon">
                                <i className="fa-solid fa-cash-register"></i>
                            </div>
                            <div>
                                <h3>{data.caj_descripcion}</h3>
                                {/* <span>Caja principal</span> */}
                            </div>
                        </button></Col>
                            })}
                          {/* </Col> */}
                        </Row>

                      </Col>
                    </Row>


                  </Col>
                </Row>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ListaClienteModal = ({
  dataCliente,
  isOpen,
  toggle,
  selectCliente,
  setModalAddCliente,
  setErrorCliente,
  setFormClientes,
  usr_id,
  delete_cliente
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":""}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Clientes</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
            <Col className="modal-add-inventario datatable-factura css_datatable1">
              <MaterialReactTable 
                muiPaginationProps={{
                  showRowsPerPage: false,
                }}
                muiTableBodyRowProps={({row}) => ({
                  sx: {
                    backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                    fontWeight: "bold",
                    },
                  })} 
                  renderEmptyRowsFallback={() => (
                    <Container fluid>
                      <Row>
                        <Col xs={12} className="col-no-record label-no-record-fiscal">
                          <Label className="label-no-record">No hay registros que mostrar</Label>
                        </Col>
                      </Row>
                    </Container>
                  )}
                  displayColumnDefOptions={{
                      "mrt-row-actions": {
                        header: "OPCIONES",
                        size: window.innerWidth <= 370?80:70,
                        maxSize: window.innerWidth <= 370?80:70,
                        minSize: window.innerWidth <= 370?80:70,
                        muiTableBodyCellProps: {
                          sx: {
                            display: "flex",
                            justifyContent: "center",
                            // width:"70px",
                            alignItems: "center",
                            "& button": {
                              marginX:  window.innerWidth <= 430 ? "5px" : "1px", 
                            },
                          },
                        },
                        muiTableHeadCellProps: {
                          sx: {
                            textAlign: "center",
                          },
                        },
                      },
                    }}
                      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth<=611?"68dvh":"57dvh"} }}
                      initialState={{
                          pagination: { pageSize: 30, pageIndex: 0 }
                        }}
                      renderRowActions={({ row,table }) => {
                      return <Box className="d-flex">
                        <IconButton onClick={() => {selectCliente(row.original)}}>
                          <AddBoxIcon/>
                        </IconButton>
                        <IconButton onClick={() => { delete_cliente({row:row.original});}}  color="error">
                          <DeleteIcon/>
                        </IconButton>
                        </Box>
                      }}

                      renderTopToolbarCustomActions={({ table }) => (
                        <Box>
                          <IconButton
                            onClick={() => {
                              setModalAddCliente(true);
                              setErrorCliente("");
                              setFormClientes(STATES_FAC_FACTURA({staneName:"formClientes",usr_id}));
                              toggle(false);
                            }}
                          >
                            <AddBoxIcon />
                          </IconButton>
                        </Box>
                      )}
                      layoutMode="grid" 
                       positionGlobalFilter="left"
                      enableEditing={true}
                      enableColumnActions={true}
                      editDisplayMode="cell"
                      enableBottomToolbar={true}
                      enableFullScreenToggle={false}
                      enableDensityToggle={false}
                      enableTopToolbar={true}
                      enableRowActions={true}
                      positionActionsColumn="last"
                      enablePagination={true}
                      enableSorting={false}
                      enableFilters={true} 
                      enableStickyHeader={true}
                      columns={COLUMNS_LISTA_CLIENTE()}
                      data={ dataCliente}
                    />
                  </Col>
            </MDBModalBody>
            <MDBModalFooter>
                <MDBBtn  onClick={() => toggle(false)} color="danger">
                    Cerrar
                </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const ListaOrden = ({
  dataListOrdenes,
  isOpen,
  toggle,
  selectItemOrdenes,
  checkOrden,
  usr_perfil,
  deleteRow
}) => {
  var total = 0;
  var cantidad_ordenes_dia = 0;
  var cantidad_ordenes_ayer = 0;
  var cantidad_colchas_dia = 0;
  var cantidad_piezas_procesadas = 0;
   var cantidad_colchas_procesadas = 0;
  var cantidad_piezas_procesadas_dia = 0;
   var cantidad_colchas_procesadas_dia = 0;
  var cantidad_piezas_sin_procesar = 0;
   var cantidad_colchas_sin_procesar = 0;
  var dinero_procesado = 0;
  var dinero_procesado_dia = 0;
  var dinero_sin_procesar = 0;
  var dinero_colchas_dia = 0;
  const {dataCompania} = useContext(StoreContext);
  dataListOrdenes.map((data,i)=>{
    if(moment(new Date()).format("YYYY-MM-DD") === moment(data.ord_fecha).format("YYYY-MM-DD")){
     cantidad_colchas_dia = cantidad_colchas_dia + Number(data.ordd_cantidad_canasta)
     dinero_colchas_dia = dinero_colchas_dia +  Number(data.ordd_total_canasta)
    }

    if(moment(new Date()).format("YYYY-MM-DD") === moment(data.ord_fecha).format("YYYY-MM-DD")){
      cantidad_ordenes_dia = cantidad_ordenes_dia + Number(data.ordd_cantidad_piezas)
    }

    if(data.ord_flag ==="1" && data.ordd_entregado !=="2"){
      cantidad_colchas_procesadas = cantidad_colchas_procesadas + Number(data.ordd_cantidad_canasta)
    }
    if(data.ord_flag ==="1" && data.ordd_entregado !=="2"){
      cantidad_piezas_procesadas = cantidad_piezas_procesadas + Number(data.ordd_cantidad_piezas)
    }

    if(data.ord_flag ==="1" && data.ordd_entregado !=="2" ){
      dinero_procesado = dinero_procesado + Number(data.ordd_total_piezas)+ Number(data.ordd_total_canasta)
    }

    if(data.ord_flag ==="1" && moment(new Date()).format("YYYY-MM-DD") === moment(data.ord_fecha_procesado).format("YYYY-MM-DD")){
      cantidad_colchas_procesadas_dia = cantidad_colchas_procesadas_dia + Number(data.ordd_cantidad_canasta)
    }

    if(data.ord_flag ==="1" && moment(new Date()).format("YYYY-MM-DD") === moment(data.ord_fecha_procesado).format("YYYY-MM-DD")){
      cantidad_piezas_procesadas_dia = cantidad_piezas_procesadas_dia + Number(data.ordd_cantidad_piezas)
    }

    if(data.ord_flag ==="1" && moment(new Date()).format("YYYY-MM-DD") === moment(data.ord_fecha_procesado).format("YYYY-MM-DD")){
      dinero_procesado_dia = dinero_procesado_dia + Number(data.ordd_total_piezas)+ Number(data.ordd_total_canasta)
    }
   
    if(data.ord_flag ==="0" && data.ordd_entregado !=="2" ){
      cantidad_colchas_sin_procesar = cantidad_colchas_sin_procesar + Number(data.ordd_cantidad_canasta)
    }

    if(data.ord_flag ==="0" && data.ordd_entregado !=="2"){

      cantidad_piezas_sin_procesar = cantidad_piezas_sin_procesar + Number(data.ordd_cantidad_piezas)
    }
    // console.log( moment(new Date()).format("YYYY-MM-DD"));
    // console.log(moment(data.ord_fecha).format("YYYY-MM-DD"));
          if(data.ord_identificador ==="20260821234249226"){
        console.log(data)
      }
    // if (moment(new Date()).subtract(1, "day").format("YYYY-MM-DD") === moment(data.ord_fecha).format("YYYY-MM-DD")){
    //   if(data.ord_identificador ==="20260821234249226"){
    //     console.log(data)
    //   }
    //   cantidad_ordenes_ayer = cantidad_ordenes_ayer + Number(data.ordd_cantidad_piezas)
    // }


    const ayer = moment().subtract(1, "day");

    const entroAyer = moment(data.ord_fecha).isSame(ayer, "day");

    const quedoSinProcesarAyer = !data.ord_fecha_procesado ||   data.ord_fecha_procesado === "0000-00-00 00:00:00" || moment(data.ord_fecha_procesado).isAfter(ayer, "day");

    if ( entroAyer &&  quedoSinProcesarAyer && data.ordd_entregado !== "2" ) {
  cantidad_ordenes_ayer = cantidad_ordenes_ayer + Number(data.ordd_cantidad_piezas)
    }

    if(data.ord_flag ==="0" && data.ordd_entregado !=="2"){
      dinero_sin_procesar = dinero_sin_procesar + Number(data.ordd_total_piezas)+ Number(data.ordd_total_canasta)
    }

    if(data.ordd_entregado !=="2")
    {
       total = total  + Number(data.ordd_total_piezas)+ Number(data.ordd_total_canasta)
    }
  })
  console.log(cantidad_ordenes_ayer)
  // console.log(cantidad_ordenes_dia)
    function cerrar_modal(){
     toggle(false);
    };
      var orders = dataListOrdenes.filter((data,i)=>{
    if(data.ordd_entregado !=="2")
      return data
  })

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":"modal-xl-w"}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Lista de ordenes</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
              {usr_perfil==="4"?            <Col className="modal-add-inventario datatable-factura">
              {dataListOrdenes !==undefined?
              <DATATABLE_COLUMNS_LISTA_ORDENES selectItemOrdenes ={selectItemOrdenes} dataListOrdenes ={dataListOrdenes}  deleteRow={deleteRow}/>
              :<Label>Cargando...</Label>}
            </Col>:<Col className="modal-add-inventario datatable-factura  css_datatable1">
              {dataListOrdenes !==undefined?
              <DATATABLE_COLUMNS_LISTA_ORDENES_NORMAL selectItemOrdenes ={selectItemOrdenes} checkOrden ={checkOrden} orders ={orders} deleteRow={deleteRow} togle={ cerrar_modal}/>
              :<Label>Cargando...</Label>}
            </Col>}
           {dataCompania.com_lavanderia==="1"?           <Row className="mt-3">
            <Col  xs ={4} sm={2}>
             <MDBInput
                className="input-iventario-totales"
                id="ordd_cantidad"
                wrapperClass="mb-2"
                label="PIEZAS PROC."
                name="ordd_cantidad"
                value={ cantidad_piezas_procesadas}
                disabled={true}
              />
            </Col>
            <Col  xs ={4} sm={2}>
             <MDBInput
                className="input-iventario-totales"
                id="ordd_cantidad"
                wrapperClass="mb-2"
                label="PIEZAS SIN PROC."
                name="ordd_cantidad"
                value={ cantidad_piezas_sin_procesar}
                disabled={true}
              />
            </Col>
                         <Col xs={4} sm={2}>
             <MDBInput
                className="input-iventario-totales"
                id="ordd_cantidad"
                wrapperClass="mb-2"
                label="PIEZAS DE AYER"
                name="ordd_cantidad"
                value={ Number(cantidad_ordenes_ayer)}
                disabled={true}
              />
            </Col>
            <Col xs={4} sm={2}>
             <MDBInput
                className="input-iventario-totales"
                id="ordd_cantidad"
                wrapperClass="mb-2"
                label="PIEZAS DEL DIA + AYER"
                name="ordd_cantidad"
                value={ Number(cantidad_ordenes_dia) + Number(cantidad_ordenes_ayer)}
                disabled={true}
              />
            </Col>
            <Col  xs ={4} sm={2}>
             <MDBInput
                className="input-iventario-totales"
                id="ordd_cantidad"
                wrapperClass="mb-2"
                label="POR COBRAR"
                name="ordd_cantidad"
                value={ "$"+new Decimal(dinero_procesado).toFixed(2)}
                disabled={true}
              />
            </Col>

            <Col  xs ={4} sm={2}>
             <MDBInput
                className="input-iventario-totales"
                id="ordd_cantidad"
                wrapperClass="mb-2"
                label="DINERO SIN PROC."
                name="ordd_cantidad"
                value={"$"+ new Decimal(dinero_sin_procesar).toFixed(2)}
                disabled={true}
              />
            </Col>

            <Col xs={4} sm={2}>
             <MDBInput
                className="input-iventario-totales"
                id="fcd_i_subtotal"
                wrapperClass="mb-2"
                label="INGRESOS POR COBRAR"
                name="fcd_i_subtotal"
                value={ "$"+new Decimal(total).toFixed(2)}
                disabled={true}
              />
            </Col>

            
            <Col xs={4} sm={2} className="mt-2">
             <MDBInput
                className="input-iventario-totales"
                id="ordd_cantidad"
                wrapperClass="mb-2"
                label="PIEZAS PROC. DEL DIA"
                name="ordd_cantidad"
                value={ cantidad_piezas_procesadas_dia}
                disabled={true}
              />
            </Col>
            <Col xs={4} sm={2} className="mt-2">
             <MDBInput
                className="input-iventario-totales"
                id="fcd_i_subtotal"
                wrapperClass="mb-2"
                label="DINERO PROC. DEL DIA"
                name="fcd_i_subtotal"
                value={ "$"+new Decimal(dinero_procesado_dia).toFixed(2)}
                disabled={true}
              />
            </Col>
            
            <Col xs={4} sm={2} className="mt-2">
             <MDBInput
                className="input-iventario-totales"
                id="ordd_cantidad"
                wrapperClass="mb-2"
                label="CANASTAS DEL DIA"
                name="ordd_cantidad"
                value={ cantidad_colchas_dia}
                disabled={true}
              />
            </Col>
            <Col xs={4} sm={2} className="mt-2">
             <MDBInput
                className="input-iventario-totales"
                id="ordd_cantidad"
                wrapperClass="mb-2"
                label="DINERO CANASTAS DEL DIA"
                name="ordd_cantidad"
                value={ "$"+new Decimal(dinero_colchas_dia).toFixed(2) }
                disabled={true}
              />
            </Col>
            <Col xs={4} sm={2} className="mt-2">
             <MDBInput
                className="input-iventario-totales"
                id="ordd_cantidad"
                wrapperClass="mb-2"
                label="CANASTA PROCESADAS"
                name="ordd_cantidad"
                value={ cantidad_colchas_procesadas}
                disabled={true}
              />
            </Col>
            <Col xs={4} sm={2} className="mt-2">
             <MDBInput
                className="input-iventario-totales"
                id="ordd_cantidad"
                wrapperClass="mb-2"
                label="CANASTA PROC. DEL DIA"
                name="ordd_cantidad"
                value={ cantidad_colchas_procesadas_dia}
                disabled={true}
              />
            </Col>
                        <Col xs={4} sm={2} className="mt-2">
             <MDBInput
                className="input-iventario-totales"
                id="ordd_cantidad"
                wrapperClass="mb-2"
                label="CANASTAS SIN PROCE."
                name="ordd_cantidad"
                value={ cantidad_colchas_sin_procesar}
                disabled={true}
              />
            </Col>
            </Row> :null}

            </MDBModalBody>
            <MDBModalFooter>
              { dataCompania.com_lavanderia==="1"?  <MDBBtn  onClick={() => post_pdf_cxc(orders)} color="success">
                    Imprimir
                </MDBBtn>:null}
                <MDBBtn  onClick={() => toggle(false)} color="danger">
                    Cerrar
                </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const ListaCotizacion = ({
  dataListCotizacion,
  isOpen,
  toggle,
  selectItemCotizacion
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":"modal-xl-w"}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Lista de cotizaciones</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
            <Col className="modal-add-inventario datatable-factura  css_datatable1">
              {dataListCotizacion !==undefined?
              <DATATABLE_COLUMNS_LISTA_COTIZACION selectItemCotizacion ={selectItemCotizacion} dataListCotizacion ={dataListCotizacion}/>
              :<Label>Cargando...</Label>}
                  </Col>
            </MDBModalBody>
            <MDBModalFooter>
                <MDBBtn  onClick={() => toggle(false)} color="danger">
                    Cerrar
                </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ListaCreditos = ({
  dataListCreditos,
  isOpen,
  toggle,
  selectCreditosDetalle,
  dataListCreditoDetalle,
  dataListCreditoPago,
  selectCreditosPago,
  addPago,
  deleteCrePago,
  crp_monto_p,
  ObjFrmPago,
  onChangeDropdown,
  formDropDownFPago,
  onChange,
  formListPago,
  setAddFPago,
  dataListpago,
  setFormDropDownFPago,
  setFormListPago,
  setDatalistpago,
  deleteRowFpago,
  setFormPagoCredito,
  formPagoCredito,
  printAbono,
  printFac,
  dataBodyCredito,
  dataCompania_f,
  isPrinting,
  setPrintI
}) => {
  var componentRef = useRef();
  const [isCreditoDetalle, setCreditoDetalle] = useState(false);
  const [isCreditoPago, setCreditoPago] = useState(false);
  const [crp_fac_identificador, setFacIdentificador] = useState(false);
  const [crp_cliente, setCrpCliente] = useState(false);
  const [cli_name, setCliName] = useState(false);
  const [isAbonos, toggleAbonos] = useState(false);
  const { dataCompania } = useContext(StoreContext);
  ObjFrmPago = ObjFrmPago.filter((data)=>{
    if(data.frm_code !=="01"){
      return data
    }
    return null

  })
  const [monto_adeudado, setMontoAdeudado] = useState(false);
  const handleSaveRow = ({
    exitEditingMode,
    row,
    values
  }) => {

  dataListpago[row.index] = {
    list_fpago: row.original.list_fpago,
    list_fpagoName:row.original.list_fpagoName,
    list_identificador:row.original.list_identificador,
    list_monto:Number(values.list_monto).toFixed(2)
  };
    // setFormClientes({...formClientes,cli_limitc:(Number(formClientes.cli_limitc)+Number(row.original.list_monto))-Number(values.list_monto)})
    setDatalistpago([...dataListpago]);
    exitEditingMode();
  }

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className="modal-fiscal">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{isCreditoDetalle?"Facturas":isCreditoPago?"Pagos":"Créditos"}</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
              {isPrinting? 
                  <Row>
                  <Col xs={10}></Col>
                  <Col xs={2} >
                    <IconButton className="float-right-btn"
                      onClick={() => {
                        setPrintI(false);
                        // setFormCotCotizacion(STATES_COT_COTIZACION({staneName:"formCotCotizacion"}));
                        // setOBJCotizacionDetalle([]);
                      }}>
                      <CloseIcon />
                    </IconButton>
                    <ReactToPrint
                            trigger={() => <button className="btn-print">  <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                            content={() => componentRef} />
                  </Col>
                  <Col xs={12} >
                    <ComponentToPrintsPDFCredito
                      ref={el => (componentRef = el)}
                      form={dataBodyCredito}
                      dataCompania={dataCompania_f}
                      com_logo_cot2={dataCompania.com_logo_cot2}
                      com_logo_cot3={dataCompania.com_logo_cot3}
                    />
                  </Col>
                </Row>
                  :<Col className="modal-add-inventario datatable-factura  css_datatable1">
              {
              isCreditoDetalle?<>
              <Row>
                <Col xs={12} md={4} className="mb-2">
                  <MDBInput
                  id="cli_name"
                  label="Nombre del cliente"
                  name="cli_name"
                  value={cli_name}
                  disabled={true}/>
                </Col>
                <Col xs={6} md={3} className="mb-2">
                  <MDBInput
                  id="cli_total"
                  label="Total"
                  name="cli_total"
                  value={monto_adeudado}
                  disabled={true}/>
                </Col>
                <Col xs={6} md={3} className="mb-2">
                  <MDBInput
                  id="cli_monto_adeudado"
                  label="Saldo adeudado"
                  name="cli_monto_adeudado"
                  value={(Number(monto_adeudado)-Number(crp_monto_p)).toFixed(2)}
                  disabled={true}/>
                </Col>
                <Col xs={12}>
                  <DATATABLE_COLUMNS_LISTA_CREDITOS_DETALLE setFormPagoCredito={setFormPagoCredito} formPagoCredito={formPagoCredito} setCreditoDetalle={setCreditoDetalle} selectCreditosPago ={selectCreditosPago} 
                    dataListCreditoDetalle ={dataListCreditoDetalle} setCreditoPago={setCreditoPago}  setFacIdentificador={setFacIdentificador} printFac={printFac}/>
                </Col>
              </Row>
              </>
              :isCreditoPago? 
              <Row>
                <Col xs={12} md={12}>
               <Label className="fw-bold">
               Factura: {formPagoCredito.fac_id.toString().padStart(10, "0")}
                </Label> 
                </Col>
                <Col xs={4} md={2} className="mb-2">
                <MDBInput
                id="crt_saldo"
                label="Total"
                name="crt_saldo"
                type={"number"}
                min={"1"}
                max={10000}
                step='0.01'
                value={Number(formPagoCredito.crd_monto).toFixed(2)}
                disabled={true}
              />
                </Col>
                <Col xs={4} md={2} className="mb-2">
                <MDBInput
                id="crp_saldo"
                label="Abonado"
                name="crp_saldo"
                type={"number"}
                min={"1"}
                max={10000}
                step='0.01'
                value={Number(formPagoCredito.crp_monto).toFixed(2)}
                disabled={true}
              />
                </Col>
                <Col xs={4} md={2} className="mb-2">
                <MDBInput
                id="crp_saldo"
                label="Saldo"
                name="crp_saldo"
                type={"number"}
                min={"1"}
                max={10000}
                step='0.01'
                value={(Number(formPagoCredito.crd_monto)-Number(formPagoCredito.crp_monto)).toFixed(2)}
                disabled={true}
              />
                </Col>
                <Col xs={4} md={2} className="d-flex">
                {isAbonos?<>
                  <MDBBtn  onClick={() => toggleAbonos(false)} color="success" className="d-flex">
                    <MDBIcon fas icon="credit-card" className="me-1 class-btn-factura d-flex"  />  Pago
                </MDBBtn>

                </>   :<MDBBtn  onClick={() => toggleAbonos(true)} color="danger" className="d-flex">
                    <MDBIcon fas icon="plus-circle" className="me-1 class-btn-factura d-flex"  />  Abonos
                </MDBBtn>}
                
                </Col>
                <Col xs={8} md={3} className="d-flex">
                {isAbonos? <>
                  <MDBBtn  onClick={() => printAbono({type:"recibo"})} className="d-flex">
                    <MDBIcon fas icon="print" className="me-1 class-btn-factura d-flex"  /> Recibo 
                </MDBBtn>
                
                <MDBBtn  onClick={() => printAbono({type:"pdf"})} className="d-flex pdf-btn-margin">
                    <MDBIcon fas icon="file-pdf" className="me-1 ml-3 class-btn-factura d-flex"  /> PDF
                </MDBBtn>
                </>
                :null}
               
                </Col>
                <Col xs={1}>
                <IconButton className="float-right-btn"
                      onClick={() => {
                        setCreditoDetalle(true);
                        setCreditoPago(false);
                        setFormDropDownFPago({
                          frm_id: "",
                          frm_code:"",
                          frm_descripcion: ""
                        });
                        setFormListPago(STATES_FAC_FACTURA({staneName:"formListPago"}))
                        setDatalistpago([])
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                </Col>
                <Col xs={12} className="mt-4">
                {isAbonos?<Row>
                  <Col   xs={12} className="mt-4">
                {  <DATATABLE_COLUMNS_LISTA_CREDITOS_PAGO dataListCreditoPago ={dataListCreditoPago} deleteRow={deleteCrePago}/>}
                </Col>
                </Row>:<Row>
                <Col xs={7} md={4}>
                <Select
                options={ObjFrmPago}
                onChange={onChangeDropdown}
                controlShouldRenderValue={formDropDownFPago.frm_descripcion.length>0?true:false}
                maxMenuHeight={180}
              />
                </Col>
                <Col xs={5} md={4} className="d-flex">
                    <MDBInput
                      id="list_monto"
                      wrapperClass="mb-4"
                      label="* Monto"
                      name="list_monto"
                      onChange={onChange}
                      value={formListPago.list_monto}
                      type="number"
                      disabled={formDropDownFPago.frm_descripcion.length>0?false:true}/>
                      {formDropDownFPago.frm_descripcion.length>0 && Number(formListPago.list_monto)>0 ?<img src={ADD_IMAGE} className="src-image-addpago" alt="..." onClick={()=>{setAddFPago(); }}/>:<img src={ADD_IMAGE} className="src-image-addpago" alt="..." 
                  />}
                </Col>
                <Col xs={6}>
                <MDBBtn onClick={() =>  {addPago({crp_fac_identificador,crp_cliente});toggleAbonos(true)}} color = "success" disabled={dataListpago.length>0?false:true}> 
                Guardar abono
              </MDBBtn>
                </Col>
                <Col xs={12} className="datatable-factura">
                <DATATABLE_COLUMNS_LISTA_FPAGO dataListpago ={dataListpago} handleSaveRow ={handleSaveRow} deleteRow ={deleteRowFpago}/>
                </Col>
                </Row>}
                
                </Col>
              </Row>
              :dataListCreditos !==undefined?
              <DATATABLE_COLUMNS_LISTA_CREDITOS setCliName ={setCliName} setFormPagoCredito={setFormPagoCredito} formPagoCredito={formPagoCredito} setMontoAdeudado={setMontoAdeudado} selectCreditosDetalle ={selectCreditosDetalle} dataListCreditos ={dataListCreditos} setCreditoDetalle={setCreditoDetalle}   setCrpCliente ={setCrpCliente}/>
              :<Label>Cargando...</Label>
              
              }
                  </Col>}

            </MDBModalBody>
            <MDBModalFooter>              
              {isAbonos && <MDBBtn  onClick={() => {setCreditoDetalle(true); setCreditoPago(false);setFormDropDownFPago({frm_id: "",frm_code:"",frm_descripcion: ""});setFormListPago(STATES_FAC_FACTURA({staneName:"formListPago"}));setDatalistpago([])}} color="danger">Cerrarrr</MDBBtn>}
              {isCreditoDetalle && <MDBBtn  onClick={() => {setCreditoDetalle(false);setFormDropDownFPago({frm_id: "",frm_code:"",frm_descripcion: ""});setFormListPago(STATES_FAC_FACTURA({staneName:"formListPago"}));setDatalistpago([]);}} color="danger">Cerrar</MDBBtn>}
              <MDBBtn  onClick={() => toggle(false)} color="danger">Cerrar</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

  const ListaFacModal = ({dataListCopia,formAnulacion,isOpen,toggle,selectItemFCopia,usr_print,setFormAnulacion,dataListAnulacion,onChangeAnulacion, errorAnulacion, toggleSaveAnular, nota_credito}) => {
    var flag_qty_caracteres = false;
    const [isOpenDetailCopia, SetOpenDetailCopia] = useState(false);
    const [dataCopiaFactura, setDataCopiaFactura] = useState([]);
    const [fac_selected, setfacSelected] = useState("");
    const [istabAnular, setTabAnular] = useState(false);
    const [istabNC, setTabAnularNC] = useState(false);
    const deleteRow = (row) => {
      if (dataCopiaFactura.factura.length > 1) {
        var value = dataCopiaFactura.factura.filter((data, i) => {
          if (i !== row.index) return data;
        });
        setDataCopiaFactura(value);
        setDataCopiaFactura({ ...dataCopiaFactura, factura: value });
      }
    };

    async function getDetailItem({ data }) {
      setfacSelected(data.fac_id);
      var response = await get_list_itemsFactura_detail(data.fac_identificador);
      setDataCopiaFactura({
        factura: response.factura,
        fPago: response.fPago,
      });
    }
    if(formAnulacion.motivo_anulacion.length>=10){
      flag_qty_caracteres = true;
    }
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":""} className={window.innerWidth<=611?"fullscreen":"modal-fiscal modal-xl-w"} >
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Lista de facturas</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody>
              {istabAnular?                 <Row>
                  <Col xs={12} sm={4}>
                    <MDBInput
                    className="input-iventario-totales"
                    id="docNumber"
                    wrapperClass="mb-4"
                    label="# de factura"
                    name="docNumber"
                    disabled={true}
                    autoFocus={true}
                    value={formAnulacion.fac_id.toString().padStart(10, "0")}/>
                  </Col>
                  <Col xs={12} sm={8}>
                    <MDBTextArea 
                      className="input-iventario-totales"
                      id="motivo_anulacion"
                      wrapperClass="mb-4"
                      // minlength ={40}
                      label="* Descripción de la anulación"
                      name="motivo_anulacion"
                      autoFocus={true}
                      onChange={onChangeAnulacion}
                      value={formAnulacion.motivo_anulacion}
                      rows={2}/>
                  </Col>
                </Row>:
              istabNC?<> {dataCopiaFactura.factura !==undefined ? PANEL_VIEW_INVOICE({fac_selected,dataCopiaFactura,nc_flag:true,deleteRow}):<Col xs={12} className="text-center"><Label>No hay registros que mostrar</Label></Col>}
               </>:
              isOpenDetailCopia && dataCopiaFactura.factura !==undefined?<Col className="modal-add-inventario datatable-factura  css_datatable1">
              <Row>
                <Col xs={12}>
                  {dataListCopia !==undefined?
                  <Row>
                    <Col xs={12} sm={4} className="input-tablet">
                     <MDBInput
                          id="fac_selected"
                          wrapperClass="mb-2"
                          label="# Factura "
                          name="fac_selected"
                          value={fac_selected.toString().padStart(10, "0")}
                          disabled={true}
                        />
                    </Col>
                    <Col xs={12} sm={4} className="input-tablet">
                     <MDBInput
                          id="fac_tipodocumento"
                          wrapperClass="mb-2"
                          label="Tipo de documento"
                          name="fac_tipodocumento"
                          // (row.fac_tipodocumento ==="01" && row.fac_anulacion==="0") ?"FACTURA DE OPERACIÓN INTERNA":row.fac_anulacion==="1"?"ANULADO":"NOTA DE CRÉDITO REFERENTE A UNA FE: " +row.fac_doc_nc 
                          value={(dataCopiaFactura.factura[0].fac_tipodocumento ==="01" && dataCopiaFactura.factura[0].fac_anulacion==="0")?"FACTURA DE OPERACIÓN INTERNA":dataCopiaFactura.factura[0].fac_anulacion==="1"?"ANULADO : "+dataCopiaFactura.factura[0].fac_motivo_anulacion:(dataCopiaFactura.factura[0].fac_tipodocumento==="0"||dataCopiaFactura.factura[0].fac_tipodocumento==="")?"ERROR: NO SE ENVIO LA FACTURA":"NOTA DE CRÉDITO FE: " +dataCopiaFactura.factura[0].fac_doc_nc }
                          disabled={true}
                        />
                    </Col>
                    
                    <Col xs={12} sm={4} className="input-tablet">
                        <MDBInput
                          id="cli_nombre"
                          wrapperClass="mb-2"
                          label="Cliente"
                          name="cli_nombre"
                          value={dataCopiaFactura.factura[0].cli_nombre}
                          disabled={true}
                        />
                    </Col>
                    <Col xs={12} sm={4} className="input-tablet">
                        <MDBInput
                          id="cli_ruc"
                          wrapperClass="mb-2"
                          label="RUC"
                          name="cli_ruc"
                          value={"RUC "+dataCopiaFactura.factura[0].cli_ruc +" DV " + dataCopiaFactura.factura[0].cli_dv}
                          disabled={true}
                        />
                    </Col>
                    <Col xs={12} className="input-tablet mb-2">
                      <MDBTextArea 
                          id="fac_text_invoice"
                          name="fac_text_invoice"
                          label="* Información complementaria"
                          disabled={true}
                          rows={3}
                          value={dataCopiaFactura.factura[0].fac_text_invoice}
                        />
                    </Col>
                    {dataCopiaFactura.fPago.map((data)=>{
                      return <>
                        <Col xs={8} className="input-tablet">
                          <MDBInput
                            id="fcfp_fpago"
                            wrapperClass="mb-2"
                            label="Forma de pago"
                            name="fcfp_fpago"
                            value={data.fcfp_fpago}
                            disabled={true}
                          />
                      </Col>
                      <Col xs={4} className="input-tablet">
                          <MDBInput
                            id="fcfp_monto"
                            wrapperClass="mb-2"
                            label="Monto"
                            name="fcfp_monto"
                            value={Number(data.fcfp_monto).toFixed(2)}
                            disabled={true}
                          />
                      </Col>
                      </>
                    })}
                    <Col xs={12} className="mb-2 mt-2 css_datatable1">
                      <MaterialReactTable 
                        muiTableBodyRowProps={({ row }) => {
                          return {
                            sx: {
                              backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                              fontWeight: "bold",
                            },
                          };
                        }}
                        muiPaginationProps={{
                          showRowsPerPage: false
                        }}
                              renderEmptyRowsFallback={() => (
                                <Col xs={12} className="col-no-record">
                                  <Label className="label-no-record">No hay registros que mostrar</Label>
                                </Col>
                              )}
                      muiSearchTextFieldProps={{
                        placeholder: "Buscar",
                      }}
                        globalFilterFn="contains"
                        muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "39dvh":"32dvh":"45dvh" : "55dvh" } }}//370w 420w, 611w, desktop
                        layoutMode="grid"
                        enableEditing={false}
                        enableColumnActions={false}
                        editDisplayMode="modal"
                        enableBottomToolbar={false}
                        enableTopToolbar={true}
                        enableRowActions={false}
                        positionActionsColumn="last"
                        enablePagination={false}
                        enableSorting={false}
                        enableFilters={true}
                        enableStickyHeader={true}
                        enableFullScreenToggle={false}
                        enableDensityToggle={false}
                        positionGlobalFilter="left"
                        columns={COLUMNS_FAC_FACTURA_DETALLE_COPIA()}
                        data={ dataCopiaFactura.factura}
                        />
                    </Col>
                    <Col sm={3} md={3}>
                    </Col>
                     <Col xs={4} sm={3} md={3}>
                      <MDBInput
                        className="input-iventario-totales"
                        id="fcd_i_subtotal"
                        wrapperClass="mb-2"
                        label="SUBTOTAL"
                        name="fcd_i_subtotal"
                        value={new Decimal(dataCopiaFactura.factura[0].fac_total).minus(new Decimal(dataCopiaFactura.factura[0].fac_itbms)).toFixed(2)}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={4} sm={3} md={3}>
                      <MDBInput
                        className="input-iventario-totales"
                        id="fcd_i_itbms"
                        wrapperClass="mb-2"
                        label="ITBMS"
                        name="fcd_i_itbms"
                        value={new Decimal(dataCopiaFactura.factura[0].fac_itbms).toFixed(2)}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={4} sm={3} md={3}>
                      <MDBInput
                        className="input-iventario-totales"
                        id="fcd_i_total"
                        wrapperClass="mb-2"
                        label="TOTAL"
                        name="fcd_i_total"
                        value={new Decimal(dataCopiaFactura.factura[0].fac_total).toFixed(2)}
                        disabled={true}
                      />
                    </Col>

                  </Row>:<Label>Cargando...</Label>}
                </Col>
              </Row>

              </Col>:<>
              <Col xs={12}>
                <div className="datatable-legend">
                    <span className="legend-item">
                        <i className="bi bi-printer"></i>
                        Imprimir recibo
                    </span>
                    <span className="legend-item">
                        <i className="bi bi-file-earmark-pdf text-danger"></i>
                      Imprimir PDF
                    </span>
                    <span className="legend-item">
                        <i className="bi bi-search"></i>
                        Ver factura
                    </span>
                    <span className="legend-item">
                        <i className="bi bi-trash text-danger"></i>
                        Anular
                    </span>
                    <span className="legend-item">
                        <i className="bi bi-file-earmark-text text-success"></i>
                        Nota crédito
                    </span>
                    <span className="legend-item">
                        <i className="bi bi-receipt text-primary"></i>
                        DGI
                    </span>
                </div>
              </Col>
              <Col xs={12} className="modal-add-inventario datatable-factura  css_datatable1 mt-3">
                {dataListCopia !==undefined?<MaterialReactTable 
                    initialState={{
                      pagination: { pageSize: 30, pageIndex: 0 },
                    }}
                    muiPaginationProps={{showRowsPerPage: false}}
                    renderEmptyRowsFallback={() => (
                      <Col xs={12} className="col-no-record">
                        <Label className="label-no-record">No hay registros que mostrar</Label>
                      </Col>
                    )}
                      muiSearchTextFieldProps={{
                        placeholder: "Buscar",
                      }}
                    globalFilterFn="contains"
                    muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "54dvh":"54dvh":"71dvh" : "45dvh" } }}//370w 420w, 611w, desktop
                       
                    muiTableBodyRowProps={({ row }) => {
                    return {
                      sx: {
                        backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                        fontWeight: "bold",
                      },
                    };
                  }}
                  enableStickyHeader={true}
                  positionActionsColumn="last"
                  enableGlobalFilter={true} 
                  enableFullScreenToggle={false}
                  enableColumnActions={false}
                  enableEditing={false}
                  enableRowActions={false}
                  enablePagination={true}
                  enableSorting={false}
                  enableFilters={true} 
                  enableDensityToggle={false}
                  positionGlobalFilter="left"
                  enableTopToolbar={true}
                  columns={COLUMNS_LISTA_FACTURA(selectItemFCopia,getDetailItem,SetOpenDetailCopia,usr_print,setTabAnular, setFormAnulacion,setTabAnularNC)}
                  data={ dataListCopia}
                />:<Label>Cargando...</Label>}
              </Col>
              </>
                
                }


            </MDBModalBody>
            <MDBModalFooter>
              {istabAnular &&<><Label className="error-label">{errorAnulacion.length > 0 ? errorAnulacion : ""}</Label>
                {((usr_print ==="1"||usr_print ==="4") && formAnulacion.fac_recibo==="1" &&  istabAnular ===true) &&<MDBBtn onClick={() =>  {toggleSaveAnular({tipo:formAnulacion.fac_recibo,print_mode:"1"}); setTabAnular(false)}} disabled={flag_qty_caracteres>0?false:true}>
                    Anular PDF
                </MDBBtn>}
                
                {((usr_print ==="2"||usr_print ==="4" || formAnulacion.fac_recibo==="0") &&  istabAnular ===true)&&<MDBBtn onClick={() =>  {toggleSaveAnular({tipo:formAnulacion.fac_recibo,print_mode:"2"}); setTabAnular(false)}} disabled={flag_qty_caracteres>0?false:true}>
                    Anular Recibo
                </MDBBtn>}</>
              }
              
              {istabNC&&<><Label className="error-label">{errorAnulacion.length > 0 ? errorAnulacion : ""}</Label>
              {((usr_print ==="1"||usr_print ==="4") && formAnulacion.fac_recibo==="1")&&<MDBBtn onClick={() =>  nota_credito({tipo:"1",items:dataCopiaFactura,print_mode:"1"})} disabled={dataCopiaFactura.factura !== undefined?false:true}>
                  NC PDF
              </MDBBtn>}
              {(usr_print ==="2"||usr_print ==="4" || formAnulacion.fac_recibo==="0")&&<MDBBtn onClick={() =>  nota_credito({tipo:"1",items:dataCopiaFactura,print_mode:"2"})} disabled={dataCopiaFactura.factura !== undefined?false:true}>
                  NC Recibo
              </MDBBtn>}</>
              }


               {isOpenDetailCopia && dataCopiaFactura.factura !==undefined? <MDBBtn  onClick={() => {setDataCopiaFactura([]);SetOpenDetailCopia(false)}} color="danger">Cerrar</MDBBtn>:null} 
               {(isOpenDetailCopia ===false && istabAnular===false && istabNC===false)&& <MDBBtn  onClick={() => {toggle(false)}} color="danger">Cerrar</MDBBtn>} 
               {istabAnular ===true?<MDBBtn  onClick={() => {setTabAnular(false)}} color="danger">Cerrar</MDBBtn>:null} 
               {istabNC ===true?<MDBBtn  onClick={() => {setTabAnularNC(false)}} color="danger">Cerrar</MDBBtn>:null} 
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ModalReporteZ = ({props,isOpen,state,handleOnChangeDate,toggle,printReceipt,usr_print}) => {
    const [tabsActive, setTabsActive] = useState("tab1");
    const {usr_nombre,caja_n,dataCompania} = useContext(StoreContext);
    const handleTabClick = (value) => {
    if (value === tabsActive) {
      return;
    }
    setTabsActive(value);
  };
  var componentRef = useRef();
  const [isPrinting, setPrintI] = useState(false);
  async function print_pdf_informe() {
    var body ={
      props:props,
      dataCompania:dataCompania,
      usr_nombre,
      usr_caja:caja_n,
      state,
      url:IP_IMAGENES
    }
    
      post_pdf_informex(body);
      setTimeout(() => {
        const startDate = moment(state[0].startDate).format("DD-MM-YYYY");
        const endDate   = moment(state[0].endDate).format("DD-MM-YYYY");
        const nombreArchivo = `informedeventas_${startDate}_${endDate}.pdf`;
        window.open(IP + "/sys_mbo/uploads/pdf/informe/" +nombreArchivo +"?" + moment().format("YYYYMMDDHHmmss"), "_blank");
      }, 1000);
  }


  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className="modal-fiscal">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Informe  de ventas</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody>
            <Row>
                  <Col xs={12} md={5} className={"text-center col-calendar"} >
                <DateRange 
                  onChange={handleOnChangeDate}
                  showSelectionPreview={false}
                  moveRangeOnFirstSelection={false}
                  editableDateInputs={true}
                  dateDisplayFormat="yyyy-MM-dd-"
                  ranges={state}
                  maxDate={new Date()} 
                  direction="vertical"
                  className="box-calendar"/>
              </Col>
              <Col xs={12} md={7}>
                <MDBTabs className="d-flex-none custom-navs">
                  <Row>
                    <Col xs={12} className="mt-3">
                      <Row>
                        <Col xs={6} >
                          <MDBTabsLink onClick={() => handleTabClick("tab1")} active={tabsActive === "tab1"} className="padding-2porc">
                            <MDBIcon fas icon="money-bill" className="me-2" /> Registro de ventas 
                          </MDBTabsLink>
                        </Col>
                        <Col xs={6}>
                          <MDBTabsLink onClick={() => handleTabClick("tab2")} active={tabsActive === "tab2"} className="padding-2porc">
                            <MDBIcon fas icon="cash-register" className="me-2" /> Anulaciones
                          </MDBTabsLink>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </MDBTabs>
                <MDBTabsContent>
                  <MDBTabsPane show={tabsActive === "tab2"}>
                    <Row  className="overflow-anulacion">
                        {props.length !==0?props.anulacion.map((data)=>{
                          return <>
                          <Col xs={12}>
                          <Row>
                            <Col xs={4} md={3} className="input-tablet mt-2">
                              <MDBInput
                                id="fac_id"
                                wrapperClass="mb-2"
                                label="# Factura"
                                name="fac_id"
                                value={data.fac_id.toString().padStart(10, "0")}
                                disabled={true}/>
                            </Col>
                            <Col xs={4} md={3}className="input-tablet  mt-2">
                                <MDBInput
                                  id="fac_fecha"
                                  wrapperClass="mb-1"
                                  label="Fecha factura"
                                  name="fac_fecha"
                                  value={data.fac_fecha}
                                  disabled={true}/>
                            </Col>
                            <Col xs={4} md={3}className="input-tablet mt-2">
                                <MDBInput
                                  id="fac_date_anulacion"
                                  wrapperClass="mb-1"
                                  label="Fecha anulación"
                                  name="fac_date_anulacion"
                                  value={data.fac_date_anulacion}
                                  disabled={true}/>
                            </Col>
                            <Col xs={4}  md={3}className="input-tablet mt-2">
                                <MDBInput
                                  id="fcd_total"
                                  wrapperClass="mb-1"
                                  label="Monto"
                                  name="fcd_total"
                                  value={Number(data.fcd_total).toFixed(2)}
                                  disabled={true}/>
                            </Col>
                            <Col xs={8} className="input-tablet mt-2">
                                <MDBInput
                                  id="fac_motivo_anulacion"
                                  wrapperClass="mb-1"
                                  label="Motivo de la anulación"
                                  name="fac_motivo_anulacion"
                                  value={data.fac_motivo_anulacion}
                                  disabled={true}/>
                            </Col>  
                            </Row></Col>
                
                            </>
                          }):""}
                      </Row>
                  </MDBTabsPane>
                  <MDBTabsPane show={tabsActive === "tab1"}>
                    <Row className="overflow-anulacion">
                        {props.length !==0?props.montos_fpago.map((data)=>{
                        return <>
                          <Col xs={9} className="input-tablet mt-1">
                            <MDBInput
                              id="fcfp_fpago"
                              wrapperClass="mb-1"
                              label="Forma de pago"
                              name="fcfp_fpago"
                              value={data.fcfp_fpago}
                              disabled={true}/>
                          </Col>
                          <Col xs={3} className="input-tablet mt-1">
                            <MDBInput
                              id="fcfp_monto"
                              wrapperClass="mb-1"
                              label="Monto"
                              name="fcfp_monto"
                              value={Number(data.fcfp_monto).toFixed(2)}
                              disabled={true} />
                          </Col>
                        </>
                      }):""}
                      {dataCompania.com_lavanderia==="1"?<>         
                      <Col xs={6} className="input-tablet mt-1">
                        <MDBInput
                          id="ordd_cantidad"
                          wrapperClass="mb-1"
                          label="PIEZAS PROCESADAS"
                          name="ordd_cantidad"
                         value={Number(props.ordenes?.[0]?.ordd_cantidad ?? 0)}
                          disabled={true} />
                      </Col>     
                      <Col xs={6} className="input-tablet mt-1">
                        <MDBInput
                          id="fcfp_monto"
                          wrapperClass="mb-1"
                          label="DINERO POR COBRAR"
                          name="fcfp_monto"
                         value={Number(props.ordenes?.[0]?.ordd_totalp ?? 0).toFixed(2)}
                          disabled={true} />
                      </Col>   <Col xs={6} className="input-tablet mt-1">
                        <MDBInput
                          id="fcfp_fpago"
                          wrapperClass="mb-1"
                          label="PIEZAS SIN PROCESAR"
                          name="fcfp_fpago"
                            value={props.ordenes?.[0]?.ordd_cantidad2 ?? 0}
                          disabled={true}/>
                      </Col>
                      <Col xs={6} className="input-tablet mt-1">
                        <MDBInput
                          id="ordd_cantidad"
                          wrapperClass="mb-1"
                          label="DINERO SIN PROCESAR"
                          name="ordd_cantidad"
                         value={props.ordenes?.[0]?.ordd_totalp2 ?? 0}
                          disabled={true} />
                      </Col>
                         <Col xs={6} className="input-tablet mt-1">
                        <MDBInput
                          id="fcfp_fpago"
                          wrapperClass="mb-1"
                          label="PIEZAS DEL DIA"
                          name="fcfp_fpago"
                            value={props.ordenes?.[0]?.ordd_cantidad_dia ?? 0}
                          disabled={true}/>
                      </Col>
                      
                      <Col xs={6} className="input-tablet mt-1">
                        <MDBInput
                          id="ordd_cantidad"
                          wrapperClass="mb-1"
                          label="INGRESOS POR COBRAR"
                          name="ordd_cantidad"
                         value={props.ordenes?.[0]?.ordd_total ?? 0}
                          disabled={true} />
                      </Col>


                      <Col xs={6} className="input-tablet mt-1">
                        <MDBInput
                          id="ordd_cantidad"
                          wrapperClass="mb-1"
                          label="PIEZAS PROC. DIA"
                          name="ordd_cantidad"
                         value={props.ordenes?.[0]?.piezas_proc_dia ?? 0}
                          disabled={true} />
                      </Col>

                                            <Col xs={6} className="input-tablet mt-1">
                        <MDBInput
                          id="ordd_cantidad"
                          wrapperClass="mb-1"
                          label="DINERO PROCESADAS DEL DIA"
                          name="ordd_cantidad"
                         value={props.ordenes?.[0]?.dinero_proc_dia ?? 0}
                          disabled={true} />
                      </Col>

                      <Col xs={6} className="input-tablet mt-1">
                        <MDBInput
                          id="ordd_cantidad"
                          wrapperClass="mb-1"
                          label="CANASTAS DEL DIA"
                          name="ordd_cantidad"
                         value={props.ordenes?.[0]?.canasta_dia ?? 0}
                          disabled={true} />
                      </Col>
                      
                      <Col xs={6} className="input-tablet mt-1">
                        <MDBInput
                          id="ordd_cantidad"
                          wrapperClass="mb-1"
                          label="DINERO CANASTAS DEL DIA"
                          name="ordd_cantidad"
                         value={props.ordenes?.[0]?.dinero_canasta_dia ?? 0}
                          disabled={true} />
                      </Col>
            
                      <Col xs={6} className="input-tablet mt-1">
                        <MDBInput
                          id="ordd_cantidad"
                          wrapperClass="mb-1"
                          label="CANASTAS PROCESADAS"
                          name="ordd_cantidad"
                         value={props.ordenes?.[0]?.canasta_procesadas ?? 0}
                          disabled={true} />
                      </Col>
                                                              <Col xs={6} className="input-tablet mt-1">
                        <MDBInput
                          id="ordd_cantidad"
                          wrapperClass="mb-1"
                          label="CANASTAS PROCESADAS DEL DIA"
                          name="ordd_cantidad"
                         value={props.ordenes?.[0]?.canasta_procesada_dia ?? 0}
                          disabled={true} />
                      </Col>
                                                              <Col xs={6} className="input-tablet mt-1">
                        <MDBInput
                          id="ordd_cantidad"
                          wrapperClass="mb-1"
                          label="CANASTAS SIN PROCESAR"
                          name="ordd_cantidad"
                         value={props.ordenes?.[0]?.canasta_sin_procesar ?? 0}
                          disabled={true} />
                      </Col>
                      </>:null}
        
                    </Row>
                  </MDBTabsPane>
                </MDBTabsContent>
                
            </Col>
                      
                    <Col xs={12}><Label className="title-informe">TOTALES -  Fecha: {moment(state[0].startDate).format("YYYY-MM-DD")} - {moment(state[0].endDate).format("YYYY-MM-DD")}</Label></Col>
                    {props.length!==0?<>                    

                    <Col xs={6} className="input-tablet">
                      <MDBInput
                        id="crp_monto"
                        wrapperClass="mb-2"
                        label="Abonos a crédito"
                        name="crp_monto"
                        value={props.abonos.length !==0 ?Number(props.abonos[0].crp_monto).toFixed(2):"0.00"}
                        disabled={true}/>
                    </Col>
                    <Col xs={6} className="input-tablet">
                      <MDBInput
                        id="fcd_total"
                        wrapperClass="mb-2"
                        label="Ventas exento"
                        name="fcd_total"
                        value={props.exentos.length !==0 ?Number(props.exentos[0].fcd_total).toFixed(2):"0.00"}
                        disabled={true}/>
                    </Col>
                    <Col xs={8} className="input-tablet">
                      <MDBInput
                        id="usr_nombre"
                        wrapperClass="mb-2"
                        label="NOMBRE"
                        name="usr_nombre"
                        value={usr_nombre}
                        disabled={true}/>
                    </Col>
                    <Col xs={4} className="input-tablet">
                      <MDBInput
                        id="fac_caja"
                        wrapperClass="mb-2"
                        label="CAJA"
                        name="fac_caja"
                        value={caja_n}
                        disabled={true}/>
                    </Col>

                    <Col xs={6} className="input-tablet">
                      <MDBInput
                        id="montos_itbms"
                        wrapperClass="mb-2"
                        label="I.T.B.M.S"
                        name="montos_itbms"
                        value={props.montos_totales.length !==0 ?Number(props.montos_totales[0].fcd_itbms).toFixed(2):"0.00"}
                        disabled={true}/>
                    </Col>
                    <Col xs={6} className="input-tablet">
                      <MDBInput
                        id="montos_totales"
                        wrapperClass="mb-2"
                        label="Totales"
                        name="montos_totales"
                        value={props.montos_totales.length !==0 ?Number(props.montos_totales[0].fcd_total).toFixed(2):"0.00"}
                        disabled={true}/>
                    </Col>

                                        
                    </>:null

                      }
            </Row>
            </MDBModalBody>
           <MDBModalFooter>
            {!isPrinting && <>            {(usr_print ==="4"||usr_print ==="2"||usr_print ==="3")&& <MDBBtn onClick={() => {printReceipt()}} disabled={props.montos_totales?.length !== 0 ? false : true}>
                <MDBIcon fas icon="print" className="me-1" />      Recibo
              </MDBBtn>}</>}

              {!isPrinting && <MDBBtn onClick={() => {print_pdf_informe()}} disabled={props.montos_totales?.length !== 0 ? false : true}>
                <MDBIcon fas icon="file-pdf" className="me-1" />      PDF
              </MDBBtn> }
              
              <MDBBtn  onClick={() => {isPrinting?setPrintI(false):toggle(false)}} color="danger" className="d-flex">
              <MDBIcon fas icon="ban" className="me-1 class-btn-factura d-flex"  />  Cerrar
              </MDBBtn>

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ListaItemModal = ({
  props,
  usr_a_costo,
  isOpen,
  toggle,
  selectItem,
  isDetailItem,
  select_detail_articulo,
  isDetailOpen,
  formDetailItem,
  SetOpenDetailItem
}) => {
    const { dataCompania } = useContext(StoreContext);
   var existencia =0;
   if(isDetailItem){
  formDetailItem.bodegas((data)=>{
    existencia = existencia+Number(data.inv_qty)
  })
   }

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":""} className={window.innerWidth<=611?"fullscreen":"modal-fiscal modal-xl-w"}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Articulos</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => isDetailOpen?SetOpenDetailItem(false):toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
              <Row>
                {isDetailOpen?            <Col >
                <Row>
                  {ITEM_DETAIL_PANEL({SetOpenDetailItem,formDetailItem,existencia})}
                </Row>
                  </Col>:
                  <Col key ={"12345"} className="modal-add-inventario datatable-factura css_datatable1">
                    {props !==undefined?isDetailItem?"":<MaterialReactTable 
                          muiPaginationProps={{
                          showRowsPerPage: false,
                        }}
                    displayColumnDefOptions={{
                      
                      "mrt-row-actions": {
                        header: "OPCIONES",
                        size: window.innerWidth <= 370?75:55,
                        maxSize: window.innerWidth <= 370?75:55,
                        minSize: window.innerWidth <= 370?75:55,
                        muiTableBodyCellProps: {
                          sx: {
                            display: "flex",
                            justifyContent: "center",
                            width:"70px",
                            alignItems: "center",
                            "& button": {
                              marginX:  window.innerWidth <= 430 ? "4px" : "4px", 
                            },
                          },
                        },
                        muiTableHeadCellProps: {
                          sx: {
                            textAlign: "center",
                          },
                        },
                      },
                    }}
                      initialState={{
                          pagination: { pageSize: 30, pageIndex: 0 },
                          columnVisibility: { art_restaurante: dataCompania.com_restaurante==="1"?true:false,art_costo:usr_a_costo==="1"?true:false },
                        }}
                      muiTableBodyRowProps={({row}) => ({
                        sx: {
                          backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                        },
                      })} 
                        renderRowActions={({ row,table }) => {
                        return <Box className="width-box-delete-cotizacion mx-auto d-flex">
                          <IconButton onClick={() => {selectItem({art_upc:row.original.art_upc,barcode:false, modalItem:false})}}>
                            <AddBoxIcon/>
                          </IconButton>
                          <IconButton  onClick={()=>{select_detail_articulo({row:row.original});}}>
                            <SearchIcon/>
                          </IconButton>
                        </Box>
                        }}
                      globalFilterFn="contains"
                      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "64dvh":"67dvh":"70dvh" : "57dvh" } }}//370w 420w, 611w, desktop
                      layoutMode="grid" 
                      renderEmptyRowsFallback={() => <Col xs={12} className="col-no-record"><Label className="label-no-record">No hay registros que mostrar</Label></Col>}
                      enableEditing={false}
                      enableColumnActions={false}
                      editDisplayMode="cell"
                      enableBottomToolbar={true}
                      enableTopToolbar={true}
                      enableDensityToggle={false}
                      enableRowActions={true}
                      positionActionsColumn="last"
                      enablePagination={true}
                      enableSorting={false}
                      enableFilters={true} 
                      enableStickyHeader={true}
                      columns={COLUMNS_LISTA_ITEMS()}
                      data={ props}
                    />:<Label>Cargando...</Label>}
                  </Col>}

              </Row>

            </MDBModalBody>
           <MDBModalFooter>
              <MDBBtn  onClick={() => {isDetailOpen?SetOpenDetailItem(false):toggle(false)}} color="danger" className="d-flex">
              <MDBIcon fas icon="ban" className="me-1 class-btn-factura d-flex"  />  Cerrar
              </MDBBtn>

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const PagarModal = ({
  deleteRow,
  setDatalistpago,
  deleteFpago,
  formDropDownFPago,
  setAddFPago,
  onChangeDropdown,
  dataListpago,
  formListPago,
  ObjFrmPago,
  isOpen,
  toggle,
  toggleSave,
  toggleSavePr,
  onChange,
  total,
  error,
  formClientes,
  setFormClientes,
  loading,
  usr_print,
  dataGarantia,
  formGarantia,
  setFormGarantia,
  onChangePagar,
  dataRetencion,
  setFormRetencion,
  formRetencion,
  dataFacturaDetalle,
  formFactura,
  onChangeFac,
  setFormListPago,
  usr_perfil
}) => { 
        const { dataCompania } = useContext(StoreContext);

  var flag_descuento = false;
  dataFacturaDetalle.map((data)=>{
    if(data.fcd_descuento_number!==""){
      flag_descuento = true;
    }
  })
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClickGarantia = (event) => {
  setAnchorEl(event.currentTarget);
};
const handleCloseGarantia = () => {
  setAnchorEl(null);
};
  var monto =0;
  var showLimitC=false;
  if(formClientes.cli_credito==="1"){
    showLimitC= true;
  }
  dataListpago.map((data,i)=>{
    monto = monto + Number(data.list_monto)
    // if(formClientes.cli_credito==="1"){
    //   showLimitC= true;
    // }
    return null
  });
    const handleSaveRow = ({
      exitEditingMode,
      row,
      values
    }) => {

    dataListpago[row.index] = {
      list_fpago: row.original.list_fpago,
      list_fpagoName:row.original.list_fpagoName,
      list_identificador:row.original.list_identificador,
      list_monto:Number(values.list_monto).toFixed(2)
    };
      setFormClientes({...formClientes,cli_limitc:(Number(formClientes.cli_limitc)+Number(row.original.list_monto))-Number(values.list_monto)})
      setDatalistpago([...dataListpago]);
      exitEditingMode();
    }
  
   const onKeyPressPagar = button => {
      if (button === "{enter}") setAddFPago();
    };

    const greekLayout = {
        theme: "hg-theme-default hg-layout-numeric numeric-theme",
        default: ["1 2 3", "4 5 6", "7 8 9", ". 0 {backspace}","{enter}"], 
        shift: ["{1Dolar} {5Dolar} {10Dolar}", "20Dolar 50Dolar 100Dolar", "& * (", "{shift} ) +"],
    }
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":""}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Cobrar</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody>
              {window.innerWidth<=611?<>
              <Row>
                <Col xs={12} className="d-ruby col-btn-reportes">
                  {ObjFrmPago.map((data,i)=>{
                      return <MDBBtn  disabled = {(total - monto)===0?true:false} onClick={() => {
                        if (formDropDownFPago.frm_descripcion.length > 0) {
                          setFormListPago({...formListPago,
                            list_monto: ((total - monto)>=0?(total - monto):0).toFixed(2)
                          });
                          if(formListPago.list_monto.length>0){
                      setAddFPago();
                          }
                          
                        } else {
                          onChangeDropdown(data);
                        }
                      }} color={formDropDownFPago.frm_code === data.frm_code?"primary":"secondary"} className="btn-payment btn-reporte_x " >
                      {data.icon==="yappy"?<img src={YAPPY_IMAGE} className="yappy-img-payment" alt="..."/>:<MDBIcon fas icon={data.icon} className="me-1 class-btn-factura d-flex"  />}
                      <span >{ data.label}</span> 
                     
                    </MDBBtn>
                  })}
                </Col>
                <Col xs={12}>
                  <Row>
                    <Col xs={6} className="d-flex input-tablet">
                      <MDBInput
                        id="list_monto"
                        wrapperClass="mb-4"
                        label="* Monto"
                        name="list_monto"
                        onChange={onChange}
                        value={formListPago.list_monto}
                        type="number"
                        disabled={formDropDownFPago.frm_descripcion.length>0?false:true}/>
                        {formDropDownFPago.frm_descripcion.length>0 && Number(formListPago.list_monto)>0 ?<img src={ADD_IMAGE} className="src-image-addpago2" alt="..." onClick={()=>{setAddFPago();}}/>:<img src={ADD_IMAGE} className="src-image-addpago2" alt="..."  />}
                    </Col>
                    <Col xs={6}>
                      {showLimitC ?<MDBInput
                        id="cli_limitc"
                        wrapperClass="mb-4"
                        label="Límite de crédito"
                        name="cli_limitc"
                        value={Number(formClientes.cli_limitc).toFixed(2)}
                        type="number"
                        disabled={true}
                      />:null}</Col>
                    <Col xs={6} className="d-flex">
                      {dataGarantia.length>1?<>   
                        <MDBBtn className="btn-waranty d-flex"
                          id="basic-button"
                          aria-controls={open ? 'basic-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? 'true' : undefined}
                          onClick={handleClickGarantia}
                          disabled ={false}>
                          <Row className="mx-auto">
                            <Col xs={6} className="text-center d-flex">
                              <img src={AWARD} className="pagar-garantia-btn" alt="..."/>
                              Garantía
                            </Col>
                          </Row>
                        </MDBBtn>
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleCloseGarantia}
                          MenuListProps={{
                            'aria-labelledby': 'basic-button',
                          }}>
                            { dataGarantia.map((data,i)=>{
                              return <>
                          <MenuItem onClick={()=>{setFormGarantia({gr_name:formGarantia.gr_name+"\n"+data.gr_name,gr_descripcion:formGarantia.gr_descripcion+"\n"+data.gr_descripcion}); handleCloseGarantia()}}>{data.gr_name}</MenuItem>
                              </>

                            })}
                        </Menu>
                              </>:""}
                            {dataCompania.com_version==="2" && <img src={EXIT_IMAGE} className="src-image-w2" alt="..." 
                        onClick={()=>{      setFormGarantia({gr_name:"",gr_descripcion:""})}}/>}  
                    </Col>
                  </Row>
                </Col>

                <Col xs={12}>
                  <Row>
                    <Col xs ={12}>
                      <Row>
                        {dataRetencion.length>1?<Col xs={12}>
                        <Label className="padd-mar-u l-retencion">
                          {"Retención :" +formClientes.re_desc}
                          </Label>
                        
                        </Col>:""   }
                        {dataGarantia.length>1?<Col xs={12}>
                        <Label className="padd-mar-u l-retencion">
                          {"Garantia :"+formGarantia.gr_name}
                          </Label>
                        
                        </Col>:""   }
                      </Row>
                    </Col>
                    <Col xs ={12} className="input-tablet">
                      <Row>
                        <Col xs={12}>
                        <MDBTextArea
                            id="fac_text_invoice"
                            name="fac_text_invoice"
                            label="Información complementaria"
                            rows={3}
                            onChange={onChangeFac}
                            value={formFactura.fac_text_invoice}
                          />
                          </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                  <Col xs={12} className="datatable-factura mt-2">
                  <DATATABLE_COLUMNS_LISTA_FPAGO dataListpago ={dataListpago} handleSaveRow ={handleSaveRow} deleteRow ={deleteRow}/>
                  </Col>
                 <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
                  <Col xs={12} className="mt-3 col-btn-reportes2">
                    <MDBInput
                      className="input-iventario-totales btn-reporte_x text-end"
                      id="total"
                      wrapperClass="mb-2"
                      label="TOTAL"
                      name="total"
                      autoFocus={true}
                      value={Number(total).toFixed(2)}
                      disabled={true}
                    />

                  
                    <MDBInput
                      className="input-iventario-totales btn-reporte_x text-end"
                      id="monto"
                      wrapperClass="mb-2"
                      label="PAGADO"
                      name="monto"
                      autoFocus={true}
                      value={monto.toFixed(2)}
                      disabled={true}
                    />
                
                    <MDBInput
                      className="input-iventario-totales btn-reporte_x text-end"
                      id="faltante"
                      wrapperClass="mb-2"
                      label="FALTANTE"
                      name="faltante"
                      autoFocus={true}
                      value={((total - monto)>=0?(total - monto):0).toFixed(2)}
                      disabled={true}
                    />
                  
                    <MDBInput
                      className="input-iventario-totales btn-reporte_x text-end"
                      id="vuelto"
                      wrapperClass="mb-2"
                      label="VUELTO"
                      name="vuelto"
                      autoFocus={true}
                      value={((monto- total)<=0?0:(monto- total)).toFixed(2)}
                      disabled={true}
                    />
                  </Col>

                </Row>
              </>:<><Row>
                <Col xs={4} className="d-ruby min-height-235">

                {
                  
                  ObjFrmPago.map((data,i)=>{
                    return <MDBBtn   disabled = {(total - monto)===0?true:false} onClick={() => {
  if (formDropDownFPago.frm_descripcion.length > 0) {
    setFormListPago({...formListPago,
      list_monto: ((total - monto)>=0?(total - monto):0).toFixed(2)
    });
    if(formListPago.list_monto.length>0){
setAddFPago();
    }
    
  } else {
    onChangeDropdown(data);
  }
}} color={formDropDownFPago.frm_code === data.frm_code?"primary":"secondary"} className="btn-payment">
                    {data.icon==="yappy"?<img src={YAPPY_IMAGE} className="yappy-img-payment" alt="..."/>:<MDBIcon fas icon={data.icon} className="me-1 class-btn-factura d-flex"  />}
                    
                     <span className="pl-16">{ data.text}</span> 
                    </MDBBtn>
                  })
                }
                </Col>
                <Col xs={2}>
                <Row>
                  <Col xs={12} className="d-flex">
                  <MDBInput
                      id="list_monto"
                      wrapperClass="mb-4"
                      label="* Monto"
                      name="list_monto"
                      onChange={onChange}
                      value={formListPago.list_monto}
                      type="number"
                      disabled={formDropDownFPago.frm_descripcion.length>0?false:true}
                    />
                    {formDropDownFPago.frm_descripcion.length>0 && Number(formListPago.list_monto)>0 ?<img src={ADD_IMAGE} className="src-image-addpago2" alt="..." 
                      onClick={()=>{setAddFPago();}}
                      />:<img src={ADD_IMAGE} className="src-image-addpago2" alt="..." 
                      />}
                    </Col>
                  <Col xs={12}>
                    {showLimitC ?<MDBInput
                      id="cli_limitc"
                      wrapperClass="mb-4"
                      label="Límite de crédito"
                      name="cli_limitc"
                      value={Number(formClientes.cli_limitc).toFixed(2)}
                      type="number"
                      disabled={true}
                    />:null}</Col>
                  <Col xs={12} className="d-flex">
                  {dataGarantia.length>1?<>   
                      <MDBBtn 
                      className="btn-waranty d-flex"
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClickGarantia}
                        disabled ={false}>
                        <Row className="mx-auto">
                          <Col xs={12} className="text-center d-flex">
                          <img src={AWARD} className="pagar-garantia-btn" alt="..."/>
                          Garantía
                          </Col>
                        </Row>
                        </MDBBtn>
                              <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleCloseGarantia}
                                MenuListProps={{
                                  'aria-labelledby': 'basic-button',
                                }}>
                                  { dataGarantia.map((data,i)=>{
                                    return <>
                                <MenuItem onClick={()=>{setFormGarantia({gr_name:formGarantia.gr_name+"\n"+data.gr_name,gr_descripcion:formGarantia.gr_descripcion+"\n"+data.gr_descripcion}); handleCloseGarantia()}}>{data.gr_name}</MenuItem>
                                    </>

                                  })}
                              </Menu>
                              </>:""}
                              {dataCompania.com_version==="2" && <img src={EXIT_IMAGE} className="src-image-w2" alt="..." 
                        onClick={()=>{      setFormGarantia({gr_name:"",gr_descripcion:""})}}/>} 
                              </Col>
                </Row>
                </Col>
                <Col xs={6}>
                {formDropDownFPago.frm_descripcion.length>0 ?<Keyboard
                  // layoutName={state.layoutName}
                  onChange={onChangePagar}
                  onKeyPress={onKeyPressPagar}
                  layout= {greekLayout}
                  disabled={formDropDownFPago.frm_descripcion.length>0?false:true}
                  display={{"{enter}": "↵","{backspace}": "⌫",}}/>:null}
                </Col>
                <Col xs={12}>
                <Row>
                  <Col xs ={6}>
                  <Row>
                    {dataRetencion.length>1?                <Col xs={12}>
                    <Label className="padd-mar-u">
                      {"Retención :" +formClientes.re_desc}
                      </Label>
                    
                    </Col>:""   }
                    {dataGarantia.length>1?                <Col xs={12}>
                    <Label className="padd-mar-u">
                      {"Garantia :"+formGarantia.gr_name}
                      </Label>
                    
                    </Col>:""   }
                  </Row>
                  </Col>
                   <Col xs ={6}>
                   <Row>
                     <Col xs={12}>
                     <MDBTextArea
                        id="fac_text_invoice"
                        name="fac_text_invoice"
                        label="Información complementaria"
                        rows={3}
                        onChange={onChangeFac}
                        value={formFactura.fac_text_invoice}
                      />
                      </Col>
                   </Row>
                   </Col>
                </Row>
                </Col>
                <Col xs={12} className="datatable-factura mt-2">
                <DATATABLE_COLUMNS_LISTA_FPAGO dataListpago ={dataListpago} handleSaveRow ={handleSaveRow} deleteRow ={deleteRow}/>
                </Col>
                <Row className="mt-3">
                {/* <Col xs={1}></Col> */}
                  <Col xs={3}>
                    <MDBInput
                      className="input-iventario-totales"
                      id="total"
                      wrapperClass="mb-2"
                      label="TOTAL"
                      name="total"
                      autoFocus={true}
                      value={Number(total).toFixed(2)}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={3}>
                    <MDBInput
                      className="input-iventario-totales"
                      id="monto"
                      wrapperClass="mb-2"
                      label="MONTO PAGADO"
                      name="monto"
                      autoFocus={true}
                      value={monto.toFixed(2)}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={3}>
                    <MDBInput
                      className="input-iventario-totales"
                      id="faltante"
                      wrapperClass="mb-2"
                      label="FALTANTE"
                      name="faltante"
                      autoFocus={true}
                      value={((total - monto)>=0?(total - monto):0).toFixed(2)}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={3}>
                    <MDBInput
                      className="input-iventario-totales"
                      id="vuelto"
                      wrapperClass="mb-2"
                      label="VUELTO"
                      name="vuelto"
                      autoFocus={true}
                      value={((monto- total)<=0?0:(monto- total)).toFixed(2)}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
                </Row>
              </Row></>}

              
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn  onClick={() => toggle(false)} color="danger" className="d-flex btn-pagar">
              <MDBIcon fas icon="ban" className="me-1 class-btn-factura d-flex"  />  Cerrar
              </MDBBtn>
              {/* usr_print 1. pdf 2. recibo 3. recibo no fiscal 4. factura electronica PDF y RECIBO  tipo 0 => recibo, tipo 1 =>electronica	///1. administrador 2. vendedor 3. restaurante tablet 4. restaurante principal	 */}
              {/* {usr_print==="4"&&<><MDBBtn className="btn-pagar" onClick={() =>  (parseFloat(total) - parseFloat(monto.toFixed(2)))>0?null:toggleSave({tipo:"1",pdf:true,prefactura:false})} color = {(total - monto)>0?"warning":"success"} disabled={loading}>
                Factura E. PDF
              </MDBBtn>
              <MDBBtn className="btn-pagar" onClick={() =>  (parseFloat(total) - parseFloat(monto.toFixed(2)))>0?null:toggleSave({tipo:"1",pdf:false,prefactura:false})} color = {(total - monto)>0?"warning":"success"} disabled={loading}>
                Factura E. recibo
              </MDBBtn>
              </>} */}
              {(usr_print==="1" || usr_print==="4")&&<MDBBtn className="btn-pagar" onClick={() =>  (parseFloat(total) - parseFloat(monto.toFixed(2)))>0?null:toggleSave({tipo:"1",pdf:true,prefactura:false})} color = {(total - monto)>0?"warning":"success"} disabled={loading}>
                Factura E. PDF
              </MDBBtn>}
              {(usr_print==="2" || usr_print==="4")&&<MDBBtn className="btn-pagar" onClick={() =>  (parseFloat(total) - parseFloat(monto.toFixed(2)))>0?null:toggleSave({tipo:"1",pdf:false,prefactura:false})} color = {(total - monto)>0?"warning":"success"} disabled={loading}>
                Factura E. recibo
              </MDBBtn>}
              {(dataCompania.com_recibo_enabled==="1" && usr_perfil !=="4")&&<MDBBtn className="btn-pagar" onClick={() =>  (parseFloat(total) - parseFloat(monto.toFixed(2)))>0?null:toggleSave({tipo:"0",pdf:false,prefactura:false})} color = {(total - monto)>0?"warning":"success"} disabled={loading}>
               {dataCompania.com_recibo_name}
              </MDBBtn>}

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const CotizacionModal = ({formCotizacion, isOpen, toggle, onChange, error, error_upc, basicModalEdit, toggleSaveEncabezado, onChangeCot_detail, handleKeyPress,  formCotCotizacionDetalle, propsDropdown, onChangeDropdown,
  OBJCotizacionDetalle, deleteRow, update_cotd_cotizacion_detalle_row, setOBJCotizacionDetalle, fetch_cot_cotizacion, toggleSave, isSaveI, selectCliente, dataCliente, formClientes, onChangeCliente,
  setFormClientesBlank, onClickSaveCliente, selectItem, dataItems, isTabAddClientes, setTabAddClientes, setFormClientes, setError, usr_precio, setPrecio, formPrecio,
  handleOnChangeCheckBox, loading, dataGarantia, formCotCotizacion, setFormCotCotizacion, dataRetencion,dataCompania,onClickBuscarRuc,fetchCotdDetalle,dataItbms}) => {

  if (formClientes.cli_exento === "1") {
    OBJCotizacionDetalle = OBJCotizacionDetalle.map((data) => ({
      ...data,
      art_itbm_venta: "0.00",
      cotd_itbms:"0.00",
      cotd_total:new Decimal(data.cotd_total).minus(new Decimal(data.cotd_itbms))
    }));
  }

  const [anchorElRe, setAnchorElRe] = React.useState(null);
  const openRe = Boolean(anchorElRe);
  const handleClickRetencion = (event) => {
    event.preventDefault();
    setAnchorElRe(event.currentTarget);
  };
  const handleCloseRetencion = () => {
    setAnchorElRe(null);
  };

  const [anchorElGr, setAnchorElGr] = React.useState(null);
  const openGR = Boolean(anchorElGr);
  const handleClickGarantia = (event) => {
    event.preventDefault();
    setAnchorElGr(event.currentTarget);
  };
  const handleCloseGarantia = () => {
    setAnchorElGr(null);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const inputCantidad = useRef(null);
  const [isModalEditCliente, setBasicModalEditCliente] = useState(false);
  const [isTabClientes, setTabClientes] = useState(false);
  const [isTabClienteHidden, setTabClienteHidden] = useState(false);
  const [isTabImageView, setTabImgView] = useState(false);
  const [isTabItems, setTabItems] = useState(false);
  const [isOpenDetailItem, SetOpenDetailItem] = useState(false);
  const [formDetailItem, setFormDetailItem] = useState({
    art_categoria: "",
    art_descripcion: "",
    art_id: "",
    art_img: null,
    art_imgName: "",
    art_itbm_cod_v: "",
    art_itbm_venta: "",
    art_precio: "",
    art_precio2: "",
    art_precio3: "",
    art_referencia: "",
    art_restaurante: "",
    art_upc: "",
    cat_descripcion: "",
    itbm_descripcion: "",
    mar_descripcion: ""
  });
  const [formImg, setFormImg] = useState({
    imgUrl: "",
    img_name: "",
    art_upc: "",
    art_referencia: "",
    cotd_itbms: "",
    cotd_descuento: "",
    cotd_cantidad: ""
  });

  let existencia = 0;
  let enableTab = true;

  let subtotal = new Decimal(0);
  let itbms = new Decimal(0);
  let total = new Decimal(0);

  if (isOpenDetailItem && formDetailItem.bodegas !== undefined) {
    formDetailItem.bodegas.map((data) => {
      existencia = existencia + Number(data.inv_qty);
      return null;
    });
  }

  if (formCotizacion.cot_fecha.length > 0 && formClientes.cli_id.toString().length > 0) {
    enableTab = false;
  }

  async function select_detail_articulo({ row }) {
    const response = await get_articulo_detail(row.art_id);

    setFormDetailItem({
      art_categoria: row.art_categoria,
      art_descripcion: row.art_descripcion,
      art_id: row.art_id,
      art_img: row.art_img,
      art_imgName: row.art_imgName,
      art_itbm_cod_v: row.art_itbm_cod_v,
      art_itbm_venta: row.art_itbm_venta,
      art_precio: row.art_precio,
      art_precio2: row.art_precio2,
      art_precio3: row.art_precio3,
      art_referencia: row.art_referencia,
      art_restaurante: row.art_restaurante,
      art_servicio: row.art_servicio,
      art_catalogo: row.art_catalogo,
      art_upc: row.art_upc,
      cat_descripcion: row.cat_descripcion,
      itbm_descripcion: row.itbm_descripcion,
      mar_descripcion: row.mar_descripcion,
      bodegas: response
    });

    SetOpenDetailItem(true);
  }

  const viewImage = ({ row }) => {
    setFormImg({
      imgUrl: imgURLocalImage + row.art_imgName,
      img_name: row.cotd_art_descripcion,
      art_upc: row.art_upc,
      art_referencia: row.art_referencia,
      cotd_itbms: row.cotd_itbms,
      cotd_descuento: row.cotd_descuento,
      cotd_cantidad: row.cotd_cantidad
    });

    setTabImgView(true);
  };

  const handleSaveRow = ({ exitEditingMode, row, values }) => {
    let cotd_descuento_number = 0;
    var itbms_venta ="0.00"
    var code_itbms_venta ="00"

      const itbmsEncontrado = dataItbms.find((data) => data.itbm_cod_number === row.original.art_itbm_cod_v);
      itbms_venta = itbmsEncontrado?.itbm_porc || "0.00";
      code_itbms_venta = itbmsEncontrado?.art_itbm_cod_v || "00";

    if (row.original.cotd_descuento_number === "") {
      cotd_descuento_number = values.cotd_descuento;
    }

    const subtotalRow = new Decimal(values.cotd_cantidad).times(
      new Decimal(values.cotd_precio)
    );

    const descuentoPct = new Decimal(
      values.cotd_descuento_number === "" ? 0 : values.cotd_descuento_number
    ).div(100);

    const subdescuento = new Decimal(values.cotd_precio).times(descuentoPct);

    const descuento = new Decimal(values.cotd_cantidad).times(
      new Decimal(subdescuento)
    );

    const itbmsRow = subtotalRow.minus(descuento).times(
      new Decimal(itbms_venta)
    );
    if (basicModalEdit) {
      update_cotd_cotizacion_detalle_row({
        cotd_art_descripcion: values.art_descripcion,
        cotd_precio: values.cotd_precio,
        cotd_cantidad: values.cotd_cantidad,
        cotd_id: row.original.cotd_id,
        cotd_itbms: itbmsRow,
        cotd_descuento: descuento,
        cotd_descuento_number: values.cotd_descuento_number === "" ? 0 : values.cotd_descuento_number,
        cotd_total: subtotalRow.minus(new Decimal(descuento)).plus(new Decimal(itbmsRow))
      }, row.original.cotd_identificador);
    }

    OBJCotizacionDetalle[row.index] = {
      art_descripcion: values.art_descripcion,
      art_itbm_cod_v: code_itbms_venta,
      art_itbm_venta: itbms_venta,
      art_upc: row.original.art_upc,
      cotd_articulo: row.original.cotd_articulo,
      cotd_cantidad: values.cotd_cantidad,
      cotd_descuento: descuento,
      cotd_descuento_number: values.cotd_descuento_number === "" ? 0 : values.cotd_descuento_number,
      cotd_itbms: itbmsRow,
      cotd_precio: values.cotd_precio,
      cotd_total: subtotalRow.minus(new Decimal(descuento)).plus(new Decimal(itbmsRow))
    };

    setOBJCotizacionDetalle([...OBJCotizacionDetalle]);
    exitEditingMode();
  };

  OBJCotizacionDetalle.map((row) => {
    subtotal = new Decimal(row.cotd_total).minus(new Decimal(row.cotd_itbms)).plus(subtotal);
    itbms = new Decimal(row.cotd_itbms).plus(itbms);
    total = new Decimal(row.cotd_total).plus(total);
    return null;
  });
  subtotal = MONEY_ROUND(subtotal);
  total = MONEY_ROUND(total);
  itbms = MONEY_ROUND(itbms);
  return (
    <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
      <MDBModalDialog centered className="cot-dialog">
        <MDBModalContent className="gm-modal cot-modal">
          <MDBModalHeader className="gm-header cot-header">
            <div className="gm-header-title">
              <span className="gm-header-icon">
                <MDBIcon fas icon="file-invoice-dollar" />
              </span>
              <div>
                <h5 className="gm-title">
                  {formCotCotizacion.cot_id !== "" ? `Cotización #${formCotCotizacion.cot_id}`: "Nueva cotización"}
                </h5>
                <p className="gm-subtitle">Cliente, artículos y condiciones de la cotización</p>
              </div>
            </div>
            <button type="button" className="gm-close" title="Cerrar" onClick={() => {toggle(false);fetch_cot_cotizacion(); }}>
              <XIcon />
            </button>
          </MDBModalHeader>
          <MDBModalBody>
            {isTabClientes ? (
              <Row>
                <Col xs={12} className="cot-table datatable-factura cfg-card modal-add-inventario css_datatable1">
                  {dataCliente !== undefined ? (<DATATABLE_LISTA_CLIENTE dataCliente={dataCliente} dataRetencion={dataRetencion} selectCliente={selectCliente}  setTabClientes={setTabClientes}/>) : (<Label>Cargando...</Label>)}
                </Col>
              </Row>
            ) : isTabAddClientes ? (
              <div  className={`cot-section ${isTabClienteHidden ? "cot-section-active" : "" }`}>
              <FORM_CLIENTE  
                  error={error}
                  loading={loading}
                  isEdit={null}
                  handleClose ={setTabAddClientes}
                  props={formClientes}
                  onChange={onChangeCliente}
                  onClickBuscarRuc={onClickBuscarRuc}
                  openRe={openRe}
                  anchorElRe={anchorElRe}
                  handleClickRetencion={handleClickRetencion}
                  handleCloseRetencion={handleCloseRetencion}
                  dataRetencion={dataRetencion}
                  setFormClientes={setFormClientes}
                  dataCompania={dataCompania}
                  />
              </div>
            ) : isTabItems ? (
              isOpenDetailItem ? (
                <>
                  {ITEM_DETAIL_PANEL({
                    SetOpenDetailItem,
                    formDetailItem,
                    existencia
                  })}
                </>
              ) : (
                <Row>
                  <Col xs={12} className="cot-table datatable-factura cfg-card modal-add-inventario css_datatable1">
                    {dataItems !== undefined ? (
                      <DATATABLE_LISTA_ITEMS
                        select_detail_articulo={select_detail_articulo}
                        dataItems={dataItems}
                        selectItem={selectItem}
                        setTabItems={setTabItems}
                      />
                    ) : (
                      <Label>Cargando...</Label>
                    )}
                  </Col>
                </Row>
              )

            ) : isTabImageView ? (
                <DetalleArticuloCotizacion formImg={formImg} />
            ) : (

              <>
                {/* DATOS COTIZACIÓN */}
               {isTabClienteHidden?<div
                  className="cot-section cot-cliente-select"
                  onClick={() => setTabClienteHidden(!isTabClienteHidden)}
                >
                  <Row className="g-2 align-items-center">

                    <Col xs={8} md={9}>
                      <div className="cot-cliente-info">

                        <div className="cot-cliente-icon">
                          <MDBIcon fas icon="user" />
                        </div>

                        <div className="cot-cliente-text">
                          <span className="cot-cliente-label">Cliente</span>

                          <strong className="cot-cliente-name">
                            {formClientes?.cli_nombre || "Sin cliente seleccionado"}
                          </strong>

                          {formClientes?.cli_ruc && (
                            <span className="cot-cliente-ruc">
                              RUC: {formClientes.cli_ruc}
                            </span>
                          )}
                        </div>

                      </div>
                    </Col>


                    <Col xs={4} md={3}>
                      <div className="cot-cliente-action">
                        <span>
                          {isTabClienteHidden ? "Cambiar" : "Ocultar"}
                        </span>

                        <IconButton
                          className="cot-cliente-expand"
                          onClick={(e) => {
                            e.stopPropagation();
                            setTabClienteHidden(!isTabClienteHidden);
                          }}
                        >
                          <AmpliarDiv />
                        </IconButton>
                      </div>
                    </Col>

                  </Row>
                </div> :                <div className="cot-section">
                  <Row className="g-1 align-items-end">

                    {/* CLIENTE */}
                    <Col xs={12} md={5} lg={3}>
                      <label className="gm-field">
                        <div className="cot-cliente-header">
                          <span className="gm-label">Cliente</span>

                          <div className="cot-cliente-action">
                            <span>
                              {isTabClienteHidden ? "Cambiar" : "Ocultar"}
                            </span>

                            <IconButton
                              className="cot-cliente-expand"
                              onClick={(e) => {
                                e.stopPropagation();
                                setTabClienteHidden(!isTabClienteHidden);
                              }}
                            >
                              <AmpliarDiv />
                            </IconButton>
                          </div>
                        </div>
                        <div className="cot-input-actions">
                          <input
                            type="text"
                            className="gm-input"
                            value={
                              formClientes.cli_nombre.length > 0
                                ? formClientes.cli_nombre + " " + formClientes.cli_ruc
                                : "Cliente"
                            }
                            disabled
                            readOnly
                          />

                          <button
                            type="button"
                            className="cot-icon-btn"
                            title="Buscar cliente"
                            onClick={() => setTabClientes(true)}
                          >
                            <SearchIcon />
                          </button>

                          <button type="button" className="cot-icon-btn cot-icon-add" title="Nuevo cliente" onClick={() => {
                            setTabAddClientes(true);
                            setBasicModalEditCliente(false);
                            setFormClientes(STATES_COT_COTIZACION({ staneName: "formClientes" }));
                          }}>
                            <PlusIcon />
                          </button>

                          {formClientes.cli_nombre.length > 0 && formClientes.cli_nombre !== "CONSUMIDOR FINAL" && (
                            <button type="button" className="cot-icon-btn" title="Editar cliente" onClick={() => {
                              setTabAddClientes(true);
                              setBasicModalEditCliente(true);
                            }}>
                              <EditIcon />
                            </button>
                          )}
                        </div>
                      </label>
                    </Col>

                    {/* FECHA */}
                    <Col xs={6} md={3} lg={2}>
                      <label className="gm-field">
                        <span className="gm-label">Fecha</span>
                        <input
                          id="dc_fecha"
                          type="date"
                          name="cot_fecha"
                          className="gm-input"
                          value={formCotizacion.cot_fecha}
                          onChange={onChange}
                        />
                      </label>
                    </Col>

                    {/* GARANTÍA */}
                    <Col xs={6} md={4} lg={1}>
                      <span className="gm-label">Garantía</span>

                      {dataGarantia.length > 1 && (
                        <>
                          <button
                            type="button"
                            id="cot-garantia-button"
                            className="cot-option-btn"
                            aria-controls={openGR ? "cot-garantia-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={openGR ? "true" : undefined}
                            onClick={handleClickGarantia}
                          >
                            <AwardIcon />
                            <span>Buscar</span>
                          </button>

                          <Menu
                            id="cot-garantia-menu"
                            anchorEl={anchorElGr}
                            open={openGR}
                            onClose={handleCloseGarantia}
                            MenuListProps={{ "aria-labelledby": "cot-garantia-button" }}
                          >
                            {dataGarantia.map((data, i) => (
                              <MenuItem key={i} onClick={() => {
                                setFormCotCotizacion({
                                  ...formCotCotizacion,
                                  cot_garantia: formCotCotizacion.cot_garantia + "\n" + data.gr_descripcion,
                                  cot_garantia_name: formCotCotizacion.cot_garantia_name + "\n" + data.gr_name
                                });

                                handleCloseGarantia();
                              }}>
                                {data.gr_name}
                              </MenuItem>
                            ))}
                          </Menu>
                        </>
                      )}
                    </Col>

                    {/* GARANTÍA SELECCIONADA */}
                    <Col xs={12} md={6} lg={3}>
                      {formCotCotizacion.cot_garantia_name.length > 0 && (
                        <div className="cot-selected-option">
                          <div>
                            <span>Garantía seleccionada</span>
                            <strong>{formCotCotizacion.cot_garantia_name}</strong>
                          </div>

                          <button type="button" title="Quitar garantía" onClick={() => {
                            setFormCotCotizacion({
                              ...formCotCotizacion,
                              cot_garantia: "",
                              cot_garantia_name: ""
                            });
                          }}>
                            <XIcon />
                          </button>
                        </div>
                      )}
                    </Col>

                    {/* DESCRIPCIÓN */}
                    <Col xs={8} md={4} lg={2}>
                      <label className="gm-field">
                        <span className="gm-label">Descripción</span>
                        <textarea
                          id="cot_descripcion"
                          name="cot_descripcion"
                          rows={2}
                          className="gm-input cot-description"
                          value={formCotizacion.cot_descripcion || ""}
                          onChange={onChange}
                        />
                      </label>
                    </Col>
                    <Col xs={4} md={2} lg={1}>
                      <label className="gm-field">
                        <span className="gm-label">Validez en Días</span>
                        <input
                          id="cot_validez"
                          name="cot_validez"
                          rows={2}
                          className="gm-input cot-description"
                          value={formCotizacion.cot_validez || ""}
                          onChange={onChange}
                        />
                      </label>
                    </Col>
                  </Row>
                </div>}

                {/* AGREGAR ARTÍCULO */}
                <div className="cot-section cot-products-section">
                  <div className="cot-section-header">
                    <div className="cot-section-title">
                      <MDBIcon fas icon="boxes" />
                      <div>
                        <strong>Agregar artículo</strong>
                        <span>Busca el producto y agrega precio y cantidad</span>
                      </div>
                    </div>
                  </div>

                  {error_upc && (
                    <div className="cot-warning">
                      <MDBIcon fas icon="exclamation-circle" />
                      <span>{error_upc}</span>
                    </div>
                  )}

                  <Row className="g-2 align-items-end">

                    {/* CÓDIGO */}
                    <Col xs={8} sm={4} lg={2}>
                      <label className="gm-field">
                        <span className="gm-label">Código o referencia</span>

                        <div className="cot-input-actions">
                          <input
                            id="art_upc"
                            name="art_upc"
                            className="gm-input"
                            value={formCotCotizacionDetalle.art_upc}
                            disabled={enableTab}
                            onChange={onChangeCot_detail}
                            onKeyDown={(e) => handleKeyPress(e, formCotCotizacionDetalle.art_upc)}
                          />

                          {formClientes.cli_nombre.length > 0 && (
                            <button type="button" className="cot-icon-btn" title="Buscar artículo" onClick={() => {
                              setTabItems(true);
                              SetOpenDetailItem(false);
                            }}>
                              <SearchIcon />
                            </button>
                          )}
                        </div>
                      </label>
                    </Col>

                    {/* REFERENCIA */}
                    <Col xs={4} sm={4} lg={2}>
                      <label className="gm-field">
                        <span className="gm-label">Referencia</span>
                        <input
                          id="art_referencia"
                          name="art_referencia"
                          className="gm-input"
                          value={formCotCotizacionDetalle.art_referencia}
                          disabled
                          onChange={onChangeCot_detail}
                        />
                      </label>
                    </Col>

                    {/* DESCRIPCIÓN */}
                    <Col xs={12} sm={8} lg={4}>
                      <label className="gm-field">
                        <span className="gm-label">Descripción del artículo</span>
                        <input
                          id="art_descripcion"
                          name="art_descripcion"
                          className="gm-input"
                          value={formCotCotizacionDetalle.art_descripcion}
                          onChange={onChangeCot_detail}
                          disabled={!(formCotCotizacionDetalle.art_upc.length > 0 && usr_precio === "1")}
                        />
                      </label>
                    </Col>

                    {/* PRECIO */}
                    <Col xs={6} sm={6} lg={2}>
                      <label className="gm-field">
                        <span className="gm-label">Precio</span>

                        <div className="cot-input-actions">
                          <input
                            id="cotd_precio"
                            name="cotd_precio"
                            type="number"
                            min="1"
                            className="gm-input"
                            value={formCotCotizacionDetalle.cotd_precio}
                            disabled={!(formCotCotizacionDetalle.art_upc.length > 0 && usr_precio === "1")}
                            onChange={onChangeCot_detail}
                          />

                          <button
                            type="button"
                            id="cot-precio-button"
                            className="cot-icon-btn"
                            title="Seleccionar precio"
                            aria-controls={open ? "cot-precio-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                            disabled={formCotCotizacionDetalle.art_upc.length === 0}
                            onClick={handleClick}
                          >
                            <PriceIcon />
                          </button>

                          <Menu
                            id="cot-precio-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{ "aria-labelledby": "cot-precio-button" }}
                          >
                            <MenuItem onClick={() => {
                              setPrecio(formPrecio.art_precio);
                              setAnchorEl(null);
                            }}>
                              {formPrecio.art_precio}
                            </MenuItem>

                            <MenuItem onClick={() => {
                              setPrecio(formPrecio.art_precio2);
                              setAnchorEl(null);
                            }}>
                              {formPrecio.art_precio2}
                            </MenuItem>

                            <MenuItem onClick={() => {
                              setPrecio(formPrecio.art_precio3);
                              setAnchorEl(null);
                            }}>
                              {formPrecio.art_precio3}
                            </MenuItem>
                          </Menu>
                        </div>
                      </label>
                    </Col>
                    <Col xs={6} sm={6} lg={2}>
                      <label className="gm-field">
                        <span className="gm-label">Cantidad</span>

                        <div className="cot-input-actions">
                          <input
                            id="cotd_cantidad"
                            name="cotd_cantidad"
                            type="number"
                            min="1"
                            className="gm-input"
                            ref={inputCantidad}
                            value={formCotCotizacionDetalle.cotd_cantidad}
                            disabled={formCotCotizacionDetalle.art_upc.length === 0}
                            onChange={onChangeCot_detail}
                            onKeyDown={(e) => handleKeyPress(e, formCotCotizacionDetalle.cotd_cantidad)}
                          />

                          <button
                            type="button"
                            className="cot-icon-btn cot-icon-add"
                            title="Agregar artículo"
                            disabled={formCotCotizacionDetalle.cotd_cantidad === ""}
                            onClick={(e) => handleKeyPress(e, formCotCotizacionDetalle.cotd_cantidad)}
                          >
                            <PlusIcon />
                          </button>
                        </div>
                      </label>
                    </Col>
                  </Row>
                </div>
                <Row>
                  <Col xs={12}>
                    <div className="cot-table datatable-factura cfg-card modal-add-inventario css_datatable1">
                      <DATATABLE_COTIZACION_DETALLE
                        enableTab={enableTab}
                        selectItem={selectItem}
                        deleteRow={deleteRow}
                        OBJCotizacionDetalle={OBJCotizacionDetalle}
                        handleSaveRow={handleSaveRow}
                        usr_precio={usr_precio}
                        viewImage={viewImage}
                        formClientes={formClientes}
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col xs={12}>
                    <FOOTER_FACTURA_COTIZACION
                      enableTab={enableTab}
                      subtotal={subtotal}
                      itbms={itbms}
                      total={total}
                    />
                  </Col>
                </Row>
              </>
            )}
          </MDBModalBody>
          <MDBModalFooter className="gm-footer cot-footer">
            {isTabAddClientes && (
              <>
                <button type="button" className="gm-btn gm-btn-cancel" onClick={() => {setTabAddClientes(false);setBasicModalEditCliente(false);setFormClientesBlank();setError("");}}>
                  <BackIcon />
                  Cancelar
                </button>
                <button type="button" className="gm-btn gm-btn-save" onClick={() => {
                  onClickSaveCliente({isEditing: isModalEditCliente,cli_id: formClientes.cli_id});
                }}>
                  <SaveIcon />
                  {isModalEditCliente ? "Actualizar cliente" : "Guardar cliente"}
                </button>
              </>
            )}
            {isTabImageView && (<button type="button" className="gm-btn gm-btn-cancel" onClick={() => setTabImgView(false)}>
                <BackIcon />
                Regresar
              </button>
            )}

            {isTabItems && (<button type="button" className="gm-btn gm-btn-cancel" onClick={() => setTabItems(false)}>
                <BackIcon />
                Regresar
              </button>)}

            {isTabClientes && (
                <button type="button" className="gm-btn gm-btn-cancel" onClick={() => setTabClientes(false)}>
                  <BackIcon />
                  Regresar
                </button>
              )}

            {!isTabClientes && !isTabItems && !isTabImageView && !isTabAddClientes && (
              <>
                <button type="button" className="gm-btn gm-btn-cancel" onClick={() => {toggle(false);fetch_cot_cotizacion(); }}>
                  <XIcon />
                  Cerrar
                </button>
                {basicModalEdit ? (
                  <button type="button" className="gm-btn gm-btn-save" disabled={loading} onClick={() => {toggleSaveEncabezado();toggle(false);}}>
                    <SaveIcon />
                    {loading ? "Guardando…" : "Guardar"}
                  </button>
                ) : (
                  <button type="button"className="gm-btn gm-btn-save"disabled={!(OBJCotizacionDetalle[0] !== undefined && loading === false)}onClick={() => toggleSave()}
                  >
                    <SaveIcon />
                    {loading ? "Guardando…" : "Guardar"}
                  </button>
                )}
              </>
            )}
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
};
const EnviadoCocinaModal = ({ isOpen, toggle }) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog centered>
          <MDBModalContent className="rt-modal">
            <MDBModalBody className="rt-modal-body">
              {/* Check animado (sin depender de la imagen) */}
              <div className="rt-modal-check" aria-hidden="true">
                <svg viewBox="0 0 52 52" width="44" height="44" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                  <path className="rt-modal-check-path" d="M14 27l8 8 16-18" />
                </svg>
              </div>

              <h5 className="rt-modal-title">Orden enviada a la cocina</h5>
              <p className="rt-modal-sub">La orden se registró correctamente.</p>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  )
}
const EnviadoModal = ({
  isOpen,
  toggle,
  dataListpago,
  total, 
  itbms
}) => {
  var monto =0;
  dataListpago.map((data,i)=>{
    monto = monto + Number(data.list_monto)
    return null
  });

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Factura creada</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody className="text-center">
            <img src={SUCCES_IMAGE} className="src-image-enviado" alt="..."/>
            <Row className="mt-3">
               <Col xs={3}>
              </Col>
                  <Col xs={6}>
                    <MDBInput
                      className="input-iventario-totales2"
                      id="subtotal"
                      wrapperClass="mb-4"
                      label="SUBTOTAL"
                      name="subtotal"
                      autoFocus={true}
                      value={(new Decimal(total).minus(new Decimal(itbms))).toFixed(2)}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={3}>
                  </Col>
              <Col xs={3}>
              </Col>
              <Col xs={6}>
                <MDBInput
                  className="input-iventario-totales2"
                  id="itbms"
                  wrapperClass="mb-4"
                  label="ITBMS"
                  name="itbms"
                  autoFocus={true}
                  value={Number(itbms).toFixed(2)}
                  disabled={true}
                />
              </Col>
              <Col xs={3}>
              </Col>
              <Col xs={3}>
                  </Col>
              <Col xs={6} className="mt-3">
                <MDBInput
                  className="input-iventario-totales2"
                  id="total"
                  wrapperClass="mb-4"
                  label="TOTAL"
                  name="total"
                  autoFocus={true}
                  value={new Decimal(total).toFixed(2)}
                  disabled={true}
                />
              </Col>
              <Col xs={3}>
              </Col>
            
                  <Col xs={3}>
                  </Col>
                  <Col xs={6}>
                    <MDBInput
                      className="input-iventario-totales2"
                      id="vuelto"
                      wrapperClass="mb-4"
                      label="VUELTO"
                      name="vuelto"
                      autoFocus={true}
                      value={(monto- total).toFixed(2)}
                      disabled={true}
                    />
              </Col>
              <Col xs={3}>

              </Col>
            </Row>
            </MDBModalBody>
    
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const ImageTooltipModalPublicidad = ({
  isOpen,
  toggle,
  srcImage
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1"   onClose={toggle}>
        <MDBModalDialog onClose={toggle} >
          <MDBModalContent>
            <MDBModalHeader>
                <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody className="text-center">
              <img src={srcImage} className="src-image-articulo-tooltip" alt="..."/>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ModalSeries = ({
  props,
  formArticulos,
  isOpen,
  toggle,
}) => {

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1"   onClose={toggle}>
        <MDBModalDialog onClose={toggle}     size={window.innerWidth <= 611 ? "fullscreen" : "xl"} className="modal-fiscal" > 
          <MDBModalContent>
            <MDBModalHeader>
              <Row>
                <Col xs={12}>
                <MDBModalTitle className="font-weight-bold">{formArticulos.data.art_descripcion}</MDBModalTitle>
                  <MDBModalTitle className="font-weight-bold">{"Codigo: " +formArticulos.data.art_upc + "("+formArticulos.data.art_referencia+")"}</MDBModalTitle>
                </Col>
              </Row>
            </MDBModalHeader>
            <MDBModalBody className="modal-add-inventario datatable-factura css_datatable1" >
            <DATATABLE_SERIES dataSeries={props}/>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ImageTooltipModal = ({
  props,
  isOpen,
  toggle,
  srcImage,
  ImgName
}) => {

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1"   onClose={toggle}>
        <MDBModalDialog onClose={toggle} >
          <MDBModalContent>
            <MDBModalHeader>
              <Row>
                <Col xs={12}>
                  <Label>{props.art_descripcion + " (" +ImgName+")"}</Label>
                </Col>
                <Col xs={12}>
                  <MDBModalTitle className="font-weight-bold">{"PRECIO $"+MONEY_ROUND(new Decimal(props.art_precio).times(new Decimal(props.art_itbm_venta).plus(new Decimal(1))))}</MDBModalTitle>
                </Col>
                <Col xs={12}>
                  <MDBModalTitle className="font-weight-bold">{"EXISTENCIA " +props.inv_qty}</MDBModalTitle>
                </Col>
              </Row>
            </MDBModalHeader>
            <MDBModalBody className="text-center">
              <img src={srcImage} className="src-image-articulo-tooltip" alt="..."/>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const OPENCASHDRAWERModal = ({formRestaurante,isOpen,toggle,onChange,openCash,code}) => {
  var codigo= false;
  if(formRestaurante.code_cash===code){
    codigo = true;
     openCash()
  }
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1"   onClose={toggle}>
        <MDBModalDialog onClose={toggle}     size={window.innerWidth <= 611 ? "sm" : "sm"} className="modal-fiscal" > 
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>ABRIR CAJA DE DINERO</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody>
              <Row>
                <Col>
                   <MDBInput
                    className="input-iventario-totales"
                    id="code_cash"
                    wrapperClass="mb-4"
                    type={"password"}
                    label="CÓDIGO DE SEGURIDAD"
                    name="code_cash"
                    onChange={onChange}
                    autoFocus={true}
                    value={formRestaurante.code_cash}
                    />
                </Col>
              </Row>
            </MDBModalBody>
            {/* <MDBModalFooter>
              <MDBBtn onClick={() =>  openCash()} disabled={codigo?false:true}>
                 ABRIR
              </MDBBtn>               
            </MDBModalFooter> */}
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const NUMEROModal = ({formRestaurante,isOpen,toggle,onChange,print_prefactura}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"sm"}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>NÚMERO DE ORDEN</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody>
              <Row>
                <Col>
                   <MDBInput
                    className="input-iventario-totales"
                    id="ord_number"
                    wrapperClass="mb-4"
                    label="# ORDEN"
                    name="ord_number"
                    onChange={onChange}
                    autoFocus={true}
                    value={formRestaurante.ord_number}
                    />
                </Col>
              </Row>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn onClick={() =>  print_prefactura({tipo:"0",pdf:false,prefactura:true})}>
                 IMPRIMIR
              </MDBBtn>
                <MDBBtn  onClick={() => toggle(false)} color="danger">
                    Cerrar
                </MDBBtn>
                
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const RucModal = ({formRuc,isOpen,toggle,onChange,setFormRuc,onClickBuscarRuc,errorRuc,dataRuc}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":""}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Consultar RUC</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
              <Row>
                <React.Fragment>
                  {window.innerWidth<=611?<>
                  <Col xs={5} className="input-tablet">
                  <MDBInput
                  className="input-buscar-ruc"
                  id="ruc"
                  wrapperClass="mb-3"
                  label="RUC"
                  name="ruc"
                   onChange={onChange}
                  value={formRuc.ruc}
                  />
                  </Col>
                <Col xs={3} className="input-tablet">
                  <MDBInput
                  className="input-buscar-ruc"
                  id="dv"
                  wrapperClass="mb-3"
                  label="DV"
                  name="dv"
                  onChange={onChange}
                  value={formRuc.dv}
                  />
                  </Col>
                  <Col xs={4} className="input-tablet">
                  <MDBBtn onClick={() =>  onClickBuscarRuc({ruc:formRuc.ruc,is_modal_ruc:true})} disabled={formRuc.ruc.length>0?false:true}>
                    Buscar
                </MDBBtn>
                  </Col>
                  {dataRuc.codigo.length>0?<><Col xs={3} className="input-tablet">
                  <MDBInput
                  id="codigo"
                  wrapperClass="mb-3"
                  label="Código"
                  name="codigo"
                  value={dataRuc.codigo}
                  />
                  </Col>
                  <Col xs={9} className="input-tablet">
                  <MDBInput
                  id="afiliadoFE"
                  wrapperClass="mb-3"
                  label="Afiliado FE"
                  name="afiliadoFE"
                  value={dataRuc.afiliadoFE}
                  />
                  </Col>
                  <Col xs={12} className="input-tablet">
                  <MDBInput
                 
                  id="razonSocial"
                  wrapperClass="mb-3"
                  label="Razón social"
                  name="razonSocial"
                  value={dataRuc.razonSocial}
                  />
                  </Col>
                  <Col xs={9} className="input-tablet">
                  <MDBInput
                 
                  id="ruc"
                  wrapperClass="mb-3"
                  label="RUC"
                  name="tuc"
                  value={dataRuc.ruc}
                  />
                  </Col>
                  <Col xs={3} className="input-tablet">
                  <MDBInput
                 
                  id="dv"
                  wrapperClass="mb-3"
                  label="DV"
                  name="dv"
                  value={dataRuc.dv}
                  />
                  </Col>
                  <Col xs={12} className="input-tablet">
                  <MDBInput
                
                  id="mensaje"
                  wrapperClass="mb-3"
                  label="Mensaje"
                  name="mensaje"
                  value={dataRuc.mensaje}
                  />
                  </Col>
                                    <Col xs={12} className="input-tablet">
                  <MDBInput
                
                  id="tipoRuc"
                  wrapperClass="mb-3"
                  label="Tipo ruc"
                  name="tipoRuc"
                  value={dataRuc.tipoRuc==="1"?"Natural":dataRuc.tipoRuc===""?"":"Jurídico"}
                  />
                  </Col></>:<></>}
                  
                  </>:<>
                  
                                  <Col xs={4} >
                  <MDBInput
                  className="input-buscar-ruc"
                  id="ruc"
                  wrapperClass="mb-3"
                  label="RUC"
                  name="ruc"
                   onChange={onChange}
                  value={formRuc.ruc}
                  />
                  </Col>
                <Col xs={1}>
                  <MDBInput
                  className="input-buscar-ruc"
                  id="dv"
                  wrapperClass="mb-3"
                  label="DV"
                  name="dv"
                  onChange={onChange}
                  value={formRuc.dv}
                  />
                  </Col>
                  <Col xs={7}>
                  <MDBBtn onClick={() =>  onClickBuscarRuc({ruc:formRuc.ruc,is_modal_ruc:true})} disabled={formRuc.ruc.length>0?false:true}>
                    Buscar
                </MDBBtn>
                  </Col>
                  {dataRuc.codigo.length>0?<><Col xs={1}>
                  <MDBInput
                  id="codigo"
                  wrapperClass="mb-4"
                  label="Código"
                  name="codigo"
                  value={dataRuc.codigo}
                  />
                  </Col>
                  <Col xs={3}>
                  <MDBInput
                  id="afiliadoFE"
                  wrapperClass="mb-4"
                  label="Afiliado FE"
                  name="afiliadoFE"
                  value={dataRuc.afiliadoFE}
                  />
                  </Col>
                  <Col xs={4}>
                  <MDBInput
                 
                  id="razonSocial"
                  wrapperClass="mb-4"
                  label="Razón social"
                  name="razonSocial"
                  value={dataRuc.razonSocial}
                  />
                  </Col>
                  <Col xs={3}>
                  <MDBInput
                 
                  id="ruc"
                  wrapperClass="mb-4"
                  label="RUC"
                  name="tuc"
                  value={dataRuc.ruc}
                  />
                  </Col>
                  <Col xs={1}>
                  <MDBInput
                 
                  id="dv"
                  wrapperClass="mb-4"
                  label="DV"
                  name="dv"
                  value={dataRuc.dv}
                  />
                  </Col>
                  <Col xs={9}>
                  <MDBInput
                
                  id="mensaje"
                  wrapperClass="mb-4"
                  label="Mensaje"
                  name="mensaje"
                  value={dataRuc.mensaje}
                  />
                  </Col>
                                    <Col xs={3}>
                  <MDBInput
                
                  id="tipoRuc"
                  wrapperClass="mb-4"
                  label="Tipo ruc"
                  name="tipoRuc"
                  value={dataRuc.tipoRuc==="1"?"Natural":dataRuc.tipoRuc===""?"":"Jurídico"}
                  />
                  </Col></>:<></>}
                    
                  
                  </>}

                  
                </React.Fragment>
            </Row>
            </MDBModalBody>
            <MDBModalFooter>
                  <Label className="error-label">{errorRuc.length > 0 ? errorRuc : ""}</Label>

                <MDBBtn  onClick={() => toggle(false)} color="danger">
                    Cerrar
                </MDBBtn>
                
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const AnulacionModal = ({
  dataListAnulacion,
  isOpen,
  toggle,
  formAnulacion,
  onChange,
  setFormAnulacion,
  toggleSave,
  usr_print,
  errorAnulacion,
  nota_credito
}) => {
  const [istabAnular, setTabAnular] = useState(true);
  const [istabNC, setTabAnularNC] = useState(false);
  const [dataCopiaFactura, setDataCopiaFactura] = useState([]);
  const [fac_selected, setfacSelected] = useState("");

  async function getDetailItem({data}) {
    setfacSelected(data.fac_id)
    var response = await get_list_itemsFactura_detail(data.fac_identificador);
    setDataCopiaFactura({
      factura:response.factura,
      fPago:response.fPago
    });
  }

  var flag_qty_caracteres = false;
  if(formAnulacion.motivo_anulacion.length>=10){
    flag_qty_caracteres = true;
  }
  const deleteRow = (row) => {
    if(dataCopiaFactura.factura.length>1){
      var value = dataCopiaFactura.factura.filter((data, i) => {
        if (i !== row.index) return data;
      });
      setDataCopiaFactura(value);
          setDataCopiaFactura({...dataCopiaFactura,
        factura:value
      });
    }
  };
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className="modal-fiscal">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Anular factura</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody>
              <Row>
                {istabAnular? <Col xs={12} className="datatable-factura  css_datatable1">
                <DATATABLE_COLUMNS_LISTA_ANULACION dataListAnulacion ={dataListAnulacion} setTabAnular={setTabAnular} setTabAnularNC={setTabAnularNC} setFormAnulacion ={setFormAnulacion} getDetailItem={getDetailItem}/>
                </Col>:
                istabNC?<>
                  {dataCopiaFactura.factura !==undefined ? PANEL_VIEW_INVOICE({fac_selected,dataCopiaFactura,nc_flag:true,deleteRow}):<Col xs={12} className="text-center"><Label>No hay registros que mostrar</Label></Col>}
                
                </>:
                <React.Fragment>
                  <Col xs={12} sm={4}>
                    <MDBInput
                    className="input-iventario-totales"
                    id="docNumber"
                    wrapperClass="mb-4"
                    label="# de factura"
                    name="docNumber"
                    autoFocus={true}
                    value={formAnulacion.fac_id.toString().padStart(10, "0")}/>
                  </Col>
                  <Col xs={12} sm={8}>
                    <MDBTextArea 
                      className="input-iventario-totales"
                      id="motivo_anulacion"
                      wrapperClass="mb-4"
                      // minlength ={40}
                      label="* Descripción de la anulación"
                      name="motivo_anulacion"
                      autoFocus={true}
                      onChange={onChange}
                      value={formAnulacion.motivo_anulacion}
                      rows={2}/>
                  </Col>
                </React.Fragment>
                }
              </Row>
            </MDBModalBody>
            <MDBModalFooter>
                <MDBBtn  onClick={() => !istabAnular?setTabAnular(true):toggle(false)} color="danger">
                    Cerrar
                </MDBBtn>
              {(!istabAnular && !istabNC)&&<><Label className="error-label">{errorAnulacion.length > 0 ? errorAnulacion : ""}</Label>
              {((usr_print ==="1"||usr_print ==="4") && formAnulacion.fac_recibo==="1")&&<MDBBtn onClick={() =>  toggleSave({tipo:formAnulacion.fac_recibo,print_mode:"1"})} disabled={flag_qty_caracteres>0?false:true}>
                  Anular PDF
              </MDBBtn>}
              {(usr_print ==="2"||usr_print ==="4" || formAnulacion.fac_recibo==="0")&&<MDBBtn onClick={() =>  toggleSave({tipo:formAnulacion.fac_recibo,print_mode:"2"})} disabled={flag_qty_caracteres>0?false:true}>
                  Anular Recibo
              </MDBBtn>}</>}
              {istabNC&&<><Label className="error-label">{errorAnulacion.length > 0 ? errorAnulacion : ""}</Label>
              {((usr_print ==="1"||usr_print ==="4") && formAnulacion.fac_recibo==="1")&&<MDBBtn onClick={() =>  nota_credito({tipo:"1",items:dataCopiaFactura,print_mode:"1"})} disabled={dataCopiaFactura.factura !== undefined?false:true}>
                  NC PDF
              </MDBBtn>}
              {(usr_print ==="2"||usr_print ==="4" || formAnulacion.fac_recibo==="0")&&<MDBBtn onClick={() =>  nota_credito({tipo:"1",items:dataCopiaFactura,print_mode:"2"})} disabled={dataCopiaFactura.factura !== undefined?false:true}>
                  NC Recibo
              </MDBBtn>}</>}
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const DateRangeModal = ({
  isOpen,
  toggle,
  show_year_month,
  open,
  handleOnChangeDate,
  state
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog >
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Calendario</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => {toggle(false);}}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
            <Row>
              <Col xs={12} className={"text-center"} >
              {show_year_month?<><Calendar 
                    onChange={handleOnChangeDate}
                    showSelectionPreview={false}
                    moveRangeOnFirstSelection={false}
                    editableDateInputs={true}
                    dateDisplayFormat="yyyy-MM-dd-"
                    ranges={state}
                    direction="horizontal"
                    className="box-calendar"
                  /></>:<>                {open && (
                  <DateRange 
                    onChange={handleOnChangeDate}
                    showSelectionPreview={false}
                    moveRangeOnFirstSelection={false}
                    editableDateInputs={true}
                    dateDisplayFormat="yyyy-MM-dd-"
                    ranges={state}
                    direction="horizontal"
                    className="box-calendar"
                  />
                )}</>}

              </Col>
            </Row>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

export {
  MesasModal,
  NUMEROModal,
  ListaCajas,
  PublicidadModal,
  DescuentoModal,
  GarantiaModal,
  EnviadoCocinaModal,
  DateRangeModal,
  EnviadoModal,
  PagarModal,
  DeleteModal,
  UsuariosModal,
  BodegaModal,
  ClienteModal,
  ProveedorModal,
  CategoriaModal,
  MarcaModal,
  ArticuloModal,
  FacturaCompraModal,
  ListaClienteModal,
  ListaItemModal,
  ListaFacModal,
  CotizacionModal,
  AnulacionModal,
  ApartadoModal,
  RecuentoModal,
  MovimientoModal,
  ListaCotizacion,
  ListaOrden,
  ImageTooltipModal,
  ListaCreditos,
  ImageTooltipModalPublicidad,
  WarningModal,
  RucModal,
  GastosModal,
  ModalReporteZ,
  ModalSeries,
  OPENCASHDRAWERModal
};
